{
  "a11y": {
    "activeBatches": "Aktif toplu işlemler, {{count}} bekliyor",
    "activeBatchesButton": "Aktif toplu işlemler",
    "addToFavorites": "Favorilere ekle",
    "addTag": "Etiket ekle",
    "audioPlayer": "Ses oynatıcı",
    "backupCode": "Yedek kod",
    "cancelAllDownloads": "Tüm indirmeleri iptal et",
    "clearAllNotifications": "Tüm bildirimleri temizle",
    "clearSelection": "Seçimi temizle",
    "clearUploadQueue": "Yükleme kuyruğunu temizle",
    "copyLink": "Bağlantıyı kopyala",
    "closePanel": "Paneli kapat",
    "composerFab": "Yeni e-posta oluştur",
    "detailsPanel": "Ayrıntılar paneli",
    "emailSending": "E-posta gönderiliyor",
    "emptyFilesTable": "Gösterilecek dosya yok",
    "editFileTags": "Dosya etiketlerini düzenle",
    "fileTagsCount": "Etiketler, {{count}}",
    "enterFilePasswordForm": "Dosya parolasını girin",
    "expandUploadProgress": "Yükleme ilerlemesini genişlet",
    "fileTypesFilter": "Dosya türüne göre filtrele",
    "onlyExpiredFilter": "Süresi dolmuş paylaşımları filtrele",
    "expiringWithinDaysFilter": "Belirli gün içinde süresi dolacak paylaşımları filtrele",
    "filters": "Filtreler",
    "fullscreen": "Tam ekran",
    "fileMoveForm": "Dosyaları taşı",
    "filePublicLinkForm": "Genel bağlantı ayarları",
    "filesTable": "Dosya listesi",
    "globalSearch": "Dosya ara",
    "goBack": "Geri",
    "groupForm": "Grup formu",
    "loading": "Yükleniyor, lütfen bekleyin",
    "minimizeUploadProgress": "Yükleme ilerlemesini küçült",
    "mute": "Sesi kapat",
    "mainNavigation": "Ana gezinme",
    "markAllRead": "Tüm bildirimleri okundu işaretle",
    "notificationsButton": "Bildirimler",
    "notificationsCount": "Bildirimler, {{count}} okunmamış",
    "notificationsList": "Bildirim listesi",
    "openEmailsSection": "E-postalar bölümünü aç",
    "openFileMenu": "Dosya işlemleri menüsünü aç",
    "openFolder": "{{name}} klasörünü aç",
    "openList": "{{name}} öğesini aç",
    "openMoreActions": "Diğer işlemleri aç",
    "openFilesSection": "Dosyalar bölümünü aç",
    "otpCode": "Tek kullanımlık parola kodu",
    "pendingGrants": "Bekleyen erişim istekleri, {{count}}",
    "pendingGrantsButton": "Bekleyen erişim istekleri",
    "playbackProgress": "Oynatma ilerlemesi, {{current}} / {{duration}}",
    "playPause": "Oynat veya duraklat",
    "quickShare": "Hızlı paylaşım yüklemesi, yüzde {{percent}}",
    "removeFromFavorites": "Favorilerden kaldır",
    "removeException": "İstisnayı kaldır",
    "removeSharedFile": "Paylaşılan dosyayı kaldır",
    "searchExactMatch": "Tam eşleşme araması",
    "searchWholeWord": "Tam kelime araması",
    "sectionSelector": "Bölüm seçici",
    "selectCountry": "{{country}} seç",
    "settingsSearch": "Ayarlarda ara",
    "skipToMain": "Ana içeriğe atla",
    "tagActions": "{{name}} etiketi için işlemler",
    "tagNotSelected": "seçili değil",
    "tagSelected": "seçili",
    "tagToggle": "{{name}}, {{state}}",
    "textEditor": "Metin dosyası düzenleyici",
    "totpCode": "Kimlik doğrulayıcı kodu",
    "unmute": "Sesi aç",
    "activityMap": "Ülkeye göre dünya etkinlik haritası",
    "cancelAllFailed": "Tüm başarısız partileri iptal et",
    "copyBackupCodes": "Yedek kodlarını kopyala",
    "deleteSelected": "Seçilenleri sil",
    "downloadBackupCodes": "Yedek kodlarını indir",
    "downloadProgress": "İndirme ilerlemesi",
    "exitEditMode": "Düzenleme modundan çık",
    "expandDownloadProgress": "İndirme ilerlemesini genişlet",
    "exportCsv": "CSV olarak dışa aktar",
    "imageEditor": "Görsel düzenleyici",
    "markdownEditor": "Markdown düzenleyici",
    "markdownHeading": "Başlık stili",
    "markdownLinkActions": "Bağlantı eylemleri",
    "markdownToolbar": "Biçimlendirme araç çubuğu",
    "minimizeDownloadProgress": "İndirme ilerlemesini küçült",
    "pdfViewer": "PDF belge görüntüleyici",
    "printDashboard": "Panoyu yazdır",
    "refreshFolderStats": "Klasör istatistiklerini yenile",
    "refreshList": "Listeyi yenile",
    "removeFile": "Dosyayı kaldır",
    "saveFile": "Dosyayı kaydet",
    "selectUser": "{{name}} seç",
    "viewUploadErrors": "Yükleme hatalarını görüntüle",
    "uploadProgress": "Yükleme ilerlemesi",
    "viewAsGrid": "Izgara olarak görüntüle",
    "viewAsList": "Liste olarak görüntüle",
    "userForm": "Kullanıcı formu",
    "userMenu": "Kullanıcı hesabı menüsü",
    "viewRiskIndicator": "{{name}}, ayrıntıları görüntüle",
    "verifyingFile": "Dosya doğrulanıyor",
    "videoPlayer": "Video oynatıcı",
    "volume": "Ses, yüzde {{percent}}",
    "messageInput": "Mesaj girişi",
    "sendMessage": "Mesaj gönder",
    "stopGenerating": "Oluşturmayı durdur"
  },
  "antivirus": {
    "quarantine": {
      "title": "Karantina",
      "description": "Enfekte, başarısız ve atlanan taramaları inceleyin; yanlış pozitifleri serbest bırakın.",
      "empty": "Bu filtreye uyan dosya yok",
      "rescan": "Yeniden tara",
      "release": "Serbest bırak",
      "delete": "Sil",
      "rescanSuccess": "Yeniden tarama kuyruğa alındı",
      "releaseSuccess": "Dosya karantinadan serbest bırakıldı",
      "releaseModalTitle": "Dosyayı karantinadan serbest bırak",
      "releaseConfirmDescription": "\"{{fileName}}\" karantinadan serbest bırakılsın mı? Dosya yeniden kullanılabilir olur. Denetim kaydı için bir gerekçe girin.",
      "releaseReasonLabel": "Gerekçe",
      "releaseReasonPlaceholder": "Dosyanın neden serbest bırakılması gerektiğini açıklayın",
      "releaseReasonRequired": "Serbest bırakma gerekçesi zorunludur",
      "deleteConfirmTitle": "Karantinadaki dosya silinsin mi?",
      "deleteConfirmDescription": "\"{{fileName}}\" çöp kutusuna taşınsın mı? Olağan dosya silme yolunu kullanır.",
      "status": {
        "infected": "Enfekte",
        "error": "Hata",
        "skipped": "Atlandı",
        "toolarge": "Çok büyük"
      },
      "columns": {
        "name": "Dosya adı",
        "threat": "Tehdit",
        "engine": "Motor",
        "ownerEmail": "Sahip e-postası",
        "scannedAt": "Taranma zamanı",
        "actions": "İşlemler"
      },
      "errors": {
        "loadFailed": "Karantina dosyaları yüklenemedi",
        "rescanFailed": "Yeniden tarama kuyruğa alınamadı",
        "releaseFailed": "Dosya serbest bırakılamadı",
        "deleteFailed": "Dosya silinemedi",
        "invalidParams": "Geçersiz filtre veya serbest bırakma gerekçesi"
      }
    }
  },
  "account": {
    "title": "Hesap",
    "description": "Profilinizi, tercihlerinizi ve güvenliğinizi yönetin.",
    "navAria": "Hesap bölümleri",
    "profile": "Profil",
    "profileDescription": "Adınızı güncelleyin. E-posta burada değiştirilemez.",
    "profileUnavailable": "Profil kullanılamıyor.",
    "profileUpdated": "Profil güncellendi",
    "preferences": "Tercihler",
    "preferencesDescription": "Dil, görünüm ve erişilebilirlik.",
    "languageDescription": "Arayüz dilini seçin.",
    "appearanceDescription": "Açık, koyu veya sistemi izle.",
    "accessibilityDescription": "Yüksek kontrast ve hareket azaltmayı açın.",
    "security": "Güvenlik",
    "securityDescription": "İki adımlı doğrulama ve geçiş anahtarları.",
    "twoFactorDescription": "Doğrulayıcı uygulama kodlarını ekleyin veya yönetin.",
    "passkeysDescription": "Bu hesap için geçiş anahtarlarını kaydedin ve yönetin.",
    "openTwoFactor": "2FA'yı yönet",
    "openPasskeys": "Geçiş anahtarlarını yönet",
    "sessions": "Oturumlar",
    "sessionsDescription": "Aktif oturumları ve klasör kilit açmalarını yönetin.",
    "activeSessionsDescription": "Aktif tarayıcı oturumlarını inceleyin ve iptal edin.",
    "folderSessionsDescription": "Klasör parola kilit açma oturumlarını yönetin.",
    "openActiveSessions": "Aktif oturumları yönet",
    "openFolderSessions": "Klasör oturumlarını yönet",
    "publicLinks": "Herkese açık bağlantılar",
    "publicLinksDescription": "Oluşturduğunuz herkese açık bağlantıları görüntüleyin ve iptal edin.",
    "publicLinksCtaDescription": "Herkese açık bağlantı listenizi açın.",
    "openPublicLinks": "Herkese açık bağlantıları yönet"
  },
  "pageTitle": {
    "app": "Filegrant",
    "login": "Giriş",
    "logout": "Çıkış",
    "settings": "Ayarlar",
    "account": "Hesap",
    "filesPersonal": "Dosyalar",
    "filesReceived": "Alınanlar",
    "filesShared": "Paylaşılanlar",
    "filesFavorites": "Favoriler",
    "filesRecent": "Son",
    "filesHidden": "Gizli",
    "filesTrash": "Çöp kutusu",
    "publicLink": "Herkese açık bağlantı",
    "emails": "E-postalar",
    "emailsInbox": "Gelen kutusu",
    "emailsSent": "Gönderilenler",
    "emailsDrafts": "Taslaklar",
    "emailsFavorites": "Favori e-postalar",
    "emailsArchive": "Arşiv",
    "emailsTrash": "E-posta çöp kutusu",
    "users": "Kullanıcılar",
    "groups": "Gruplar",
    "dashboard": "Gösterge paneli",
    "salesDashboard": "Satış paneli",
    "activityLogs": "Etkinlik günlükleri",
    "antivirusQuarantine": "Karantina",
    "viewer": "Görüntüleyici",
    "office": "Office",
    "quickShare": "Quick Share",
    "store": "Mağaza",
    "purchase": "Satın alma",
    "paymentSuccess": "Ödeme başarılı",
    "fileShareRequests": "Paylaşım istekleri",
    "protectedFile": "Korumalı dosya",
    "extensionAuthorize": "Uzantı yetkilendirmesi",
    "sharePointStatus": "SharePoint durumu"
  },
  "activityLogOperationTypes": {
    "CreateFile": "Dosya Oluştur",
    "CreateFolder": "Klasör oluştur",
    "CreateFileFailed": "Dosya oluşturulamadı",
    "CreateFolderFailed": "Klasör oluşturulamadı",
    "ReadFile": "Dosya Oku",
    "ReadFolder": "Klasör Oku",
    "DownloadFile": "Dosya indir",
    "DownloadFileEncrypted": "Şifrelenmiş dosya indir",
    "DownloadFileZip": "ZIP Dosyası İndir",
    "SearchFiles": "Dosyalarda Ara",
    "ReadFileFailed": "Dosya Okunamadı",
    "ReadFolderFailed": "Klasör Okunamadı",
    "DownloadFileFailed": "Dosya İndirilemedi",
    "DownloadFileEncFailed": "Şifrelenmiş dosya indirilemedi",
    "DownloadFileZipFailed": "ZIP Dosyası İndirilemedi",
    "UpdateFile": "Dosyayı Güncelle",
    "RenameFile": "Dosyayı Yeniden Adlandır",
    "MoveFile": "Dosyayı Taşı",
    "DuplicateFile": "Dosyayı Çoğalt",
    "UploadFile": "Dosya Yükle",
    "UpdateFileFailed": "Dosya Güncellenemedi",
    "RenameFileFailed": "Dosya Yeniden Adlandırılamadı",
    "MoveFileFailed": "Dosya taşınamadı",
    "DuplicateFileFailed": "Dosya Çoğaltılamadı",
    "UploadFileFailed": "Dosya Yüklenemedi",
    "DeleteFileToRecycleBin": "Dosyayı Geri Dönüşüm Kutusuna Taşı",
    "DeleteFolderToRecycleBin": "Klasörü Geri Dönüşüm Kutusuna Taşı",
    "DeleteFileToRecycleBinFailed": "Dosya geri dönüşüm kutusuna taşınamadı",
    "DeleteFolderToRecycleBinFailed": "Klasör geri dönüşüm kutusuna taşınamadı",
    "DeleteFilePermanently": "Dosyayı Kalıcı Olarak Sil",
    "DeleteFolderPermanently": "Klasörü Kalıcı Olarak Sil",
    "DeleteFilePermanentlyFailed": "Dosya kalıcı olarak silinemedi",
    "DeleteFolderPermanentlyFailed": "Klasör Kalıcı Olarak Silinemedi",
    "ShareFile": "Dosya Paylaş",
    "ShareFolder": "Klasör Paylaş",
    "RevokeShare": "Paylaşımı Kaldır",
    "ShareFileFailed": "Dosya Paylaşılamadı",
    "ShareFolderFailed": "Klasör Paylaşılamadı",
    "RevokeShareFailed": "Paylaşım Kaldırılamadı",
    "ViewAuditLog": "Denetim Kaydını Görüntüle",
    "ExportAuditLog": "Denetim Kaydını Dışa Aktar",
    "ViewAuditLogFailed": "Denetim Kaydı Görüntülenemedi",
    "ExportAuditLogFailed": "Denetim Kaydı Dışa Aktarılamadı",
    "PurgeAuditLog": "Denetim Kaydı Temizlendi (saklama)",
    "GrantAccess": "Erişim Ver",
    "RevokeAccess": "Erişimi Kaldır",
    "GrantAccessFailed": "Erişim Verilemedi",
    "RevokeAccessFailed": "Erişim Kaldırılamadı",
    "CreateVersion": "Sürüm Oluştur",
    "RevertVersion": "Sürümü Geri Al",
    "CreateVersionFailed": "Sürüm oluşturulamadı",
    "RevertVersionFailed": "Sürüm geri alınamadı",
    "CommentFile": "Dosyaya Yorum Yap",
    "ReplyComment": "Yoruma Yanıt Ver",
    "AssignTask": "Görev Ata",
    "CommentFileFailed": "Dosyaya Yorum Yapılamadı",
    "ReplyCommentFailed": "Yoruma Yanıt Verilemedi",
    "AssignTaskFailed": "Görev Atanamadı",
    "PreviewFile": "Dosyayı Önizle",
    "HiddenFile": "Dosyayı Gizle",
    "UnhiddenFile": "Dosyayı Görünür Yap",
    "AddToFavorites": "Favorilere Ekle",
    "RemoveFromFavorites": "Favorilerden Çıkar",
    "PreviewFileFailed": "Dosya Önizlenemedi",
    "HiddenFileFailed": "Dosya Gizlenemedi",
    "UnhiddenFileFailed": "Dosya Görünür Yapılamadı",
    "AddToFavoritesFailed": "Favorilere Eklenemedi",
    "RemoveFromFavoritesFailed": "Favorilerden Çıkarılamadı",
    "CreateUser": "Kullanıcı Oluştur",
    "EditUser": "Kullanıcıyı Düzenle",
    "RemoveUser": "Kullanıcıyı Kaldır",
    "CreateGroup": "Grup Oluştur",
    "EditGroup": "Grubu Düzenle",
    "RemoveGroup": "Grubu Kaldır",
    "OnBehalfOfAccess": "Vekâleten Erişim Sağla",
    "OnBehalfOfOperation": "Vekâleten İşlem Yap",
    "CreateUserFailed": "Kullanıcı Oluşturulamadı",
    "EditUserFailed": "Kullanıcı Düzenlenemedi",
    "RemoveUserFailed": "Kullanıcı Kaldırılamadı",
    "CreateGroupFailed": "Grup Oluşturulamadı",
    "EditGroupFailed": "Grup Düzenlenemedi",
    "RemoveGroupFailed": "Grup Kaldırılamadı",
    "OnBehalfOfAccessFailed": "Vekâleten Erişim Sağlanamadı",
    "OnBehalfOfOperationFailed": "Vekâleten İşlem Yapılamadı",
    "LogIn": "Oturum Aç",
    "LogOut": "Oturumu Kapat",
    "OTPRequest": "OTP Talep Et",
    "LogInFailed": "Oturum Açılamadı",
    "LogOutFailed": "Oturum Kapatılamadı",
    "OTPRequestFailed": "OTP Talep Edilemedi",
    "AddTag": "Etiket Ekle",
    "RemoveTag": "Etiketi Kaldır",
    "UpdateTag": "Etiketi Güncelle",
    "ListTags": "Etiketleri Listele",
    "AddTagFailed": "Etiket Eklenemedi",
    "RemoveTagFailed": "Etiket Kaldırılamadı",
    "UpdateTagFailed": "Etiket Güncellenemedi",
    "ListTagsFailed": "Etiketler Listelenemedi",
    "RestoreFile": "Dosyayı Geri Yükle",
    "TagFile": "Dosyayı Etiketle",
    "RemoveTagFile": "Dosya Etiketini Kaldır",
    "EncryptFile": "Dosyayı Şifrele",
    "DecryptFile": "Dosyanın Şifresini Çöz",
    "ChangeFileOwner": "Dosya Sahibinı Değiştir",
    "SetFileExpiration": "Dosya Geçerlilik Süresi Belirle",
    "GenerateShareLink": "Paylaşım Bağlantısı Oluştur",
    "ValidateUser": "Kullanıcıyı Doğrula",
    "SignFile": "Dosyayı İmzala",
    "FileDescription": "Dosya Açıklamasını Güncelle",
    "ShortCut": "Kısayol Oluştur",
    "RestoreFileFailed": "Dosya Geri Yüklenemedi",
    "TagFileFailed": "Dosya Etiketlenemedi",
    "RemoveTagFileFailed": "Dosya Etiketi Kaldırılamadı",
    "EncryptFileFailed": "Dosya Şifrelenemedi",
    "DecryptFileFailed": "Dosya Şifresi Çözülemedi",
    "ChangeFileOwnerFailed": "Dosya sahibi değiştirilemedi",
    "SetFileExpirationFailed": "Dosya Geçerlilik Süresi Belirlenemedi",
    "GenerateShareLinkFailed": "Paylaşım bağlantısı oluşturulamadı",
    "ValidateUserFailed": "Kullanıcı Doğrulanamadı",
    "SignFileFailed": "Dosya İmzalanamadı",
    "FileDescriptionFailed": "Dosya Açıklaması Güncellenemedi",
    "ShortCutFailed": "Kısayol Oluşturulamadı",
    "ScreenCaptureAttempt": "Ekran Görüntüsü Alma Girişimi",
    "ClipboardCopyAttempt": "Panoya Kopyalama Girişimi",
    "UnauthorizedAccessAttempt": "Yetkisiz Erişim Girişimi",
    "ScreenCaptureAttemptFailed": "Ekran Görüntüsü Alma Girişimi Başarısız Oldu",
    "ClipboardCopyAttemptFailed": "Panoya Kopyalama Girişimi Başarısız Oldu",
    "UnauthorizedAccessAttemptFailed": "Yetkisiz Erişim Girişimi Başarısız Oldu",
    "MalwareDetection": "Kötü Amaçlı Yazılım Tespit Edildi",
    "MalwareRemoval": "Kötü Amaçlı Yazılım Temizlendi",
    "SuspiciousActivityDetected": "Şüpheli Etkinlik Tespit Edildi",
    "IntrusionDetection": "Sızma Tespit Edildi",
    "IntrusionPrevention": "Sızma Engellendi",
    "DataLeakageAttempt": "Veri Sızıntısı Girişimi",
    "DataLeakageAttemptFailed": "Veri Sızıntısı Girişimi Başarısız Oldu",
    "PhishingAttemptDetected": "Oltalama Girişimi Tespit Edildi",
    "RansomwareAttackDetected": "Fidye Yazılımı Saldırısı Tespit Edildi",
    "BruteForceAttackDetected": "Kaba Kuvvet Saldırısı Tespit Edildi",
    "TwoFactorAuthEnabled": "İki Faktörlü Kimlik Doğrulama Etkinleştirildi",
    "TwoFactorAuthDisabled": "İki Faktörlü Kimlik Doğrulama Devre Dışı Bırakıldı",
    "TwoFactorAuthAttemptFailed": "İki Faktörlü Kimlik Doğrulama Denemesi Başarısız Oldu",
    "PasswordChange": "Parolayı Değiştir",
    "PasswordChangeFailed": "Parola Değiştirilemedi",
    "SecuritySettingsUpdate": "Güvenlik Ayarlarını Güncelle",
    "SecuritySettingsUpdateFailed": "Güvenlik ayarları güncellenemedi",
    "FirewallRuleChange": "Güvenlik Duvarı Kuralını Değiştir",
    "FirewallRuleChangeFailed": "Güvenlik Duvarı Kuralı Değiştirilemedi",
    "EncryptionKeyManagement": "Şifreleme Anahtarını Yönet",
    "EncryptionKeyManagementFailed": "Şifreleme Anahtarı Yönetilemedi",
    "AccessControlPolicyChange": "Erişim Kontrol Politikasını Değiştir",
    "AccessControlPolicyChangeFailed": "Erişim Kontrol Politikası Değiştirilemedi",
    "SecurityPatchApplied": "Güvenlik Yaması Uygulandı",
    "SecurityPatchAppliedFailed": "Güvenlik Yaması Uygulanamadı",
    "LastCheckToken": "Son Kontrol Tokeni",
    "UpdateSetting": "Ayarı Güncelle",
    "ViewGroupsList": "Grupları Listele",
    "ViewUsersList": "Kullanıcıları Listele",
    "ViewTrash": "Çöp Kutusunu Görüntüle",
    "ViewArchivedFiles": "Arşivlenen Dosyaları Görüntüle",
    "ViewFavoriteFiles": "Favori Dosyaları Görüntüle",
    "ViewSharedFiles": "Paylaşılan Dosyaları Görüntüle",
    "ViewReceivedFiles": "Alınan Dosyaları Görüntüle",
    "ViewSettings": "Ayarları Görüntüle",
    "EmailSent": "E-posta Gönder",
    "EmailRead": "E-postayı Oku",
    "EmailSaveDraft": "Taslağı Kaydet",
    "EmailUpdateDraft": "Taslağı Güncelle",
    "EmailTrash": "E-postayı Çöp Kutusuna Taşı",
    "EmailRestore": "E-postayı Geri Yükle",
    "EmailDelete": "E-postayı Sil",
    "EmailArchive": "E-postayı Arşivle",
    "EmailUnarchive": "E-postayı Arşivden Çıkar",
    "EmailFavourite": "E-postayı Favorilere Ekle",
    "EmailUnfavourite": "E-postayı Favorilerden Çıkar",
    "EmailAttachmentRemoved": "E-posta Eki Kaldırıldı",
    "EmailRecipientRemoved": "E-posta Alıcısı Kaldırıldı",
    "CreateSetting": "Ayar Oluştur",
    "DeleteSetting": "Ayarı Sil",
    "PaymentSessionCreated": "Ödeme Oturumu Oluşturuldu",
    "PaymentCompleted": "Ödeme Tamamlandı",
    "SessionRevoked": "Oturum İptal Edildi",
    "AllSessionsRevoked": "Tüm Oturumlar İptal Edildi",
    "AdminSessionRevoked": "Yönetici Oturumu İptal Edildi",
    "CreateCompany": "Şirket Oluştur",
    "UpdateCompany": "Şirketi Güncelle",
    "BackOfficeCreateUser": "BackOffice Kullanıcısı Oluştur",
    "BackOfficeUpdateUser": "BackOffice Kullanıcısını Güncelle",
    "SystemMaintenance": "Sistem bakımı",
    "CreateCertificate": "Sertifika Oluştur",
    "CreateAccessRule": "Erişim Kuralı Oluştur",
    "VersionRetention": "Sürüm Saklama Politikası Uygula",
    "CleanupDeletedVersions": "Silinen Sürümleri Temizle",
    "CreateIdentityProvider": "Kimlik Sağlayıcı Oluştur",
    "UpdateIdentityProvider": "Kimlik Sağlayıcıyı Güncelle",
    "CreateAIAgent": "Yapay Zekâ Ajanı Oluştur",
    "UpdateAIAgent": "Yapay Zekâ Ajanını Güncelle",
    "DeleteAIAgent": "Yapay Zekâ Ajanını Sil",
    "AIChatRequest": "Yapay Zekâ Sohbet İsteği",
    "AIChatWithDocument": "Belge ile Yapay Zekâ Sohbeti",
    "CancelBatch": "Toplu İşi İptal Et",
    "CancelFileJobs": "Dosya İşlerini İptal Et",
    "RetryFileJobs": "Dosya İşlerini Yeniden Dene",
    "InviteUsers": "Kullanıcı Davet Et",
    "ViewExecutiveReport": "Yönetici Raporunu Görüntüle",
    "CreatePublicLink": "Herkese Açık Bağlantı Oluştur",
    "RevokePublicLink": "Herkese Açık Bağlantıyı İptal Et",
    "PublicLinkAccess": "Herkese Açık Bağlantıya Eriş",
    "PublicLinkDownload": "Herkese Açık Bağlantıdan İndir",
    "PublicLinkAccessFailed": "Herkese Açık Bağlantıya Erişilemedi",
    "IpRegionLoginBlocked": "IP/Bölge Girişi Engellendi",
    "IpRegionFileOperationBlocked": "IP/Bölge Kaynaklı Dosya İşlemi Engellendi",
    "EntraIdSyncStarted": "Entra ID Senkronizasyonu Başlatıldı",
    "EntraIdSyncCompleted": "Entra ID Senkronizasyonu Tamamlandı",
    "EntraIdUserImported": "Entra ID Kullanıcısı İçe Aktarıldı",
    "EntraIdGroupImported": "Entra ID Grubu İçe Aktarıldı",
    "EntraIdSyncFailed": "Entra ID senkronizasyonu başarısız oldu",
    "SetFolderPassword": "Klasör Parolası Belirle",
    "RemoveFolderPassword": "Klasör Parolasını Kaldır",
    "FolderPasswordVerified": "Klasör Parolası Doğrulandı",
    "FolderPasswordFailed": "Klasör Parolası Doğrulanamadı",
    "FolderPasswordLockout": "Klasör şifre kilidi",
    "FolderPasswordSessionRevoked": "Klasör Parola Oturumu İptal Edildi",
    "FolderPasswordResetOtpRequested": "Klasör Parolası Sıfırlama OTP İsteği",
    "FolderPasswordResetWithOtp": "Klasör Parolası OTP ile Sıfırlandı",
    "FolderPasswordResetOtpFailed": "Klasör Parolası Sıfırlama OTP İşlemi Başarısız Oldu",
    "TotpExemptionGranted": "TOTP Muafiyeti Verildi",
    "TotpExemptionRevoked": "TOTP Muafiyeti Kaldırıldı",
    "TotpExemptionExpired": "TOTP Muafiyeti Süresi Doldu",
    "TransferOwnership": "Sahipliği Devret",
    "SharePointFileEncrypted": "SharePoint dosyası şifrelendi",
    "SharePointFileEncryptionFailed": "SharePoint dosyası şifrelenemedi",
    "SharePointFileEncryptionSkipped": "SharePoint dosyası atlandı",
    "SharePointScanCycleCompleted": "SharePoint tarama döngüsü tamamlandı",
    "SharePointScanCycleFailed": "SharePoint tarama döngüsü başarısız oldu",
    "SharePointConnectionTested": "SharePoint bağlantısı doğrulandı",
    "SharePointConnectionTestFailed": "SharePoint bağlantısı doğrulanamadı",
    "SharePointPerimeterBrowsed": "SharePoint kapsamı görüntülendi",
    "SharePointViewerTokenIssued": "SharePoint görüntüleyici jetonu verildi",
    "SharePointViewerTokenDenied": "SharePoint görüntüleyici jetonu reddedildi",
    "SharePointEditSessionOpened": "SharePoint düzenleme oturumu açıldı",
    "SharePointEditSessionDenied": "SharePoint düzenleme oturumu reddedildi",
    "SharePointFileEdited": "SharePoint dosyası düzenlendi",
    "DirectorySyncUserDisabled": "Dizin senkronizasyonu kullanıcıyı devre dışı bıraktı",
    "DirectorySyncUserEnabled": "Dizin senkronizasyonu kullanıcıyı etkinleştirdi",
    "DirectorySyncGroupMembersChanged": "Dizin senkronizasyonu grup üyelerini değiştirdi",
    "DirectorySyncStarted": "Dizin senkronizasyonu başladı",
    "DirectorySyncCompleted": "Dizin senkronizasyonu tamamlandı",
    "DirectorySyncFailed": "Dizin senkronizasyonu başarısız oldu",
    "DirectorySyncUserImported": "Kullanıcı dizin senkronizasyonuyla içe aktarıldı",
    "DirectorySyncGroupImported": "Grup dizin senkronizasyonuyla içe aktarıldı",
    "DirectorySyncConnectionTested": "Dizin bağlantısı test edildi"
  },
  "activityLogTargetTypes": {
    "File": "Dosya",
    "Folder": "Klasör ",
    "Files": "Dosyalar",
    "FilesAndFolders": "Dosyalar ve Klasörler",
    "FilesAndTags": "Dosyalar ve Etiketler",
    "FilesFoldersAndTags": "Dosyalar, Klasörler ve Etiketler",
    "User": "Kullanıcı",
    "Group": "Grup",
    "Share": "Paylaş",
    "ShareLink": "Bağlantıyı paylaş",
    "Version": "Sürüm",
    "Comment": "Yorum",
    "Task": "Görev",
    "Permission": "İzin",
    "AccessControl": "Erişim Kontrolü",
    "Admin": "Yönetici",
    "Configuration": "Yapılandırma",
    "Setting": "Ayar",
    "Tag": "Etiket",
    "Metadata": "Meta Veri",
    "Notification": "Bildirim",
    "Workflow": "İş Akışı",
    "Template": "Şablon",
    "AuditLog": "Denetim Kaydı",
    "Security": "Güvenlik",
    "Monitoring": "İzleme",
    "Authentication": "Kimlik Doğrulama",
    "TwoFactorAuth": "İki Faktörlü Kimlik Doğrulama",
    "Encryption": "Şifreleme",
    "EncryptionKey": "Şifreleme Anahtarı",
    "Other": "Diğer",
    "GroupsList": "Gruplar Listesi",
    "UsersList": "Kullanıcılar Listesi",
    "SpecialFolder": "Özel Klasör",
    "SettingsList": "Ayarlar Listesi",
    "Email": "E-posta",
    "SharePointFile": "SharePoint dosyası"
  },
  "realtime": {
    "connected": "Bağlı",
    "connecting": "Bağlanıyor…",
    "disconnected": "Bağlantı kesildi",
    "reconnecting": "Yeniden bağlanıyor…"
  },
  "settings": {
    "settings": "Ayarlar",
    "unavailable": "Ayarlar şu anda kullanılamıyor",
    "retry": "Yeniden denemek için buraya tıklayın",
    "authentication": "Kimlik doğrulama",
    "saveCard": {
      "message": "<strong>Değişiklikleri tamamladığınızda Kaydet'e</strong> tıklayın."
    },
    "informations": "Bilgiler",
    "preview": "Önizleme",
    "externalUserEnforcement": "Harici Kullanıcı Zorunluluğu",
    "externalUserEnforcementDescription": "Tüm harici kullanıcılar için Yakalama Önleme modunda görüntülemeyi zorunlu kılın.",
    "tagBasedEncryption": "Etiket Tabanlı Şifreleme",
    "tagBasedEncryptionDescription": "Belirli etiketlere sahip dosyalar için Yakalama Önleme modunda görüntülemeyi zorlayın.",
    "tagBasedEncryptionPlaceholder": "Etiketler (virgülle ayrılmış), - örneğin 'gizli, gizli'",
    "companyBranding": {
      "title": "Firma ismi ve markası",
      "description": "Platformun görünümünü şirketinizin markasıyla özelleştirin. Bu, kullanıcılara gösterilecek logoyu, renkleri ve diğer görsel öğeleri ayarlamayı içerir.",
      "companyName": "Şirket Adı",
      "preferredLanguage": "Tercih Edilen Dil",
      "companyLogos": "Şirket Logoları",
      "companyLogosDescription": "Dosya boyutu 1 MB'den büyük olamaz",
      "loginPageLogo": "Giriş",
      "loginPageLogoDescription": "Kullanıcılar için giriş sayfasında gösterilecek logoyu ayarlayın. Öneriler: Maksimum 200 piksel genişliğinde şeffaf bir arka plana sahip kare veya yatay logo.",
      "topBarLogo": "Üst Bar / Logo",
      "topBarLogoDescription": "Platformun üst çubuğunda görüntülenecek logoyu ayarlayın. Öneriler: Şeffaf arka plana sahip kare veya yatay logo.",
      "emailNotificationLogo": "E-posta Bildirimi Logosu",
      "emailNotificationLogoDescription": "Kullanıcılara gönderilen e - posta bildirimlerinde kullanılacak logoyu ayarlayın.",
      "quickShareBackground": "Hızlı Paylaşım Arka Planı",
      "quickShareBackgroundDescription": "Hızlı paylaşım sayfasında görüntülenecek arka plan görüntüsünü ayarlayın. Önerilen boyut: 1200x1920 piksel",
      "companyColors": "Şirket Renkleri",
      "topBarColors": "Üst Çubuk Renkleri",
      "topBarColorsDescription": "Platformun üst çubuğu için arka planı ve metin rengini ayarlayın.",
      "mainButtonsColors": "Butonların Renkleri",
      "mainButtonsColorsDescription": "Ana düğme için arka plan ve metin rengini ayarlayın.",
      "loginPageTitle": "Giriş Sayfası Başlığı",
      "loginPageSubtitle": "Giriş Sayfası Altyazısı",
      "loginTermsAndConditions": "Giriş Sayfası Kullanım Koşulları",
      "loginPagePreview": "Giriş Sayfası Önizlemesi",
      "mainButtonsPreview": "Ana Buton Önizlemesi",
      "emailNotificationsPreview": "E-posta Bildirimleri Önizlemesi",
      "quickSharePreview": "Hızlı Paylaşım Önizlemesi",
      "addLogo": "Logo Ekle"
    },
    "emailCustomizations": {
      "title": "E-posta özelleştirmeleri",
      "description": "Platform tarafından gönderilen e-posta bildirimleri için kullanılan HTML şablonlarını özelleştirin.",
      "language": "Dil",
      "noTemplates": "E-posta şablonu yok",
      "subject": "Ders",
      "availablePlaceholders": "Kullanılabilir Yer Tutucular (eklemek için tıklayın)",
      "preview": "Önizleme",
      "customized": "Özelleştirilmiş",
      "default": "Varsayılan",
      "resetToDefault": "Varsayılana Sıfırla",
      "resetTitle": "Şablonu sıfırla",
      "resetConfirm": "Sıfırla",
      "resetConfirmDescription": "Bu, özelleştirmelerinizi kaldıracak ve varsayılan şablona geri dönecektir. Bu eylem geri alınamaz.",
      "resetSuccess": "Şablon varsayılana sıfırlandı",
      "resetError": "Şablon sıfırlanamadı",
      "saveSuccess": "Şablon başarıyla kaydedildi",
      "saveError": "Şablon kaydedilemedi",
      "sendTest": "Test E-postası Gönder",
      "testSuccess": "Test e-postası gönderildi",
      "testError": "Test e-postası gönderilemedi"
    },
    "downloadRestrictions": {
      "title": "Şifreleme uygulamasını indir",
      "description": "Tüm üyeler için indirme kısıtlamaları ayarlarını kontrol edin. Bu, indirmelerde şifrelemenin uygulanmasını, harici kullanıcılar için belirli kuralların uygulanmasını ve bu ayarların dosya etiketlerine göre geçersiz kılınmasını içerir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Sahip oldukları veya düzenleme izinlerine sahip oldukları için zaten indirme izinlerine sahip olan üyeler için indirme şifrelemesini uygulayın. Etkinleştirilmezse, indirmeler uygun olduğunda normal şekilde çalışacaktır.",
      "exceptionHandlingTitle": "İstisna İşleme ",
      "exceptionHandlingDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "externalUserEnforcementTitle": "Harici Kullanıcı Zorunluluğu",
      "externalUserEnforcementDescription": "Tüm harici kullanıcılar için indirme şifrelemesini zorunlu kılın",
      "tagBasedEncryptionTitle": "Etiket Tabanlı Şifreleme",
      "tagBasedEncryptionDescription": "Belirli etiketlerle Şifreli indirmeye zorla",
      "tagBasedEncryptionPlaceholder": "Etiketler (virgülle ayrılmış), - örneğin 'gizli, gizli'",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir"
    },
    "downloadAllowedTags": {
      "title": "İzin verilen etiketleri indir",
      "description": "Üyelerin Salt Okunur izinleriyle paylaşılan belgeleri indirmelerine izin verir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, uygulandıkları koşulları ve izin verilen istisnaları tanımlayabilir.",
      "exceptionHandlingTitle": "İstisna İşleme ",
      "exceptionHandlingDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "externalUserEnforcementTitle": "Harici Kullanıcı Zorlaması",
      "externalUserEnforcementDescription": "Tüm harici kullanıcılar için indirme şifrelemesini zorunlu kılın",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Salt okunur dosyalar için indirmeyi yalnızca bu etiketlere sahip dosyalar için etkinleştirin.",
      "tagsPlaceholder": "Etiketler (virgülle ayrılmış), - örneğin 'gizli, gizli'",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir"
    },
    "forcedAntiCaptureMode": {
      "title": "Zorunlu yakalama önleme modu",
      "description": "Paylaşılan dosyaları yalnızca Yakalama Önleme modunda belirli etiketlerle görüntülemeye zorlayın.",
      "forcedAntiCaptureModeTitle": "Yakalamayı Önleme Uygulaması",
      "forcedAntiCaptureModeDescription": "Yakalama işleminin tümüne mi yoksa hiçbirine mi uygulanacağını seçin. Yakalamayı önleme özelliğini etkinleştirmek, güvenli dosya indirmelerini de etkinleştirir.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "tagBasedEncryptionTitle": "Etiket Tabanlı Şifreleme",
      "tagBasedEncryptionDescription": "Bu kuralı yalnızca belirli etiketlere sahip dosyalara uygula"
    },
    "aiTagging": {
      "title": "Yapay zeka etiketleme",
      "description": "Dosyalar için AI etiketlemeyi etkinleştirin. Bu, dosyaları içeriklerine göre otomatik olarak etiketleyecektir.",
      "descriptionInternal": "Dosyalar için AI etiketlemeyi etkinleştirin. Bu, dosyaları içeriklerine göre otomatik olarak etiketleyecektir. <DangerText>Not: Bu yalnızca 250 MB'tan küçük dosyalar için geçerlidir. Bu ayarlarda yapılan değişiklikler geriye dönük olarak UYGULANMAZ, yani mevcut etiketlere sahip dosyalar otomatik olarak sınıflandırılmaz.</DangerText>",
      "isRuleEnabledTitle": "Yapay Zeka Etiketleme Kuralını Etkinleştir",
      "isRuleEnabledDescription": "Kullanıcıların ( Yöneticiler ve Katkıda Bulunanlar ) yapay zekanın dosyalarını içeriklerine göre etiketlemesine izin verme yeteneğini etkinleştirin.",
      "isAutomaticClassificationEnabledTitle": "Otomatik Sınıflandırmayı Etkinleştir",
      "isAutomaticClassificationEnabledDescription": "Dosyaların içeriğine göre otomatik sınıflandırmasını etkinleştirin.",
      "ruleTargetTitle": "Kural Hedefi",
      "ruleTargetDescription": "Kuralın hedefini seçin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralı yalnızca belirli etiketlere sahip dosyalara uygula",
      "aiAgentTitle": "Yapay Zekâ Aracı",
      "aiAgentDescription": "Dosyaları etiketlemek için kullanılacak AI aracısını seçin.",
      "aiAgentPlaceholder": "Bir Danışman Seçin",
      "membersTitle": "Seçilen Temsilci ile Kimler Sınıflandırabilir",
      "membersDescription": "Seçilen temsilcinin hangi üyelere başvuracağını seçin.",
      "exceptionsTitle": "İstisnaları Yönet",
      "exceptionsDescription": "Otomatik sınıflandırmaya sahip olmak istemediğiniz kullanıcıları ekleyin",
      "exceptionsButtonText": "Kullanıcıları yönet",
      "filesTypeTitle": "Dosya Uzantısı Yönetimi",
      "filesTypeDescription": "Temsilci tarafından sınıflandırılacak dosya uzantılarını belirtin.",
      "externalUserTitle": "Harici Kullanıcı",
      "externalUserDescription": "Harici kullanıcılar tarafından sınıflandırmaya izin ver.",
      "filesTypePlaceholder": "Lütfen bir veya daha fazla seçin.",
      "folderIdsTitle": "Sınıflandırılacak klasörler",
      "folderIdsDescription": "Seçilen aracı tarafından sınıflandırılacak klasörleri seçin."
    },
    "singleSignOn": {
      "title": "Tek oturum açma (SSO)",
      "enableTitle": "Çoklu Oturum Açmayı Etkinleştir",
      "description": "Kuruluşunuz için Çoklu Oturum Açma'yı (SSO) etkinleştirin. Bu, kullanıcılarınızın desteklenen bir kimlik sağlayıcısından mevcut kimlik bilgilerini kullanarak Filegrant Enterprise'a giriş yapmalarını sağlayacaktır.",
      "providers": "Tedarikçiler",
      "providersDescription": "Çoklu Oturum Açma (SSO) için etkinleştirmek istediğiniz sağlayıcıları seçin.",
      "google": "Google",
      "microsoft": "Microsoft",
      "cybergrant": "Siber Hibe",
      "notificationSsoEnableMessage": "Tek Oturum Açma (SSO) özelliği etkinleştiriliyor. Bu işlemin tamamlanması birkaç dakika sürebilir. Lütfen işlem tamamlanana kadar bu sayfada kalın.",
      "notificationSsoEnabledMessage": "Tek Oturum Açma (SSO) özelliği başarıyla etkinleştirildi.",
      "copyRedirectUriHint": "Kopyalayın ve IdP'nizin yapılandırmasını ekleyin.",
      "redirectUri": "Yönlendirme URL’si",
      "copyRedirectUriDesc": "Kopyalayın ve IdP'nizin yapılandırmasını ekleyin.",
      "notificationSsoEnableTimeout": "Hata etkinleştirme",
      "notificationSsoEnableTimeoutDesc": "Çoklu Oturum Açma (SSO) özelliği etkinleştirilemedi. Lütfen tekrar deneyin.",
      "domainAlreadySet": "Bu alan adı zaten ayarlanmış",
      "mobileRedirectUri": "Mobil Yönlendirme URI'Sİ",
      "mobileRedirectUriHint": "Bu yönlendirme URI'SİNİ yalnızca mobil uygulamada SSO'yu etkinleştirmek istiyorsanız ekleyin.",
      "clientCertificate": "İstemci sertifikası",
      "certificateInUse": "Sertifika kullanımda",
      "certificateThumbprint": "Parmak izi",
      "certificateExpiresAt": "Son kullanma",
      "certificateExpired": "Bu sertifikanın süresi {{date}} tarihinde doldu. Değiştirilene kadar SSO girişi ve Entra ID senkronu başarısız olur.",
      "certificateExpiringSoon": "Bu sertifikanın süresi {{date}} tarihinde doluyor ({{days}} gün içinde).",
      "certificateTooLarge": "Sertifika dosyası çok büyük. Boyut sınırının altında bir PKCS#12 (.pfx/.p12) kullanın.",
      "certificateReadyToUpload": "Yeni sertifika seçildi. Parolasını girin (yoksa boş bırakın) ve kaydedin.",
      "uploadCertificate": "Sertifika yükle",
      "replaceCertificate": "Sertifikayı değiştir",
      "clearCertificate": "Sertifikayı kaldır",
      "certificatePassword": "Sertifika parolası",
      "certificatePasswordHint": "Her yeni yüklemede PKCS#12 parolasını girin; saklanan parola yeniden kullanılmaz. Dosyanın parolası yoksa boş bırakın.",
      "certificatePasswordPlaceholder": "PKCS#12 parolası (isteğe bağlı)",
      "noCredentialsWarning": "İstemci gizli anahtarı veya sertifika yapılandırılmamış. Bu sağlayıcıyı etkinleştirmeden önce en az bir kimlik bilgisi ekleyin.",
      "clientIdChangeWarning": "Client ID değişti. Yeni bir istemci gizli anahtarı gönderin ve/veya sertifikayı yeniden yükleyin; aksi halde maskelenmiş kimlik bilgileri silinir.",
      "clientIdChangeBlocksSave": "Kaydedilemiyor: maskelenmiş kimlik bilgileri korunurken Client ID değişti",
      "clientIdChangeBlocksSaveHint": "Microsoft yapılandırması {{index}}: kaydetmeden önce yeni bir istemci gizli anahtarı girin ve/veya bir sertifika yükleyin.",
      "certificateProblemEntry": "{{provider}} — yapılandırma {{index}}: {{message}}",
      "errors": {
        "certificateInvalid": "İstemci sertifikası kabul edilemedi",
        "certificateNotSupported": "Bu sağlayıcı için sertifikalar desteklenmiyor",
        "invalidConfiguration": "Geçersiz Single Sign-On yapılandırması"
      }
    },
    "fileDeletionRestriction": {
      "title": "Dosya silme kısıtlaması",
      "description": "Kullanıcılar tarafından dosya silme üzerinde ayrıntılı kontrolü etkinleştirin. Bu ayar, yaratıcının, sahibinin veya alıcının dosyasına göre kullanıcının rolüne göre silme izinlerini tanımlamanıza olanak tanır. Bu, açık ve güvenli içerik yönetimi kuralları sağlar, yetkisiz silme işlemlerini önler ve kurumsal politikalara uyumu destekler.",
      "allowDeletionFor": "Silmeye İzin Verilenler",
      "allowDeletionForDescription": "Silmeye İzin Verilenler Açıklaması",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "fileAccessTypeTitle": "Dosya Erişim Türü",
      "fileAccessTypeDescription": "Dosyayı silmeye yetkili dosya/klasör erişim türlerini seçin.",
      "owner": "Sahibi",
      "creator": "Tasarımcı",
      "receiver": "Alıcı"
    },
    "adminRegisteredMemberVisibility": {
      "title": "Yönetici kayıtlı üye görünürlüğü",
      "description": "Yönetici tarafından kayıtlı üyelerin veya grupların kullanıcılara görünürlüğünü kontrol edin. Seçenekler arasında, tüm kullanıcıların yönetici tarafından kayıtlı kullanıcıları görmesine izin verilmesi veya hiçbirinin görülmemesine izin verilmesi yer alır. Görünürlük öncelikle dosya paylaşımı yoluyla sağlanır. Bir kullanıcı, yönetici olarak kayıtlı bir üyeye karşılık gelen e-posta adresiyle bir dosya paylaştığında, bu ayar gereği kullanıcının yönetici olarak kayıtlı kullanıcıları görüntüleme izni olmasa bile, kullanıcı paylaşım sonrasında üyenin adını ve soyadını görecektir. Bu sınırlama, Özel durumunun atandığı kullanıcılar veya gruplar için geçerli değildir.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "sectionTitle": "Kullanıcı Görünürlük Sınırlamaları",
      "visibilityTitle": "Yönetici - Kayıtlı Üyeler Görünürlüğü",
      "visibilityDescription": "Yönetici tarafından kayıtlı üyelerin veya grupların kullanıcılara görünürlüğünü kontrol edin. Seçenekler arasında, tüm kullanıcıların yönetici tarafından kayıtlı kullanıcıları görmesine izin verilmesi veya hiçbirinin görülmemesine izin verilmesi yer alır. Görünürlük öncelikle dosya paylaşımı yoluyla sağlanır. Bir kullanıcı, yönetici olarak kayıtlı bir üyeye karşılık gelen e-posta adresiyle bir dosya paylaştığında, bu ayar gereği kullanıcının yönetici olarak kayıtlı kullanıcıları görüntüleme izni olmasa bile, kullanıcı paylaşım sonrasında üyenin adını ve soyadını görecektir. Bu sınırlama, Özel durumunun atandığı kullanıcılar veya gruplar için geçerli değildir."
    },
    "aiFileSummary": {
      "title": "AI dosya özeti",
      "description": "Dosyalar için AI dosya özetini etkinleştirin. Bu, içeriğine göre dosyanın bir özetini otomatik olarak oluşturacaktır.",
      "descriptionInternal": "Dosyalar için AI dosya özetini etkinleştirin. Bu, içeriğine göre dosyanın bir özetini otomatik olarak oluşturacaktır. <DangerText>Not: Bu yalnızca 250 MB'tan küçük dosyalar için geçerlidir.</DangerText>",
      "activeForAllTitle": "Yapay Zeka Dosya Özeti erişimi",
      "activeForAllDescription": "Yapay zeka tarafından oluşturulan dosya özetlerinin tüm kullanıcılar tarafından kullanılabilir olup olmadığını seçin.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "externalUserTitle": "Harici Kullanıcı",
      "externalUserDescription": "Harici kullanıcılar tarafından özet oluşturulmasına izin ver.",
      "filesTypeTitle": "Dosya Uzantısı Yönetimi",
      "filesTypeDescription": "AI tarafından özetlenecek dosya uzantılarını belirtin.",
      "filesTypePlaceholder": "Lütfen bir veya daha fazla seçin."
    },
    "aiFileChat": {
      "title": "AI dosya sohbeti",
      "description": "Dosyalar için AI dosya sohbetini etkinleştirin. Bu, kullanıcıların dosya içeriğiyle sohbet etmelerini sağlar.",
      "descriptionInternal": "Dosyalar için AI dosya sohbetini etkinleştirin. Bu, kullanıcıların dosya içeriğiyle sohbet etmelerini sağlar. <DangerText>Not: Bu yalnızca 250 MB'tan küçük dosyalar için geçerlidir.</DangerText>",
      "activeForAllTitle": "Yapay Zeka Dosya Sohbet erişimi",
      "activeForAllDescription": "Yapay zeka tarafından oluşturulan dosya sohbetinin tüm kullanıcılar tarafından kullanılabilir olup olmadığını seçin.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "externalUserTitle": "Harici Kullanıcı",
      "externalUserDescription": "Harici kullanıcılar tarafından dosya içeriğiyle sohbete izin verin.",
      "filesTypeTitle": "Dosya Uzantısı Yönetimi",
      "filesTypeDescription": "Yapay zeka ile sohbet edilecek dosya uzantılarını belirtin.",
      "filesTypePlaceholder": "Lütfen bir veya daha fazla seçin."
    },
    "aiScraping": {
      "title": "Yapay zekâ veri tarama koruması",
      "description": "Yapay zekanın dosyaları taramasını reddedin. Bu, herhangi bir yapay zeka aracının dosya içeriğini toplamasını engelleyecektir.",
      "descriptionInternal": "Yapay zekanın dosyaları taramasını reddedin. Bu, herhangi bir yapay zeka aracının dosya içeriğini toplamasını engelleyecektir. <DangerText>Not: AI tarama yalnızca Salt Okunur modda açılan ve 250 MB'den küçük dosyalara uygulanır. Tarama koruması şu anda yalnızca PDF ve Office dosyalarında etkindir.</DangerText>",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, uygulandıkları koşulları ve izin verilen istisnaları tanımlayabilir.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "externalUserTitle": "Harici Kullanıcı",
      "externalUserDescription": "Dosya içeriğinin harici kullanıcılar tarafından taranmasına izin verin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir"
    },
    "onBehalfMode": {
      "title": "Adına modu",
      "description": "Platform için on behalf modunu kontrol edin. Bu, hangi katkıda bulunanların diğer katkıda bulunanlar adına işlem yapabileceğini belirtmenize olanak tanır.",
      "internalTitle": "Kullanıcılar Adına Yönetici Eylemleri",
      "internalDescription": "Yetkili yöneticiler, katkıda bulunan dosyalarının listesini görüntüleyebilir ve kullanıcılar adına dosyaları taşıma, silme veya paylaşma gibi gerekli işlemleri gerçekleştirebilir. Ancak, kullanıcı gizliliğini koruyarak dosyaların içeriğini açamazlar veya görüntüleyemezler. Bu özelliği bireysel yöneticiler için etkinleştirme veya devre dışı bırakma yetkisi yalnızca süper yöneticiye aittir. Bu, yalnızca güvenilir yöneticilerin kullanıcı dosyalarını yönetebilmesini sağlar",
      "activeForAllTitle": "Yönetici Kapsamı",
      "activeForAllDescription": "Yöneticilerin tüm kullanıcılar adına veya hiçbiri adına eylem gerçekleştirip gerçekleştiremeyeceğini tanımlama yeteneğini kontrol edin. Bu ayar, yöneticilerin dosyaları yönetme ve platformdaki diğer kullanıcılar adına görevleri gerçekleştirme iznine sahip olup olmadığını belirlemenize olanak tanır.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Burada seçilen yöneticiler, yukarıdaki 'adına' izinlerin istisnaları olacaktır."
    },
    "fileSalesPermission": {
      "title": "Dosya satış izni",
      "description": "Kullanıcıların platform üzerinden kendi dosyalarını satmalarına izin verin.",
      "internalTitle": "Üyeler için Dosya Satışını Etkinleştir",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Üyelerin platform üzerinden kendi dosyalarını satmalarına izin verin. Seçenekler arasında bu özelliğin tüm üyeler için etkinleştirilmesi veya hiçbirinin etkinleştirilmemesi yer alır. Satış için listelenen dosyalar platform tarafından yönetilecek, güvenli işlemler ve ödemelerin uygun şekilde ele alınması sağlanacaktır.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "externalUserTitle": "Harici Kullanıcı",
      "externalUserDescription": "Harici kullanıcılar tarafından dosya satışına izin ver."
    },
    "resharingPermission": {
      "title": "Yeniden paylaşım izni",
      "description": "Önceden tanımlanmış seçeneklere ve her dosyaya uygulanan etiketlere dayalı kuralları uygularken kullanıcıların dosyaları başkalarıyla yeniden paylaşmasına izin verin. Bu, içeriğin kontrollü dağıtımını sağlar ve kurumsal politikalara uyumun korunmasına yardımcı olur.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların, yönetici tarafından belirlenen belirli seçeneklere ve etiketlere sahip dosyaları paylaşma konusunda kısıtlamalara tabi olup olmadığını kontrol edin. Seçenekler, bu iznin tüm kullanıcılara uygulanmasını veya hiç uygulanmamasını içerir. Daha önce paylaşılmış olan mevcut dosyalar etkin kalacak ve etiketlerdeki değişiklikler daha önce paylaşılan bu dosyaları etkilemeyecektir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan kullanıcıları belirtin.",
      "showUsers": "Başkaları tarafından zaten erişim izni verilmiş kullanıcıları göster.",
      "allowEdit": "Kullanıcıların mevcut paylaşım ayarlarını değiştirmesine, geçersiz kılmasına veya silmesine olanak tanır.",
      "readOnly": "Salt okunur (Görüntüleyici) erişimi olan kullanıcılar tarafından dosya paylaşımını etkinleştirin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir"
    },
    "fileVersioningRetentionPolicies": {
      "title": "Dosya sürümü oluşturma",
      "description": "Dosya sürümlerinin nasıl tutulacağını yapılandırın. Saklama Sayısı gereklidir, Saklama Yaşı isteğe bağlıdır ve 0 olarak ayarlanabilir.",
      "retentionByCountTitle": "Sayıya Göre Saklama",
      "retentionByCountDescription": "Saklamayı sayıya göre ayarlayın – her dosyanın yalnızca son N sürümünü saklayın; bu sınıra ulaşıldığında eski sürümler otomatik olarak temizlenir",
      "retentionByAgeTitle": "Yaşa Göre Saklama",
      "retentionByAgeDescription": "Saklamayı yaşa göre ayarlayın – N günden daha eski sürümleri silin; Bu yaşı aşan tüm anlık görüntüler, depolamada şişmeyi önlemek için otomatik olarak temizlenecektir"
    },
    "retentionPolicies": {
      "title": "Saklama politikaları",
      "description": "Dosyaların platformda ne kadar süre tutulacağını yapılandırın. Çöp kutusundan otomatik silmeyi yönetin ve aktif dosyalar için saklama kuralları tanımlayın.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "trash": {
        "title": "Çöp kutusu saklama",
        "description": "Çöp kutusuna taşınan dosyalar yapılandırılan gün sayısından sonra kalıcı olarak silinir.",
        "activeForAllTitle": "Çöp Kutusu Saklamayı Etkinleştir",
        "activeForAllDescription": "Etkinleştirildiğinde, çöp kutusundaki dosyalar saklama süresi sonunda kalıcı olarak silinir.",
        "retentionDaysTitle": "Çöp Kutusunda Gün",
        "retentionDaysDescription": "Bir dosyanın kalıcı silinmeden önce çöp kutusunda kalacağı gün sayısı. 0'dan büyük olmalıdır.",
        "exceptionHandlingDescription": "Bu listedeki kullanıcılar ve gruplar çöp kutusu saklamasından muaftır; dosyaları çöp kutusunda süresiz kalır."
      },
      "files": {
        "title": "Dosya saklama",
        "description": "Aktif dosyalara bir saklama kuralı uygular. Saklama süresi aşağıda seçtiğiniz tarihten (oluşturma veya son değişiklik) itibaren hesaplanır.",
        "activeForAllTitle": "Dosya Saklamayı Etkinleştir",
        "activeForAllDescription": "Etkinleştirildiğinde, yapılandırılan süreden eski dosyalar seçilen eyleme göre işlenir.",
        "retentionDaysTitle": "Saklama Süresi (gün)",
        "retentionDaysDescription": "Seçilen referans tarihinden (oluşturma veya değişiklik) sonra eylemin tetikleneceği gün sayısı. 0'dan büyük olmalıdır.",
        "retentionTriggerTitle": "Saklamayı şuradan hesapla",
        "retentionTriggerDescription": "Saklama süresinin dosyanın oluşturulma tarihinden mi yoksa son değiştirilme tarihinden mi hesaplanacağını seçin.",
        "retentionTrigger": {
          "created_at": "Dosya oluşturma tarihi",
          "updated_at": "Son değiştirilme tarihi"
        },
        "actionOnExpiryTitle": "Süre Sonunda Eylem",
        "actionOnExpiryDescription": "Saklama süresini aşan dosyalara ne olur.",
        "actionOnExpiry": {
          "MoveToTrash": "Çöp kutusuna taşı",
          "DeletePermanently": "Kalıcı olarak sil",
          "RetainedTagWorkflow": "*RETAINED etiketi uygula, sonra sil"
        },
        "retainedTag": {
          "title": "*RETAINED etiketi nasıl çalışır",
          "step1": "Bu politika kaydedildiğinde sunucu *RETAINED adında bir sistem etiketi oluşturur (şirket etiket listesinde görünür ancak salt okunurdur).",
          "step2": "Yukarıdaki saklama süresinden sonra *RETAINED etiketi, o gün sayısından daha eski oluşturulmuş tüm dosyalara otomatik olarak uygulanır.",
          "step3": "Etiketlendikten sonra dosya erişilebilir kalır ancak etiket hiç kimse tarafından kaldırılamaz: arayüz kaldırma kontrolünü gizler ve sunucu sistem etiketini silmeye yönelik her girişimi reddeder.",
          "step4": "Etiketin uygulanmasından itibaren aşağıda ayarlanan gün sayısı geçtiğinde dosya kalıcı olarak silinir (DB + depolama). Tüm akıştan hariç tutmak için kullanıcıları veya grupları istisnalara ekleyin."
        },
        "retainedTagDaysTitle": "*RETAINED etiketli gün sayısı",
        "retainedTagDaysDescription": "*RETAINED etiketi uygulandıktan sonra dosyalar bu kadar gün içinde kalıcı olarak silinir. 0'dan büyük olmalıdır.",
        "tagsTitle": "Yalnızca bu etiketlere sahip dosyalara uygula",
        "tagsDescription": "Politikayı tüm dosyalara uygulamak için boş bırakın. Yalnızca herkese açık etiketler desteklenir.",
        "exceptionHandlingDescription": "Bu listedeki kullanıcılar ve gruplar dosya saklamasından muaftır; dosyaları çöp kutusuna taşınmaz, silinmez veya *RETAINED olarak etiketlenmez."
      },
      "deletePermanentlyConfirm": {
        "title": "Kalıcı silme politikasını onaylayın",
        "description": "<DangerText>Bu eylem, saklama süresini aşan tüm şirket dosyalarını KALICI olarak siler. Bu işlem geri alınamaz.</DangerText>"
      },
      "deletePermanentlySelectWarning": {
        "title": "Kalıcı silme",
        "description": "Bu eylem seçildiğinde, saklama süresini aşan dosyalar kalıcı olarak silinir. <DangerText>Bu işlem geri alınamaz ve silinen dosyalar kurtarılamaz.</DangerText><br></br>Devam etmek için aşağıdaki alana <DangerText>{{confirmKeyword}}</DangerText> yazın."
      },
      "errors": {
        "trashRetentionDays": "Çöp kutusunda kalma günü 0'dan büyük olmalıdır.",
        "retentionDays": "Saklama süresi 0'dan büyük olmalıdır.",
        "retainedTagDays": "*RETAINED etiketli gün sayısı 0'dan büyük olmalıdır."
      }
    },
    "mandatoryExpirationSharedFile": {
      "title": "Paylaşılan dosya için zorunlu son kullanma",
      "description": "Paylaşılan dosyaların zorunlu son kullanma tarihini kontrol edin. Bu, hangi paylaşılan dosyaların son kullanma tarihinin olması gerektiğini belirtmenize olanak tanır.",
      "descriptionInternal": "Bu bölüm, süresiz erişimi önlemek için dosya paylaşımına zaman sınırları uygular. Yöneticiler, paylaşılan her dosya için bir son kullanma tarihi isteyebilir, izin verilen maksimum süreyi belirleyebilir ve son kullanma tarihi olmayan paylaşımları engelleyebilir. Bu kurallar, paylaşılan erişimin geçici olmasını ve güvenlik ve uyumluluk gereksinimleriyle uyumlu olmasını sağlar. <DangerText> Bu ayarlarda yapılan değişiklikler geriye dönük olarak UYGULANMAZ; yani yeni sınırları aşan mevcut paylaşımlar GÜNCELLENMEYECEKTİR.</DangerText>",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kısıtlamaların istisnası olan üyeleri belirtin.",
      "maxAllowedByAgeTitle": "İzin Verilen Maksimum Süre",
      "maxAllowedByAgeDescription": "Herhangi bir dosya paylaşımı için maksimum süre sınırını (ör. 90 gün) ayarlar.",
      "excludedDomainsTitle": "Hariç tutulan alan adları",
      "excludedDomainsDescription": "Bu tam alan adlarına yapılan paylaşımlar için son kullanma tarihi gerekmez. Yalnızca alan adı girin (ör. company.com); joker karakter veya URL kullanmayın. Muafiyet yoksa boş bırakın.",
      "excludedDomainsPlaceholder": "Hariç tutulan alan adı yok, eklemek için tıklayın",
      "excludedGroupsTitle": "Hariç tutulan gruplar",
      "excludedGroupsDescription": "Grup paylaşımları zorunlu son kullanma tarihinden muaf tutulabilir. Hiçbiri, tüm gruplar veya belirli gruplar seçin. Kullanıcının muaf bir gruba üyeliği, kullanıcı paylaşımlarını muaf tutmaz.",
      "excludedGroupsModeNone": "Muaf grup yok",
      "excludedGroupsModeAll": "Tüm gruplar muaf",
      "excludedGroupsModeSome": "Yalnızca seçilen gruplar muaf",
      "excludedGroupsPlaceholder": "Muaf grupları seçin",
      "excludedGroupsExceptionsTitle": "Hâlâ tabi olan gruplar",
      "excludedGroupsExceptionsPlaceholder": "Hâlâ son kullanma tarihi gerektiren grupları seçin",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Maksimum paylaşım süresi sınırını yalnızca belirli etiketlere sahip dosyalara uygular.",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir"
    },
    "fileTagManagement": {
      "title": "Etiket kaldırma kuralları",
      "description": "Dosyalardan hangi etiketlerin kaldırılamayacağını tanımlayın. Bir kurala tabi kullanıcılar seçili etiketleri dosyalardan kaldıramaz; kurala kullanıcı veya grup bazında istisnalar tanınabilir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların, yönetici tarafından tanımlanan etiket kaldırma kısıtlamalarına tabi olup olmayacağını kontrol edin. Dosyalardaki mevcut etiketler değişmeden kalacak ve izin güncellemeleri önceden uygulanan etiketleri etkilemeyecektir.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan kullanıcıları belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Dosyalardan kaldırılamayan etiketler. Tüm etiketleri korumak için boş bırakın.",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir"
    },
    "fileTagAdditionRestriction": {
      "title": "Etiket ekleme kuralları",
      "description": "Dosyalara hangi etiketlerin eklenemeyeceğini tanımlayın. Bir kurala tabi kullanıcılar seçili etiketleri dosyalara ekleyemez; kurala kullanıcı veya grup bazında istisnalar tanınabilir.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan kullanıcıları belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Dosyalara eklenemeyen etiketler. Tüm etiketleri kısıtlamak için boş bırakın.",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir"
    },
    "externalFileSharingRestriction": {
      "title": "Harici paylaşım kısıtlamaları",
      "description": "Bu bölüm, yöneticilerin, katkıda bulunanların kuruluş dışında dosya paylaşıp paylaşamayacağına ve hangi koşullar altında paylaşabileceğine karar vermesine olanak tanır. Paylaşım tamamen etkinleştirilebilir, devre dışı bırakılabilir veya belirli güvenilir alanlarla sınırlandırılabilir. Kurallar ayrıca dosya etiketlerine dayalı olarak harici paylaşımı kısıtlayabilir veya belirli gönderen ve alıcıların Veri Kaybını Önleme (DLP) politikalarını atlamasına izin verebilir. Bu kontroller, gizli bilgilerin güvenliğinin sağlanmasına yardımcı olur ve harici işbirliklerinin yalnızca onaylı taraflarla gerçekleşmesini sağlar.",
      "descriptionInternal": "Bu bölüm, yöneticilerin, katkıda bulunanların kuruluş dışında dosya paylaşıp paylaşamayacağına ve hangi koşullar altında paylaşabileceğine karar vermesine olanak tanır. Paylaşım tamamen etkinleştirilebilir, devre dışı bırakılabilir veya belirli güvenilir alanlarla sınırlandırılabilir. Kurallar ayrıca dosya etiketlerine dayalı olarak harici paylaşımı kısıtlayabilir veya belirli gönderen ve alıcıların Veri Kaybını Önleme (DLP) politikalarını atlamasına izin verebilir. Bu kontroller, gizli bilgilerin güvenliğinin sağlanmasına yardımcı olur ve harici işbirliklerinin yalnızca onaylı taraflarla gerçekleşmesini sağlar.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan üyeleri belirtin.",
      "approvedDomainsTitle": "Yalnızca Onaylanan Alan Adları",
      "approvedDomainsDescription": "Paylaşımı önceden onaylanmış alan adlarının listesiyle sınırlar.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Yalnızca belirli etiketlere sahip dosyalar için harici alan adlarıyla paylaşıma izin verir.",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir",
      "approvedDomainsPlaceholder": "Onaylanmış alan adı yok, eklemek için tıklayın"
    },
    "secureFileLocalAccess": {
      "title": "Güvenli yerel dosya erişimi",
      "description": "Dosyalara güvenli yerel erişimi kontrol edin. Bu, hangi dosyalara yerel olarak erişilebileceğini belirtmenize olanak tanır.",
      "descriptionInternal": "Bu ayar, belgelerin aracı aracılığıyla yerel olarak (Windows veya macOS'ta) güvenli ve şifreli bir şekilde nasıl açılacağını tanımlar. Kullanıcı gerekli izinlere sahipse, korunan dosyaları yetkili uygulamalarla açarak Veri Kaybını Önleme politikalarına uyum sağlayabilir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan üyeleri belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir",
      "restrictionsTitle": "Kısıtlamalar",
      "restrictionsDescription": "Korumalı belgelere erişirken hangi kullanıcı eylemlerinin sınırlandırılacağını tanımlayın:",
      "restrictCopyPaste": "Kopyala-Yapıştır İşlemlerini Kısıtla",
      "restrictCopyPasteDescription": "Belirli etiketlere sahip dosyalar için kopyala-yapıştır işlemlerini kısıtlayın.",
      "restrictPrint": "Yazdırmayı Kısıtla",
      "restrictPrintDescription": "Belirli etiketlere sahip dosyalar için yazdırmayı kısıtlayın.",
      "restrictAppInternetAccess": "Uygulama İnternet Erişimini Kısıtla",
      "restrictAppInternetAccessDescription": "Belirli etiketlere sahip dosyalar için uygulamanın internet erişimini kısıtlayın.",
      "restrictScreenCapture": "Ekran Görüntüsünü Kısıtla",
      "restrictScreenCaptureDescription": "Belirli etiketlere sahip dosyalar için ekran görüntüsünüı kısıtlayın.",
      "localAccessSettingsTitle": "Yerel Erişim Ayarları",
      "localAccessSettingsDescription": "Kullanıcıların cihazlarında korumalı dosyaları nasıl açabileceklerini ve bunlarla nasıl çalışabileceklerini yapılandırın:",
      "defaultLocalFileOpen": "Varsayılan Yerel Dosya Açma",
      "defaultLocalFileOpenDescription": "Korunan dosyaların varsayılan uygulamayla mı yoksa 'İzin Verilen Uygulamalar' alanında belirtilen uygulamayla mı açılacağını seçin.",
      "allowedApplicationsTitle": "İzin Verilen Uygulamalar",
      "allowedApplicationsDescription": "Korunan dosyaları açmasına izin verilen uygulamaları seçin.",
      "offlineMode": "İnternet bağlantısı olmadığında dosya erişimini etkinleştirir",
      "offlineModeDescription": "Sertifikanın yerel olarak saklanması, dosyaların çevrimdışı şifresinin çözülmesine olanak tanır. Yerel kullanıcının depolanan sertifikaya erişimi varsa dosya içerikleri açığa çıkabilir"
    },
    "tagBasedAccessControl": {
      "title": "Etikete dayalı erişim kontrolü",
      "description": "İsteğe bağlı okuma/yazma hakları ve parola korumasıyla tüm kullanıcılara veya harici konuklara görünürlük sağlayan etiketlerle (ör. Genel) belge erişimini yönetin.",
      "descriptionInternal": "Arama ve politika yönetimini basitleştirmek için kullanıcı veya grup etiketlerini kullanarak belge erişimini kontrol edin. Etiketler (Genel gibi), isteğe bağlı okuma veya okuma/yazma izinleri ve parola korumasıyla tüm kayıtlı kullanıcılara (Dahili Genel) veya harici, kimliği doğrulanmamış kullanıcılara (Herkes) daha geniş görünürlük sağlamak için uygulanabilir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan üyeleri belirtin.",
      "audienceTitle": "Hedef Kitle",
      "audienceDescription": "Etiketli belgelere kimlerin erişmesine izin verileceğini tanımlayın.",
      "registeredUsers": "Kayıtlı Kullanıcılar",
      "unregisteredUsers": "Kayıtlı Olmayan Kullanıcılar",
      "admin": "Yönetici",
      "contributors": "Katkıda Bulunanlar",
      "readers": "Okuyucular",
      "external": "Harici",
      "readAndWrite": "Okuma ve Yazma",
      "readOnly": "Salt Okunur",
      "passwordRequired": "Erişim için şifre gerektir",
      "setLinkExpiration": "Bağlantının geçerlilik süresini ayarla (tarih/saat)",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Yalnızca belirli etiketlere sahip dosyalar için harici alan adlarıyla paylaşıma izin verir.",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir",
      "accessPolicyTagsRequired": "Erişim politikası etiketleri gerekli"
    },
    "contributorStorageLimit": {
      "title": "Depolama sınırlamaları",
      "allocationTitle": "Katılımcı Depolama Tahsisi",
      "allocationDescription": "Dosyaları yüklemek ve paylaşmak için katkıda bulunanların kullanabileceği depolama alanını tanımlayın. Bu seçenek, katkıda bulunanlar için belirli depolama sınırları belirlemenize veya şirket tarafından lisansı kapsamında satın alınan toplam alana bağlı depolama için \"Lisansla Sınırlı\"yı seçmenize olanak tanır."
    },
    "deviceAccessLimitation": {
      "title": "Eşzamanlı bağlantıları yönetme",
      "browsersTitle": "Tarayıcılar",
      "browsersDescription": "Her üyenin web uygulamasını kullanarak farklı tarayıcılar aracılığıyla Filegrant Enterprise'a yapabileceği eşzamanlı bağlantı sayısını ayarlayın",
      "exceedingConnectionsTitle": "Bağlantı Aşımı",
      "exceedingConnectionsDescription": "Bağlı tarayıcıların sayısı izin verilen sınırı aştığında gerçekleştirilecek eylemi belirtin.",
      "invalidateOldSessionsOption": "En eski bağlantıların oturum belirtecini otomatik olarak geçersiz kılın.",
      "blockAccessOption": "Eski oturumların bağlantısı manuel olarak kesilene veya süresi dolana kadar erişimi reddedin."
    },
    "editorFileManagement": {
      "title": "Editör dosya yönetimi",
      "subtitle": "Katkıda bulunanların, hesaplarındaki dosya ve klasörleri silme ve yeniden adlandırma izinlerini kontrol edin. Seçenekler arasında, tüm katkıda bulunanlara izin verilmesi veya hiçbirine izin verilmemesi yer alır; eylemler, düzenleyici erişimiyle yükledikleri veya aldıkları dosyalarla sınırlıdır.",
      "deletionPermissionsTitle": "Silme İzinleri",
      "deletionPermissionsDescription": "Katkıda bulunanların dosyaları silip silemeyeceğini kontrol edin. Seçenekler arasında, katkıda bulunanların editör erişimiyle yükledikleri veya aldıkları dosyaları silmelerine izin verme veya vermeme yer alır.",
      "userScopeTitle": "Kullanıcı Kapsamı",
      "userScopeDescription": "Yukarıdaki izinlerin tüm katkıda bulunanlara veya hiçbirine uygulanmasını kontrol edin.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki izinlerin istisnası olan kullanıcıları belirtin. Bu kullanıcılar, genel ayarlara bakılmaksızın dosya ve klasörleri silmek ve yeniden adlandırmak için özelleştirilmiş erişime sahip olacaktır."
    },
    "fileSizeLimit": {
      "title": "Üye başına dosya boyutu sınırı",
      "limitTitle": "Dosya Boyutu Sınırlaması",
      "limitDescription": "Üyelerin yükleyebileceği maksimum dosya boyutunu tanımlayın. Bu ayar, herhangi bir üye tarafından platforma eklenebilecek en büyük dosya boyutunu kontrol etmenize olanak tanıyarak, depolama alanının verimli kullanımını sağlar ve optimum performansı korur."
    },
    "quickShareMode": {
      "title": "Hızlı paylaşım",
      "description": "Hızlı Paylaşım ayarlarını yönetin. Etkinleştirmeyi, oturum açtıktan sonra otomatik açmayı ve maksimum paylaşım süresini kontrol edin.",
      "isVisibleTitle": "Görünür",
      "isVisibleDescription": "Kullanıcılar için Hızlı Paylaşımı etkinleştirme veya devre dışı bırakma",
      "activeForAllTitle": "Hızlı Paylaşım erişimi",
      "activeForAllDescription": "Hızlı Paylaşımın tüm kullanıcılara mı yoksa hiçbir kullanıcıya mı sunulacağını seçin.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kuralın istisnası olan üyeleri belirtin.",
      "showQuickShareByDefaultTitle": "Hızlı Paylaşımı varsayılan olarak göster",
      "showQuickShareByDefaultDescription": "Oturum açtıktan sonra Hızlı Paylaşımı varsayılan açılış sayfası yapın",
      "maxSharingDaysTitle": "Maksimum paylaşım süresi (gün)",
      "maxSharingDaysDescription": "Paylaşımın kaç gün süreceğini ayarlayın. Paylaşımlar seçilen gün sayısından (maksimum 365) sonra otomatik olarak sona erer",
      "enabledTitle": "Hızlı Paylaşımı Etkinleştir",
      "enabledDescription": "Etkinleştirildiğinde kullanıcılar, Hızlı Paylaşım aracılığıyla dosyaları paylaşabilir. Devre dışı bırakıldığında Hızlı Paylaşım özelliği kullanılamaz.",
      "daysTitle": "Maksimum paylaşım süresi",
      "daysDescription": "Bu sayıda gün geçtikten sonra paylaşılan dosya bağlantısının süresi dolacak ve paylaşım kaldırılacaktır.",
      "daysOption1": "Son 1 gün paylaşımı",
      "daysOption3": "Son 3 gün paylaşımı",
      "daysOption7": "Son 7 gün paylaşımı",
      "daysOption14": "Son 14 gün paylaşımı",
      "daysOption30": "Son 30 gün paylaşımı",
      "daysOption90": "Son 90 gün paylaşımı"
    },
    "totpRequired": {
      "title": "İki faktörlü kimlik doğrulama (TOTP)",
      "description": "Şirket çapında TOTP 2FA'yı yapılandırın. Tüm kullanıcılar için TOTP'yi zorunlu kılın, yeni hesaplar için bir yetkisiz kullanım süresi belirleyin ve yöneticilerin kullanıcı TOTP'sini sıfırlamasına izin verin.",
      "requiredTitle": "Tüm kullanıcılar için TOTP'yi zorunlu kılın",
      "requiredDescription": "Etkinleştirildiğinde tüm kullanıcıların TOTP'yi kurması gerekir. Yeni kullanıcılara, hesap oluşturulduktan sonra bu özelliği etkinleştirmek için ek süre tanınır.",
      "gracePeriodDaysTitle": "Ek süre (gün)",
      "gracePeriodDaysDescription": "Kullanıcıların, oturum açmanın engellenmesinden önce, hesap oluşturma işleminden TOTP'yi etkinleştirmeye kadar bu kadar günleri vardır.",
      "allowAdminResetTitle": "Yöneticilerin kullanıcı TOTP'sini sıfırlamasına izin ver",
      "allowAdminResetDescription": "Etkinleştirildiğinde yöneticiler, kimlik doğrulama uygulamasına erişimi kaybeden kullanıcılar için TOTP'yi devre dışı bırakabilir.",
      "maxExemptionDaysTitle": "Maksimum muafiyet günleri",
      "maxExemptionDaysDescription": "Bir yöneticinin geçici TOTP muafiyeti vermesi durumunda maksimum gün sayısı (1-365). Varsayılan 30.",
      "allowPermanentExemptionTitle": "Kalıcı Muafiyete İzin Ver",
      "allowPermanentExemptionDescription": "Etkinleştirildiğinde yöneticiler kalıcı TOTP muafiyetleri verebilir (süresi sona ermez). Devre dışı bırakıldığında yalnızca geçici muafiyetlere izin verilir.",
      "gracePeriodOption0": "Ek süre yok (hemen)",
      "gracePeriodOption1": "1 gün",
      "gracePeriodOption3": "3 gün",
      "gracePeriodOption7": "7 gün (önerilen)",
      "gracePeriodOption14": "14 gün",
      "gracePeriodOption30": "30 gün"
    },
    "passkeySettings": {
      "allowAdminRemoveDescription": "Etkinleştirildiğinde yöneticiler, yönetici araçlarından bireysel geçiş anahtarlarını kaldırabilir veya bir kullanıcının tüm geçiş anahtarlarını temizleyebilir.",
      "allowAdminRemoveTitle": "Yöneticilerin kullanıcı şifrelerini kaldırmasına izin ver",
      "allowAs2faDescription": "Etkinleştirildiğinde, e-posta OTP'sini tamamlayan kullanıcılar, kayıt ve diğer politikalara bağlı olarak TOTP yerine bir geçiş anahtarıyla oturum açmayı tamamlayabilir.",
      "allowAs2faTitle": "İkinci faktör olarak geçiş anahtarlarına izin verin",
      "allowPasswordlessDescription": "Etkinleştirildiğinde, uygun kullanıcılar e-posta OTP'si olmadan bir şifre anahtarıyla oturum açabilir. İzin verilmesi için ikinci bir faktör olarak geçiş anahtarlarını gerektirir.",
      "allowPasswordlessTitle": "Şifresiz şifre anahtarıyla oturum açmaya izin ver",
      "attestationOptionDirect": "Doğrudan",
      "attestationOptionIndirect": "Dolaylı",
      "attestationOptionNone": "Yok (çoğu kuruluş için tipik)",
      "attestationPreferenceDescription": "Sunucunun kayıt sırasında ne kadar güçlü bir şekilde onay istediğini belirtir. Daha yüksek düzeyler güvenceyi artırabilir ancak kimlik doğrulayıcı uyumluluğunu azaltabilir.",
      "attestationPreferenceTitle": "Onay tercihi",
      "authenticatorAttachmentAny": "Herhangi biri (kısıtlama yok)",
      "authenticatorAttachmentCrossPlatform": "Platformlar arası (ör. güvenlik anahtarı)",
      "authenticatorAttachmentDescription": "İsteğe bağlı olarak kaydı bu cihazdaki platform kimlik doğrulayıcılarıyla ve platformlar arası güvenlik anahtarlarıyla sınırlayın veya en geniş uyumluluk için kısıtlamasız bırakın.",
      "authenticatorAttachmentPlatform": "Platform (bu cihaz)",
      "authenticatorAttachmentTitle": "Kimlik doğrulayıcı eki (isteğe bağlı)",
      "description": "Kuruluş çapında geçiş anahtarlarını (WebAuthn) yapılandırın: etkinleştirme, ikinci faktör ve parolasız oturum açma, kullanıcı başına sınırlar, yönetici kaldırma ve kayıt töreni tercihleri.",
      "enabledDescription": "Devre dışı bırakıldığında, bu politika kapsamındaki kullanıcılar için ortak anahtar kaydı ve ortak anahtara dayalı oturum açma kullanılamaz.",
      "enabledTitle": "Kuruluş için şifre anahtarlarını etkinleştirin",
      "maxCredentialsPerUserDescription": "Her kullanıcının kaydedebileceği maksimum geçiş anahtarı sayısı (1-50). Yayılmayı sınırlar ve yükü destekler.",
      "maxCredentialsPerUserTitle": "Kullanıcı başına maksimum şifre anahtarı",
      "title": "Geçiş anahtarları (WebAuthn)",
      "userVerificationDescription": "Şifre anahtarı kaydı sırasında kimlik doğrulayıcının kullanıcıyı ne kadar sıkı bir şekilde doğrulaması gerektiği. Gerekli olan en katı olanıdır; cesareti kırılmış en zayıf olanıdır.",
      "userVerificationOptionDiscouraged": "Cesareti kırıldı",
      "userVerificationOptionPreferred": "Tercih edilen",
      "userVerificationOptionRequired": "Gerekli",
      "userVerificationTitle": "Kayıt için kullanıcı doğrulaması"
    },
    "antivirusScan": {
      "title": "Antivirüs taraması",
      "description": "Hangi yüklenen dosya türlerinin antivirüs motoru tarafından taranacağını yapılandırın. Uzantı filtresi maliyeti kontrol eder, güvenlik politikasını değil.",
      "enabledTitle": "Antivirüs taramasını etkinleştir",
      "enabledDescription": "Etkinleştirildiğinde eşleşen yüklemeler eşzamansız taranır. Devre dışı bırakıldığında yeni yüklemeler taranmaz; mevcut tarama sonuçları dosyalarda kalır.",
      "extensionsTitle": "Taranan dosya uzantıları",
      "extensionsDescription": "Yalnızca listelenen uzantıya sahip dosyalar tarayıcıya gönderilir. Tarama hacmini ve maliyetini azaltmak için listeyi daraltın.",
      "extensionsPlaceholder": "Taranacak uzantıları seçin",
      "costNoticeTitle": "Uzantı filtresi maliyeti kontrol eder",
      "costNoticeDescription": "Daha fazla uzantı taramak antivirüs kullanımını artırır. Bu ayar diğer güvenlik kontrollerinin yerini tutmaz.",
      "saveError": "Antivirüs tarama ayarları geçersiz. Taramayı yalnızca en az bir uzantı seçiliyken etkinleştirin.",
      "stickyInfectedNote": "Taramayı kapatmak mevcut enfekte sonuçları temizlemez ve dosyaları karantinadan kaldırmaz."
    },
    "activityLogRetention": {
      "title": "Etkinlik günlüğü saklama",
      "description": "Şirketin etkinlik günlüğünü ne kadar süre saklayacağını belirler. Bir kaydın oluşturulmasından itibaren saklama süresi geçtiğinde kayıt kalıcı olarak silinir.",
      "activeTitle": "Saklama politikası",
      "activeDescription": "Devre dışı bırakıldığında etkinlik günlüğü süresiz olarak saklanır ve hiçbir kayıt silinmez.",
      "windowTitle": "Saklama süresi",
      "windowDescription": "Bu süreden daha eski günlük kayıtları kalıcı olarak silinir. İzin verilen aralık: {{min}} aydan {{max}} yıla kadar.",
      "warningTitle": "Silme işlemi kalıcı ve geçmişe dönüktür",
      "warningDescription": "Politikayı etkinleştirmek, saklama süresini zaten aşmış olan kayıtları da siler. Silinen kayıtlar geri getirilemez: bir kopya saklamanız gerekiyorsa önce etkinlik günlüğünü dışa aktarın."
    },
    "securityAnalysis": {
      "title": "Executive Report & Security Notification",
      "description": "Executive Report (dahili alan adları, risk göstergesi eşikleri), güvenlik anomalisi tespit eşikleri ve tespit edilen anomaliler için e-posta bildirimlerinin tek yapılandırması.",
      "enableTitle": "E-posta bildirimlerini etkinleştir",
      "enableDescription": "Etkinleştirildiğinde, seçilen önem düzeyi ve üzerindeki yeni güvenlik anomalileri için seçili alıcılara bir e-posta gönderilir.",
      "recipientsTitle": "Alıcılar",
      "recipientsDescription": "Bildirimleri alacak platform kullanıcıları ve grupları. Gruplar için tüm üyeler bilgilendirilir.",
      "recipientsPlaceholder": "Kullanıcı veya grup ara",
      "minSeverityTitle": "Minimum önem düzeyi",
      "minSeverityDescription": "Bildirimleri yalnızca bu önem düzeyinden itibaren gönder. Warning, Warning ve Critical içerir; Critical yalnızca Critical gönderir.",
      "severityWarning": "Warning ve üzeri",
      "severityCritical": "Yalnızca Critical",
      "domainsTitle": "Dahili alan adları",
      "domainsDescription": "Executive Report dahili ve harici paylaşımları ayırt ederken dahili kabul edilen, virgülle ayrılmış e-posta alan adları listesi. Boşsa, ilk yöneticinin e-posta alan adı kullanılır.",
      "domainsPlaceholder": "sirket.com, istirak.com",
      "domainsError": "Bir veya daha fazla alan adı geçerli bir biçimde değil (örn. sirket.com).",
      "thresholdsTitle": "Risk göstergesi eşikleri",
      "thresholdsDescription": "Executive Report'un her risk göstergesi için neyin warning, neyin critical sayılacağını tanımlayan yüzde eşikleri.",
      "warningLabel": "Warning ≥",
      "criticalLabel": "Critical ≥",
      "thresholdError": "Warning eşiği critical eşiğinden düşük olmalıdır.",
      "detectorThresholdsTitle": "Anomali tespit eşikleri",
      "detectorThresholdsDescription": "Her güvenlik anomalisi dedektörü için neyin warning, neyin critical sayılacağını tanımlayan olay sayıları. Sayısal eşiği olmayan dedektörler (engellenen yönetici IP'si, açık güvenlik sinyalleri) özelleştirilemez.",
      "detectorThresholdError": "Warning eşiği critical eşiğinden düşük olmalıdır.",
      "detectors": {
        "bruteForceLogin": "Aynı hesapta başarısız oturum açmalar (15 dk pencere)",
        "folderPassword": "Başarısız klasör parolası denemeleri (klasör ve kullanıcı başına)",
        "publicLinkBruteForce": "Genel bağlantılara başarısız erişimler (bağlantı ve IP başına)",
        "massDownload": "Bir kullanıcının indirdiği dosyalar (60 dk pencere)",
        "passwordSpray": "Password spray: bir IP'den denenen farklı hesaplar",
        "unauthorizedCountry": "Yetkisiz ülkeden engellenen erişimler (kullanıcı ve ülke başına)"
      }
    },
    "ipRegionRestriction": {
      "title": "IP/bölge kısıtlaması",
      "description": "Platform erişimini IP adresine, ülkeye veya bölgeye göre kısıtlayın",
      "warningMessage": "Uyarı: Bu ayar, ölçütlere uymayan tüm kullanıcıları engeller",
      "warningDescription": "İzin verilen IP'lerin, ülkelerin veya bölgelerin dışındaki kullanıcıların erişimi reddedilecektir. Belirli kullanıcılar veya gruplar için istisnaları yapılandırın.",
      "confirmTitle": "Yapılandırmayı Onayla",
      "confirmWarning": "Bu yapılandırma erişimi kısıtlayacaktır. İzin verilen IP'lerin, ülkelerin veya bölgelerin dışındaki kullanıcıların erişimi reddedilecektir. Emin misin?",
      "scopeTitle": "Uygulama Kapsamı",
      "scopeDescription": "Bu kısıtlama ne zaman uygulanmalı?",
      "scopeLogin": "Yalnızca Giriş Yap",
      "scopeFileOps": "Yalnızca Dosya İşlemleri",
      "scopeBoth": "Her ikisi de (Önerilen)",
      "allowedIpsTitle": "İzin Verilen IP Adresleri / CIDR Aralıkları",
      "allowedIpsDescription": "IP'lerin veya CIDR aralıklarının virgülle ayrılmış listesi (IPv4/IPv6)",
      "allowedCountriesTitle": "İzin Verilen Ülkeler",
      "allowedCountriesDescription": "Ülkeleri seçin (ISO 3166-1 alpha-2 kodları)",
      "allowedRegionsTitle": "İzin Verilen Bölgeler",
      "allowedRegionsDescription": "Bölgeleri seçin (ISO 3166-2 kodları veya Avrupa Birliği için 'AB')",
      "allowPrivateNetworksTitle": "Özel Ağlara İzin Ver",
      "allowPrivateNetworksDescription": "Özel IP aralıkları için kısıtlamayı atlama (10.x, 192.168.x, 172.16-31.x)",
      "adminAccessSectionTitle": "Yönetici Erişimi",
      "restrictAdminAccessTitle": "Yönetici ayarlarını IP ile kısıtla",
      "restrictAdminAccessDescription": "Yönetici ayarlarına yalnızca belirtilen IP adreslerinden veya CIDR aralıklarından erişime izin ver",
      "adminAllowedIpsTitle": "İzin verilen yönetici IP adresleri",
      "adminAllowedIpsDescription": "Yöneticilerin ayarlara erişip değiştirebileceği IP adresleri veya CIDR aralıklarının virgülle ayrılmış listesi",
      "addAdminIp": "IP ekle",
      "addAllowedIp": "IP veya CIDR ekle",
      "logBlockedAttemptsTitle": "Engellenen Denemeleri Günlüğe Kaydet",
      "logBlockedAttemptsDescription": "Tüm erişim reddetme girişimlerini etkinlik günlüğüne kaydedin",
      "blockedMessageTitle": "Özel Engellenen Mesaj",
      "blockedMessageDescription": "Engellenen kullanıcılara gösterilen mesaj (en fazla 200 karakter)",
      "blockedMessagePlaceholder": "Bulunduğunuz yerden erişim reddedildi.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Ek erişim kriterlerine sahip kullanıcılar veya gruplar",
      "validationAtLeastOne": "En az bir kriter (IP, ülke veya bölge) belirtilmelidir",
      "validationInvalidIp": "Geçersiz IP/CIDR biçimi: {{entries}}",
      "validationInvalidCountry": "Geçersiz ülke kodları: {{codes}}",
      "validationInvalidRegion": "Geçersiz bölge kodları: {{codes}}",
      "adminAllowedIpsHelper": "Yalnızca IP/CIDR: coğrafi konum yok, özel ağ atlaması yok ve yukarıdaki istisnalar burada geçerli değildir."
    },
    "fileTypeRestriction": {
      "title": "Dosya türü kısıtlama kontrolü",
      "description": "Hangi dosya türlerinin yükleme için engelleneceğini belirtmenize olanak tanır.",
      "blockedExtensionsTitle": "Dosya Uzantıları Engellendi",
      "blockedExtensionsDescription": "Hangi dosya uzantılarının engellendiğini belirtin. Bu, tam olarak hangi dosya türlerinin kısıtlamalara tabi olduğunu tanımlamanıza olanak tanır.",
      "userScopeTitle": "Kullanıcı Kapsamı",
      "userScopeDescription": "Yukarıda tanımlanan belirtilen dosya türlerine göre kullanıcıların platforma dosya yüklemesinin veya paylaşmasının engellenip engellenmeyeceğini kontrol edin. Seçenekler arasında tüm kullanıcıların engellenmesi veya hiçbirinin engellenmesi yer alır. Yüklenen veya paylaşılan mevcut dosyalar, izin daha sonra iptal edilse bile etkin kalacaktır.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, uygulandıkları koşulları ve izin verilen istisnaları tanımlayabilir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki kısıtlamaların istisnası olan kullanıcıları belirtin.",
      "showUsers": "Başkaları tarafından zaten erişim izni verilmiş kullanıcıları göster.",
      "allowEdit": "Kullanıcıların mevcut paylaşım ayarlarını değiştirmesine, geçersiz kılmasına veya silmesine olanak tanır.",
      "readOnly": "Salt okunur (Görüntüleyici) erişimi olan kullanıcılar tarafından dosya paylaşımını etkinleştirin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın.",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "fileTypesTitle": "Dosya Türleri",
      "fileTypesDescription": "Bu kurala tabi olan dosya türlerini tanımlayın.",
      "fileTypesPlaceholder": "Dosya türlerini veya uzantılarını seçin"
    },
    "folderCreationPermission": {
      "title": "Klasör sınırlamaları",
      "creationTitle": "Katılımcı Klasörü Oluşturma",
      "creationDescription": "Hangi katkıda bulunanların platformda klasör oluşturabileceğini kontrol edin. Seçenekler arasında tüm katkıda bulunanlara izin verilmesi veya hiçbirine izin verilmemesi yer alır. İzin daha sonra iptal edilse bile mevcut klasörler erişilebilir durumda kalır.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin."
    },
    "groupCreationControl": {
      "title": "Grup sınırlamaları",
      "creationTitle": "Katılımcı Grubu Oluşturma",
      "creationDescription": "Hangi katkıda bulunanların platformda grup oluşturabileceğini kontrol edin. Seçenekler arasında tüm katkıda bulunanlara izin verilmesi veya hiçbirine izin verilmemesi yer alır. Oluşturulan gruplar yalnızca onları oluşturan kullanıcı tarafından görülebilir. İzin daha sonra iptal edilse bile mevcut gruplara erişilebilir durumda kalır.",
      "exceptionHandlingTitle": "İstisna İşleme ",
      "exceptionHandlingDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin."
    },
    "publicAccessLink": {
      "title": "Genel erişim bağlantısı",
      "description": "Katkıda bulunanların, kimlik doğrulaması olmadan dosya ve klasörlere erişim için bağlantılar oluşturma yeteneğini kontrol edin. Seçenekler arasında tüm üyelerin bu bağlantıları oluşturmasına izin verilmesi veya hiçbirinin bu bağlantıları oluşturmasına izin verilmesi yer alır. İzin daha sonra iptal edilse bile mevcut bağlantılar etkin kalacaktır.",
      "activeForAllTitle": "Katılımcı Bağlantısı Oluşturma",
      "activeForAllDescription": "Katkıda bulunanların, kimlik doğrulaması olmadan dosya ve klasörlere erişim için bağlantılar oluşturma yeteneğini kontrol edin. Seçenekler arasında tüm üyelerin bu bağlantıları oluşturmasına izin verilmesi veya hiçbirinin bu bağlantıları oluşturmasına izin verilmesi yer alır. İzin daha sonra iptal edilse bile mevcut bağlantılar etkin kalacaktır.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki bağlantı oluşturma izinlerinin istisnası olan katkıda bulunanları belirtin.",
      "forcePasswordTitle": "Parola Zorunluluğu",
      "forcePasswordDescription": "Etkinleştirildiğinde, kullanıcının genel bağlantı oluştururken bir parola belirlemesi gerekir.",
      "mandatoryMaxAccessCountTitle": "Zorunlu Maksimum Erişim Sayısı",
      "mandatoryMaxAccessCountDescription": "0'dan büyükse kullanıcının maksimum erişim sayısını (0–10000) belirtmesi gerekir. 0 gerekli olmadığı anlamına gelir.",
      "maxExpirationDaysTitle": "Maksimum Son Kullanma Günleri",
      "maxExpirationDaysDescription": "0'dan büyükse kullanıcının bu sayıda gün (0-365) içinde bir süre sonu ayarlaması gerekir. 0 kısıtlamanın olmadığı anlamına gelir. <br /> <DangerText> \"Zorunlu Sona Erme Paylaşılan Dosyası\" etkinleştirilirse, söz konusu ayarda tanımlanan son kullanma tarihi, burada yapılandırılan maksimum son kullanma tarihinden önce gelecektir. </DangerText>",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Genel bağlantılar yalnızca bu etiketlere sahip dosyalar için oluşturulabilir."
    },
    "sessionControl": {
      "title": "Eşzamanlı oturum limiti",
      "description": "Kullanıcı başına etkin oturum sayısını sınırlayın. Kullanıcı limiti aştığında en eski oturum otomatik olarak sonlandırılır.",
      "maxSessionsTitle": "Maksimum Oturum Sayısı",
      "maxActiveSessions": "Maksimum aktif oturum",
      "maxSessionsDescription": "Kullanıcı başına izin verilen maksimum eşzamanlı oturum sayısını ayarlayın. Limite ulaşıldığında en eski oturumun bağlantısı otomatik olarak kesilecektir.",
      "unlimited": "Sınırsız",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Belirli kullanıcılar veya gruplar için oturum sınırını geçersiz kılın.",
      "pendingExceptionsTitle": "Bekleyen istisnalar",
      "savedExceptionsTitle": "Kaydedilen istisnalar",
      "selectUsersOrGroups": "Kullanıcıları veya grupları seçin..."
    },
    "uploadWithTag": {
      "title": "Otomatik etiket yönetimi",
      "description": "Filegrant Enterprise, yüklenen sınıflandırılmış dosyaların meta verilerini belirli anahtar kelimelere göre tarayacaktır. Belirtilen anahtar kelimelerden herhangi biri tespit edilirse karşılık gelen değer dosyaya etiket olarak uygulanacaktır. Platformda halihazırda bir etiket yoksa otomatik olarak oluşturulur. Bu işlem, her dosyanın içeriğine göre uygun şekilde kategorize edilmesini ve etiketlenmesini sağlar.",
      "keywordsTitle": "Anahtar Kelimeler",
      "keywordsDescription": "Yüklemeden sonra değerleri dosya için etiket olarak kullanılacak anahtar kelimeleri belirtin.",
      "userScopeTitle": "Kullanıcı Kapsamı",
      "userScopeDescription": "Üyelerin platformdaki dosya yüklemelerinde otomatik etiket tespitine tabi olup olmayacağını kontrol edin. Seçenekler arasında bunun tüm üyelere uygulanması veya hiçbirine uygulanması yer alır. Halihazırda yüklenmiş ve etiketlenmiş mevcut dosyalar etkin kalacak ve anahtar sözcüklerde yapılan değişiklikler, önceden etiketlenen bu dosyaları etkilemeyecektir.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin."
    },
    "watermarkProtection": {
      "title": "Filigran koruması",
      "description": "Paylaşılan dosyalar için filigran korumasını kontrol edin. Tüm üyeler için etkinleştirin veya hiçbiri için etkinleştirin, istisnaları yönetin ve filigranda hangi verilerin görüneceğini yapılandırın (ör. paylaşım tarihi, sahip, alıcı, oluşturulma tarihi, IP).",
      "descriptionInternal": "Paylaşılan dosyalar için filigran korumasını kontrol edin. Tüm üyeler için etkinleştirin veya hiçbiri için etkinleştirin, istisnaları yönetin ve filigranda hangi verilerin görüneceğini yapılandırın (ör. paylaşım tarihi, sahip, alıcı, oluşturulma tarihi, IP). <DangerText>Şu anda filigranlar PDF dosyalarına ve görüntülere (jpeg, png, svg) uygulanır ve yalnızca Office dosyasını (doc, docx, ppt, pptx, xls, xlsx) salt okunur modda alan alıcılar için geçerlidir.</DangerText>",
      "enabledTitle": "Etkinleştirilmiş",
      "enabledDescription": "Bu ayarı açın veya kapatın.",
      "userScopeTitle": "Kullanıcı Kapsamı",
      "userScopeDescription": "Üyelerin dosyalarını filigranlarla korumasına izin verin. Seçenekler arasında bu özelliğin tüm üyeler için etkinleştirilmesi veya hiçbiri için etkinleştirilmesi yer alır. Filigranlar paylaşım sırasında uygulanabilir. Alıcılar belgeyi açtığında filigran, alıcıların e-posta adresini, IP adresini ve belgeye erişim tarihini görüntüleyerek içeriğin korunmasını ve izlenmesini sağlar.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Filigran korumasını tüm üyelere uygulayın veya hiçbirine uygulayın. Hiçbiri olarak ayarlandığında, istisnalar ve etiketler aracılığıyla belirli üyeleri hâlâ hedefleyebilirsiniz.",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Filigran korumasını yalnızca bu etiketlere sahip dosyalara uygulayın.",
      "previewTitle": "Önizleme",
      "textLabel": "Filigran metni",
      "repetitionLabel": "Tekrarlama",
      "repetitionSingle": "Tekil",
      "repetitionRepetitive": "Tekrarlayan",
      "fieldsLabel": "Görüntülenecek alanlar",
      "fieldsSharingDate": "Paylaşım tarihi",
      "fieldsOwner": "Sahibi",
      "fieldsRecipient": "Alıcı",
      "fieldsCreationDate": "Oluşturulma tarihi",
      "fieldsIp": "IP adresi",
      "positionXLabel": "Yatay konum",
      "positionYLabel": "Dikey konum",
      "positionLeft": "Sol",
      "positionCenter": "Merkez",
      "positionRight": "Sağ",
      "positionTop": "Tepe",
      "positionMiddle": "Orta",
      "positionBottom": "Alt",
      "positionsLabel": "Konum",
      "positionsTopLeft": "Sol üst",
      "positionsTopCenter": "Üst orta",
      "positionsTopRight": "Sağ üst",
      "positionsBottomLeft": "Sol alt",
      "positionsBottomCenter": "Alt orta",
      "positionsBottomRight": "Sağ alt",
      "positionsDiagonal": "Çapraz (tekrarlanan)",
      "fontSizeLabel": "Yazı tipi boyutu",
      "fontSizeDescription": "1–72",
      "fontColorLabel": "Yazı tipi rengi",
      "opacityLabel": "Opaklık",
      "opacityDescription": "%0–100",
      "textPlaceholderHelp": "Aşağıdaki düğmeler metne yer tutucular ekler. Satır sonları için \\n ve kalın metin için **kalın** karakterini kullanabilirsiniz. Her düğmenin araç ipucu, ne yaptığını açıklar.",
      "placeholderButtonOwner": "Sahibi",
      "placeholderTooltipOwner": "Filigranda {owner}, belge sahibinin adı ile değiştirilir.",
      "placeholderButtonAccessDate": "Tarihi/saati görüntüle",
      "placeholderTooltipAccessDate": "Filigranda {access_date}, belgenin görüntülendiği tarih ve saat ile değiştirilir.",
      "placeholderButtonSharingDate": "Paylaşım tarihi",
      "placeholderTooltipSharingDate": "Filigranda {sharing_date}, bağlantı oluşturma tarihiyle değiştirilir.",
      "placeholderButtonIp": "IP adresi",
      "placeholderTooltipIp": "Filigranda {ip}, izleyicinin IP adresiyle değiştirilir.",
      "placeholderButtonRecipient": "Alıcı",
      "placeholderTooltipRecipient": "Filigranda {recipient} alıcının adı ile değiştirilir.",
      "placeholderButtonOwnerEmail": "Sahip e-postası",
      "placeholderTooltipOwnerEmail": "Filigranda {owneremail}, belge sahibinin e-posta adresiyle değiştirilir.",
      "placeholderButtonRecipientEmail": "Alıcı e-postası",
      "placeholderTooltipRecipientEmail": "Filigranda {recipientemail}, alıcının e-posta adresiyle değiştirilir."
    },
    "remotegrantForceEncryption": {
      "title": "Remotegrant zorunlu şifreleme (lisans gerekli)",
      "description": "Remotegrant'ı kullanarak dosyaları şifreleyin ve yeni oluşturulan üyelere otomatik olarak erişim izinleri atayın."
    },
    "sharingApprovalRequirement": {
      "title": "Paylaşım onay gereksinimleri",
      "description": "Dosya ve klasör paylaşımının önceden onay gerektirip gerektirmediğini kontrol ederek hassas dosyaların dağıtımdan ve uyumluluk sağlanmadan önce incelenmesini sağlar.",
      "descriptionInternal": "Bu bölüm yöneticilerin dosya ve klasör paylaşımının önceden onay gerektirip gerektirmediğini kontrol etmesine olanak tanır. Kurallar evrensel olarak belirli dosya sahipliği türlerine veya sınıflandırma etiketlerine dayalı olarak uygulanabilir. Yöneticiler, hassas dosyaların paylaşılmadan önce incelenmesini sağlayarak uyumluluğun korunmasına, veri sızıntılarının önlenmesine ve kurumsal politikaların uygulanmasına yardımcı olabilir. Onay talepleri belirlenmiş bir süpervizöre veya önceden tanımlanmış bir inceleme ekibine yönlendirilebilir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisna İşleme ",
      "exceptionsDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "reviewTeamTitle": "Ekibi İncele",
      "reviewTeamDescription": "Onay isteklerini inceleyecek ekibi belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir",
      "exceptionHandlingTitle": "İstisna Yönetimi",
      "exceptionHandlingDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "generalApprovalTitle": "Genel Onay Gereksinimi",
      "generalApprovalDescription": "Paylaşıma yalnızca politikada tanımlanan atanmış bir yöneticinin veya ekibin önceden onayı alındıktan sonra izin verilir.",
      "resharingApprovalTitle": "Yalnızca Yeniden Paylaşılan Dosyaların Onayı",
      "resharingApprovalDescription": "Onay gereksinimini yalnızca önceden alınmış ve yeniden paylaşılmakta olan dosyalara uygular.",
      "manageReviewTeam": "İnceleme Ekibini Yönet"
    },
    "mandatoryFileClassification": {
      "title": "Zorunlu dosya sınıflandırması",
      "description": "Hassas dosyaların uygun şekilde etiketlendiğinden ve korunduğundan emin olmak için dosyaların paylaşılmadan önce sınıflandırılmasını zorunlu kılın.",
      "descriptionInternal": "Bu bölüm, dosyaların paylaşılmadan önce uygun şekilde sınıflandırılmasını sağlar. Sınıflandırmayı zorunlu kılarak hassas içeriğin yanlışlıkla veya izinsiz paylaşılmasını önlemeye yardımcı olur ve tutarlı veri yönetimini destekler.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir"
    },
    "forcedFileInvisibility": {
      "title": "Zorunlu dosya gizliliği",
      "description": "Bu özellik, yöneticilerin paylaşım eylemini tamamlarken belirli dosya türlerini alıcılar için görünmez hale getirmesine olanak tanır. Örneğin, düzenlenebilir ana dosyalar olarak kullanılan Office belgeleri paylaşılabilir ancak alıcıya gizli kalarak düzenlenebilir kaynak dosyaların açığa çıkması riskini azaltırken PDF'ler gibi onaylanmış biçimlerin paylaşımına da izin verir.",
      "descriptionInternal": "Bu özellik, yöneticilerin paylaşım eylemini tamamlarken belirli dosya türlerini alıcılar için görünmez hale getirmesine olanak tanır. Örneğin, düzenlenebilir ana dosyalar olarak kullanılan Office belgeleri paylaşılabilir ancak alıcıya gizli kalarak düzenlenebilir kaynak dosyaların açığa çıkması riskini azaltırken PDF'ler gibi onaylanmış biçimlerin paylaşımına da izin verir.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin. Bu ayar, izinlerin kapsamını, bunların uygulanacağı koşulları ve izin verilen istisnaları tanımlayabilir. Kullanıcı etkinliğinin kurumsal politikalarla uyumlu kalmasını sağlarken uygun durumlarda esnekliğe de izin verir.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "fileTypesTitle": "Paylaştıktan Sonra Görünmez",
      "fileTypesDescription": "Paylaşım işlemini tamamlarken belirli dosya türlerini (örneğin, Office belgeleri) alıcılar için görünmez hale getirir.",
      "fileTypesPlaceholder": "Dosya türlerini veya uzantılarını girin (ör. .docx, .xls, .pptx)",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir"
    },
    "shortcutLink": {
      "title": "Kısayol bağlantısı kısıtlaması",
      "description": "Belirlenen etiketleri içeren dosyalar için kısayol bağlantılarının oluşturulmasını kısıtlayın.",
      "descriptionInternal": "Belirlenen etiketleri içeren dosyalar için kısayol bağlantılarının oluşturulmasını kısıtlayın.",
      "activeForAllTitle": "Kullanıcı Kapsamı",
      "activeForAllDescription": "Kullanıcıların yönetici tarafından belirlenen kısıtlamalara tabi olup olmadığını kontrol edin.",
      "exceptionsTitle": "İstisnalar",
      "exceptionsDescription": "Yukarıdaki özelliğin istisnası olan kullanıcıları belirtin.",
      "tagsTitle": "Etiketler",
      "tagsDescription": "Bu kuralları yalnızca belirli etiketlere sahip dosyalara uygulayın",
      "tagsRequired": "Birden fazla kural olduğunda en az bir etiket gereklidir",
      "exceptionsRequiredForTags": "Etiketleri ayarlamak için istisnalar gereklidir"
    },
    "adminSettingsPermissions": {
      "title": "Yönetici ayarları izinleri",
      "description": "Yöneticinin platform ayarlarına erişimini kısıtlar",
      "deniedSettingsUserTitle": "Yönetici Kapsamı",
      "deniedSettingsUserDescription": "Ayarlara erişimi reddedilecek yöneticiyi seçin.",
      "deniedSettingsTitle": "Reddedilen Ayarlar",
      "deniedSettingsDescription": "Yöneticilerin erişmesine izin verilmeyen ayarları belirtin.",
      "selectUserFirst": "Önce bir kullanıcı seçin"
    },
    "sharePointIntegration": {
      "title": "SharePoint entegrasyonu",
      "description": "Seçtiğiniz SharePoint kapsamındaki dosyaları yerinde şifreleyin.",
      "steps": {
        "connection": "Bağlantı",
        "key": "Şifreleme anahtarı",
        "perimeter": "Kapsam"
      },
      "connectionDescription": "Entra ID uygulama kaydınızın app-only kimlik bilgileri.",
      "tenantIdLabel": "Kiracı kimliği",
      "clientIdLabel": "İstemci kimliği",
      "spaClientIdLabel": "SPA istemci kimliği (görüntüleyici/düzenleyici)",
      "spaClientIdHint": "SPA (genel) türünde ikinci uygulama kaydı: tarayıcı, şifreli dosyaları okumak ve düzenlemek için buraya oturum açar. Bu olmadan hiç kimse web uygulamasından dosya açamaz. Uygulama-yalnızca kaydını buraya asla girmeyin — onun bir gizli anahtarı vardır.",
      "guidHint": "Geçerli bir GUID girin.",
      "clientSecretLabel": "İstemci parolası",
      "clientSecretPlaceholder": "İstemci parolasını yapıştırın",
      "clientSecretHint": "Yalnızca yazılabilir: kaydedildikten sonra yalnızca değiştirilebilir.",
      "clientSecretStored": "Kayıtlı bir istemci parolası var",
      "replaceSecret": "Değiştir",
      "editConnection": "Düzenle",
      "hideConnection": "Kapat",
      "testAction": "Doğrula",
      "testOk": "Bağlantı doğrulandı",
      "testKo": "Bağlantı reddedildi",
      "saveCredentialsFirst": "Önce kimlik bilgilerini kaydedin.",
      "lastVerifyOk": "Doğrulandı",
      "lastVerifyKo": "Denetim başarısız",
      "lastVerifiedAt": "Son denetim: {{date}}",
      "perimeterDescription": "Taramanın incelediği siteler ve klasörler.",
      "perimeter": {
        "sitesTitle": "Siteler",
        "searchSites": "Site ara",
        "reloadSites": "Site listesini yeniden yükle",
        "foldersTitle": "{{siteName}}",
        "foldersTitleEmpty": "Klasörler",
        "pickSiteFirst": "Soldan bir site seçin.",
        "noLibraries": "Burada görünür belge kitaplığı yok.",
        "wholeSiteTag": "Tüm site",
        "selectedTitle": "Kapsamda:",
        "scopeNone": "yok",
        "folderCount": "{{count}} klasör",
        "librariesCrumb": "Belge kitaplıkları",
        "noSubfolders": "Alt klasör yok.",
        "levelTruncatedTitle": "Burada listelenemeyecek kadar çok klasör var",
        "levelTruncatedBody": "2000 klasör sınırının üzerinde bazı klasörler hiçbir sayfada görünmez: aşağıda yol ile ekleyin.",
        "manualPathLabel": "Yol ile klasör ekle",
        "manualPathPlaceholder": "Yol ile klasör ekleyin, ör. Sozlesmeler/2026",
        "manualPathInvalid": "Kitaplık köküne göreli yol, \".\" veya \"..\" bölümleri olmadan (en fazla 400 karakter).",
        "browse": "Gözat",
        "openFolder": "{{name}} klasörünü aç",
        "scopeLabel": "Bu sitede ne izlensin",
        "scopeOff": "Hiçbir şey",
        "scopeWhole": "Tüm site",
        "scopeFolders": "Yalnızca aşağıdaki klasörler",
        "selectedFoldersTitle": "İzlenen klasörler",
        "librariesNotSelectable": "Bir kitaplığı açın. Seçtiğiniz klasör sitenin tüm kitaplıkları için geçerlidir.",
        "addFolder": "{{name}} klasörünü izlenen klasörlere ekle",
        "folderAdded": "Eklendi",
        "folderAlreadyAdded": "Bu klasör zaten izleniyor",
        "noFoldersSelected": "Henüz yok.",
        "parentFolderWatched": "Üst klasör \"{{folder}}\" zaten izleniyor, bu nedenle alt klasörleri de kapsamda.",
        "emptyWarning": "Hiçbir site seçilmedi: hiçbir şey incelenmez veya şifrelenmez.",
        "siteCount": "{{count}} site"
      },
      "certificateDescription": "Dosyaların şifrelendiği RemoteGrant sertifikası.",
      "encryption": {
        "thumbprintLabel": "Parmak izi",
        "unnamedCertificate": "{{id}} numaralı sertifika",
        "reloadAction": "Sertifikaları yeniden yükle",
        "selectPlaceholder": "Bir sertifika seçin",
        "optionLabel": "{{name}} — oluşturulma: {{date}}",
        "rotationTitle": "Sertifikayı değiştirmek hiçbir şeyi yeniden şifrelemez",
        "rotationBody": "Zaten şifrelenmiş dosyalar önceki sertifikaya bağlı kalır: onu RemoteGrant'ta tutun, aksi halde okunamaz hale gelirler.",
        "dryRunBlockedReason": "Discovery modunu kapatmak için bir şifreleme sertifikası seçin.",
        "errors": {
          "listFailed": "Sertifika listesi yüklenemedi.",
          "certificateNotFound": "Seçili sertifika artık RemoteGrant listenizde yok. Listeyi yeniden yükleyip tekrar bir sertifika seçin.",
          "remoteGrantNotConfigured": "RemoteGrant şirketiniz için yapılandırılmadı. Anahtarlarını CyberGrant ayarlar: destek ekibine başvurun.",
          "remoteGrantUnavailable": "RemoteGrant geçici olarak erişilemiyor. Birazdan yeniden deneyin.",
          "remoteGrantDenied": "RemoteGrant şirketinizin kimlik bilgilerini reddetti. Destek ekibine başvurun."
        },
        "empty": "RemoteGrant şirketiniz için sertifika döndürmedi."
      },
      "fileExtensionsTitle": "Dosya türü filtresi",
      "fileExtensionsDescription": "Yalnızca bu uzantılara sahip dosyalar kapsama girer. Tüm dosya türlerini dahil etmek için listeyi boş bırakın.",
      "addFileExtension": "Uzantı ekle",
      "invalidFileExtension": "Tek bir uzantı girin, örneğin .docx",
      "allFileTypesWarning": "Filtre ayarlanmadı: kapsamdaki tüm dosya türleri dahildir.",
      "dryRunTitle": "Discovery modu",
      "dryRunDescription": "Kapsamı hiçbir şeyi şifrelemeden inceleyin. Varsayılan ve güvenli seçenek.",
      "dryRunOnTag": "Discovery",
      "dryRunOffTag": "Şifreleniyor",
      "confirmEncryption": {
        "confirmAction": "Şifrele",
        "irreversible": "Yerinde yeniden yazılırlar ve buradan şifreleri çözülemez.",
        "title": "Bu seçimdeki dosyalar şifrelensin mi?"
      },
      "errors": {
        "notAvailableTitle": "Lisansınıza dahil değil",
        "notAvailable": "SharePoint entegrasyonu lisansınıza dahil değildir. Etkinleştirmek için destek ekibine başvurun.",
        "notConfigured": "Henüz kayıtlı kimlik bilgisi yok. Önce bağlantı parametrelerini girip kaydedin.",
        "configInvalid": "Kaydedilmiş yapılandırma reddedildi. Aşağıda listelenen sorunları düzeltip yeniden kaydedin.",
        "testFailed": "Bağlantı doğrulanamadı.",
        "sitesFailed": "Kiracıdaki siteler yüklenemedi.",
        "foldersFailed": "Bu klasör düzeyi yüklenemedi.",
        "siteNotFound": "Bu site artık bu kimlik bilgileriyle erişilebilir değil. Site listesini yeniden yükleyip siteyi tekrar seçin.",
        "graphUnauthorizedShort": "Microsoft Graph kimlik bilgilerini reddetti.",
        "graphUnavailable": "Microsoft Graph geçici olarak erişilemiyor. Birazdan yeniden deneyin.",
        "notAllowed": "Bu ayarı yönetme izniniz yok. SharePoint entegrasyonuna erişim için bir SuperAdmin'e başvurun.",
        "invalidParams": "İstek geçersiz bir parametre nedeniyle reddedildi.",
        "remedyPermissions": "Uygulama kaydı, yönetici onayıyla Sites.Read.All ve Files.ReadWrite.All uygulama izinlerine ihtiyaç duyar.",
        "remedySecret": "İstemci parolası yanlış veya süresi dolmuş olabilir: yukarıya yenisini girin."
      }
    },
    "activeDirectoryLdap": {
      "title": "Active Directory (LDAP)",
      "description": "Kullanıcı ve grup senkronizasyonu için Filegrant'ı şirket içi Active Directory'nize bağlayın.",
      "connectionTitle": "Bağlantı",
      "connectionDescription": "Etki alanı denetleyicisi, servis hesabı ve arama kökü.",
      "hostLabel": "Ana bilgisayar",
      "portLabel": "Bağlantı noktası",
      "securityLabel": "Güvenlik",
      "securityNone": "Yok (açık metin)",
      "allowInsecureLabel": "Parolanın açık gittiğini anlıyorum — güvensiz LDAP'ye izin ver",
      "allowInsecureWarning": "Güvenlik none iken servis hesabı parolası ağda açık gider.",
      "bindDnLabel": "Bind DN",
      "bindPasswordLabel": "Bind parolası",
      "bindPasswordStored": "Bir bind parolası saklanıyor",
      "bindPasswordRequired": "Kaydetmeden önce bind parolasını girin.",
      "replacePassword": "Değiştir",
      "baseDnLabel": "Base DN",
      "loginAliasLabel": "Oturum açma takma adı özniteliği",
      "loginAliasNone": "Yok",
      "suggestRetypePassword": "Ana bilgisayar veya bind DN değişti — bind parolasını yeniden yazmayı düşünün.",
      "testAction": "Bağlantıyı test et",
      "testOk": "Bağlantı doğrulandı",
      "saveCredentialsFirst": "Önce yapılandırmayı kaydedin; kaydedilmemiş değişiklik olmasın.",
      "lastVerifiedAt": "Son doğrulama: {{date}}",
      "neverVerified": "Hiç doğrulanmadı",
      "caTitle": "CA sertifikası",
      "caDescription": "Etki alanı denetleyicisi sertifikasını imzalayan dahili CA'nın PEM'i. Sistem güven deposu için boş bırakın.",
      "uploadCa": ".cer / .pem yükle",
      "removeCa": "CA'yı kaldır",
      "caThumbprint": "Parmak izi",
      "caExpiresAt": "CA {{date}} tarihinde sona eriyor",
      "caExpiringSoon": "CA yakında sona eriyor ({{date}})",
      "caExpired": "CA {{date}} tarihinde sona erdi",
      "advancedTitle": "Gelişmiş",
      "advancedDescription": "İsteğe bağlı arama tabanları ve LDAP filtreleri.",
      "advancedToggle": "Arama tabanları ve filtreler",
      "userSearchBaseLabel": "Kullanıcı arama tabanı",
      "groupSearchBaseLabel": "Grup arama tabanı",
      "userFilterLabel": "Kullanıcı filtresi",
      "groupFilterLabel": "Grup filtresi",
      "errors": {
        "notAvailableTitle": "Kullanılamıyor"
      },
      "passwordRequiredOnTargetChange": "Parolayı yeniden girin: bağlantı hedefi değişti.",
      "filterHelp": "Varsayılan aramayı daraltan isteğe bağlı ek koşul (AND), örn. (department=Sales).",
      "neverVerifiedInvite": "Bağlantı hiç doğrulanmadı — Bağlantıyı test et’e basın."
    },
    "outboundEmail": {
      "title": "Özel e-posta göndereni",
      "description": "Platform bildirimlerini kendi alan adınızdan SMTP veya Mailgun ile gönderin.",
      "statusTitle": "Gönderen durumu",
      "statusDescription": "Bildirimlerin şu anda özel alan adınızdan gidip gitmediği.",
      "refreshStatus": "Durumu yenile",
      "badgeActive": "Aktif: bildirimler {{domain}} adresinden gider",
      "badgeInactive": "Aktif değil: bildirimler hâlâ platform gönderenini kullanır",
      "reasonDisabled": "Özel gönderen kapalı.",
      "reasonNotVerified": "Alan adı sahipliği henüz doğrulanmadı.",
      "reasonMailgunNotActive": "Mailgun alan adı henüz aktif değil.",
      "reasonNotActive": "Özel gönderen kullanımda değil.",
      "formTitle": "Yapılandırma",
      "formDescription": "Alan adı, From kimliği ve teslimat modu.",
      "enabledLabel": "Özel göndereni etkinleştir",
      "modeLabel": "Teslimat modu",
      "modeSmtp": "SMTP (kendi sunucu)",
      "modeMailgun": "Mailgun (platform hesabı)",
      "mailgunUnavailable": "Mailgun modu bu platformda kullanılamaz.",
      "domainLabel": "Alan adı",
      "fromAddressLabel": "From adresi",
      "fromNameLabel": "From adı",
      "sendFromUserLabel": "Kullanıcıdan gönder",
      "sendFromUserOn": "From olarak işlem yapan kullanıcının e-postasını kullan",
      "sendFromUserOff": "Şirket From adresini / özel alan adını kullan",
      "smtpHostLabel": "SMTP host",
      "smtpPortLabel": "SMTP port",
      "smtpUsernameLabel": "SMTP kullanıcı adı",
      "smtpPasswordLabel": "SMTP parola",
      "smtpPasswordStored": "Bir SMTP parolası kayıtlı",
      "smtpPasswordRequired": "Kaydetmeden önce SMTP parolasını girin.",
      "replacePassword": "Değiştir",
      "smtpSecurityLabel": "SMTP güvenlik",
      "suggestRetypePassword": "Host veya kullanıcı adı değişti — SMTP parolasını yeniden girin.",
      "domainChangeTitle": "Alan adı değiştirilsin mi?",
      "domainChangeWarning": "Alan adını değiştirmek doğrulamayı yeniden başlatır. Yeni alan adı doğrulanana kadar özel gönderen kullanılmaz.",
      "dnsTitle": "DNS ve doğrulama",
      "dnsDescription": "Sahiplik TXT kaydını yayınlayın, sonra doğrulayın. Mailgun modunda Mailgun kayıtlarını da yayınlayın.",
      "verifyNow": "Şimdi doğrula",
      "verifyOk": "Alan adı sahipliği doğrulandı",
      "verifyPending": "Sahiplik TXT henüz bulunamadı",
      "verifyMailgun": "Mailgun kayıtlarını doğrula",
      "verifyMailgunOk": "Mailgun kayıtları doğrulandı: alan adı aktif",
      "verifyMailgunPending": "Mailgun henüz tüm kayıtları doğrulamadı",
      "autoCheckHint": "Alan adı doğrulanana kadar her dakika otomatik olarak kontrol edilir.",
      "autoCheckVerified": "Alan adı doğrulandı: özel gönderen artık kullanılabilir.",
      "saveBeforeVerify": "Önce bir alan adı kaydedin, sonra doğrulayın.",
      "ownershipName": "Ad",
      "ownershipValue": "Değer",
      "recordType": "Tür",
      "recordValid": "Geçerli",
      "recordInvalid": "Geçersiz",
      "verifiedAt": "Doğrulandı: {{date}}",
      "lastCheckedAt": "Son kontrol: {{date}}",
      "dnsEmpty": "Sahiplik TXT kaydını almak için bir alan adı kaydedin.",
      "mailgunRecordsTitle": "Mailgun DNS kayıtları",
      "testTitle": "Test e-postası",
      "testDescription": "Özel gönderen üzerinden kendi SuperAdmin adresinize bir test iletisi kuyruğa alır.",
      "testDescriptionPlatform": "Kendi SuperAdmin adresinize bir test iletisi kuyruğa alır. Özel gönderen henüz kullanımda değil, bu yüzden mevcut gönderen kullanılır.",
      "sendTest": "Test e-postası gönder",
      "testQueued": "{{recipient}} adresine kuyruğa alındı",
      "testQueuedPlatform": "Mevcut gönderen üzerinden {{recipient}} adresine kuyruğa alındı (özel gönderen kullanımda değil)",
      "errors": {
        "notAvailableTitle": "Kullanılamaz"
      }
    }
  },
  "auth": {
    "loginPageTitle": "Filegrant Enterprise'a hoş geldiniz",
    "loginPageSubtitle": "Dokümana güvenli bir şekilde erişmek için lütfen e-posta adresinizi girin.",
    "resendOtpCode": "OTP kodunu yeniden gönder",
    "loginTermsAndConditions": "Cyber ​​Grant Inc.'in <a target=\"_blank\" href=\"https://www.cybergrant.net/terms-of-service\"><strong>Hizmet Şartları</strong></a>'nı kabul ediyorum",
    "loginPageEmailLabel": "E-posta/kullanıcı adı",
    "loginPageEmailPlaceholder": "E-posta/kullanıcı adınızı buraya girin...",
    "loginPageOtpLabel": "Kayıtlı e-posta adresinize bir kod gönderdik. 6 haneli kodu buraya girin. Almadıysanız 'Yeni bir kod iste'ye tıklayın",
    "loginButtonLabel": "Giriş Yap",
    "loginPageResendOtp": "Yeni bir kod isteyin",
    "orContinueWith": "veya şununla devam et",
    "loginPageTooManyAttempts": "Çok Fazla Deneme",
    "totpStepTitle": "İki faktörlü kimlik doğrulama",
    "enterTotpCode": "Kimlik doğrulayıcı uygulamanızdan 6 haneli kodu girin",
    "configure2FA": "İki Faktörlü Doğrulamayı Yapılandır",
    "useBackupCode": "Yedek kod kullanın",
    "useOtpCode": "OTP kodunu kullan",
    "enterBackupCode": "Yedek kodunuzu girin",
    "backupCodePlaceholder": "Yedek kodunuzu girin",
    "totpTimeRemaining": "Kimlik doğrulamanın tamamlanması için kalan süre: {{time}}",
    "twoFactorChooseMethod": "Nasıl doğrulanacağını seçin",
    "usePasskey": "Şifre anahtarını kullan",
    "useTotp": "Kimlik doğrulayıcı uygulamasını kullan",
    "passkeyWaiting": "Şifrenizi bekliyorum…",
    "orDivider": "veya",
    "signInWithPasskey": "Şifre anahtarıyla oturum açın",
    "passkeyCancelled": "Geçiş anahtarıyla oturum açma iptal edildi.",
    "passkeyNotSupported": "Tarayıcınız şifre anahtarlarını desteklemiyor.",
    "passwordlessNotEnabled": "Kuruluşunuz için geçiş anahtarıyla oturum açma etkin değil.",
    "totpForcedSetupIntro": "Kuruluşunuz iki faktörlü kimlik doğrulama gerektiriyor. {{email}} olarak oturum açmayı tamamlamak için şimdi kurun.",
    "totpForcedSetupTitle": "İki faktörlü kimlik doğrulamayı kurun",
    "totpForcedSetupDescription": "QR kodunu kimlik doğrulama uygulamanızla tarayın, ardından oturum açmayı tamamlamak için 6 haneli kodu girin."
  },
  "secret": {
    "createTitle": "Gizli dosya oluştur",
    "createSecret": "Gizli Oluştur",
    "newSecret": "Yeni Gizli",
    "fileName": "Dosya adı",
    "fileNameRequired": "Dosya adı gerekli",
    "protectWithPassword": "Şifreyle koruyun",
    "protectWithSecretKey": "Gizli anahtarla koruyun",
    "secretKeyWarning": "Bu anahtarı kaybederseniz bilgilere artık erişemezsiniz",
    "changeSecretKey": "Gizli anahtarı değiştir",
    "currentSecretKey": "Mevcut gizli anahtar",
    "wrongCurrentKey": "Mevcut gizli anahtar yanlış",
    "hint": "İpucu",
    "hintPlaceholder": "Anahtarı hatırlamak için isteğe bağlı ipucu",
    "newSecretKey": "Yeni gizli anahtar",
    "confirmSecretKey": "Gizli anahtarı onayla",
    "secretKeyMismatch": "Gizli anahtarlar eşleşmiyor",
    "enterPassword": "Şifreyi girin",
    "confirmPassword": "Şifreyi onayla",
    "passwordRequired": "Şifre gerekli",
    "passwordMinLength": "Şifre en az 4 karakter olmalıdır",
    "confirmPasswordRequired": "Şifreyi onayla",
    "passwordMismatch": "Şifreler eşleşmiyor",
    "wrongPassword": "Yanlış şifre",
    "addField": "Alan ekle",
    "addFieldForGroup": "Gruba alan ekle",
    "removeField": "Alanı kaldır",
    "editLabel": "Etiketi düzenle",
    "fieldType": "Tip",
    "fieldLabel": "Yeni Alan",
    "fieldValue": "Değer",
    "fields": {
      "heading": "Alanlar",
      "username": "Kullanıcı adı",
      "password": "Parola",
      "website": "Web sitesi",
      "cardholder": "Kart sahibi",
      "number": "Kart numarası",
      "brand": "Marka",
      "exp_month": "Son kullanma ayı",
      "exp_year": "Son kullanma yılı",
      "cvv": "CVV",
      "title": "Ünvan",
      "first_name": "Ad",
      "last_name": "Soyad",
      "fiscal_code": "Vergi numarası",
      "passport": "Pasaport",
      "driving_license": "Ehliyet",
      "email": "E-posta",
      "phone": "Telefon",
      "address1": "Adres satırı 1",
      "address2": "Adres satırı 2",
      "address3": "Adres satırı 3",
      "city": "Şehir",
      "state": "İl / Bölge",
      "zip": "Posta kodu",
      "country": "Ülke",
      "private_key": "Özel anahtar",
      "public_key": "Açık anahtar",
      "fingerprint": "Parmak izi",
      "notes": "Notlar"
    },
    "searchFields": "Alanlarda ara",
    "noFieldsYet": "Henüz alan yok",
    "untitled": "Başlıksız",
    "types": {
      "text": "Metin",
      "password": "Şifre",
      "url": "URL'si",
      "username": "Kullanıcı adı",
      "email": "E-posta",
      "phone": "Telefon",
      "textarea": "Metin alanı",
      "number": "Sayı",
      "month": "Ay",
      "year": "Yıl"
    },
    "validation": {
      "email": "Geçerli bir e-posta gibi görünmüyor",
      "url": "Geçerli bir URL gibi görünmüyor",
      "phone": "Geçerli bir telefon numarası gibi görünmüyor",
      "number": "Geçerli bir sayı gibi görünmüyor"
    },
    "password": {
      "show": "Göster",
      "hide": "Gizle",
      "generate": "Oluştur",
      "copy": "Kopyala",
      "copied": "Kopyalandı!",
      "length": "Uzunluk",
      "includeSymbols": "Özel karakterleri dahil et",
      "strength": {
        "veryWeak": "Çok zayıf",
        "weak": "Zayıf",
        "fair": "Adil",
        "strong": "Güçlü",
        "veryStrong": "Çok güçlü"
      }
    },
    "edit": "Düzenle",
    "save": "Kaydet",
    "saved": "Kaydedildi",
    "cancel": "İptal",
    "protectedFile": "Korumalı dosya",
    "enterPasswordToView": "İçeriği görüntülemek için şifreyi girin",
    "unlock": "Kilidi aç",
    "noData": "Veri yok",
    "loadError": "Dosya yüklenirken hata oluştu",
    "saveError": "Dosya kaydedilirken hata oluştu",
    "addWebsite": "Web sitesi ekle",
    "addGroup": "Grup ekle",
    "newGroup": "Yeni grup",
    "renameGroup": "Grubu yeniden adlandır",
    "deleteGroup": "Grubu sil",
    "moveUp": "Yukarı taşı",
    "moveDown": "Aşağı taşı",
    "dragToReorderField": "{{label}} öğesini sürükleyerek sırala",
    "dragToReorderGroup": "{{label}} grubunu sürükleyerek sırala",
    "presets": {
      "credentials": "Giriş bilgileri",
      "card": "Ödeme kartı",
      "identity": "Kimlik",
      "ssh_key": "SSH anahtarı",
      "custom": "Özel gizli"
    },
    "groups": {
      "credentials_main": "Giriş bilgileri",
      "credentials_autofill": "Otomatik doldurma seçenekleri",
      "card_main": "Kart",
      "identity_personal": "Kişisel",
      "identity_ids": "Kimlikler",
      "identity_contact": "İletişim",
      "identity_address": "Adres",
      "ssh_main": "SSH anahtarı",
      "custom_fields": "Özel alanlar",
      "additional_options": "Ek seçenekler"
    },
    "card": {
      "brands": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "American Express",
        "other": "Diğer"
      }
    },
    "identity": {
      "titles": {
        "mr": "Bay",
        "ms": "Bayan",
        "mx": "Mx",
        "dr": "Dr",
        "prof": "Prof",
        "other": "Diğer"
      }
    },
    "ssh": {
      "upload": "Anahtar dosyası yükle",
      "uploadError": "Anahtar dosyası okunamadı"
    }
  },
  "publicShare": {
    "createLink": "Bağlantı Oluştur",
    "revokeLink": "Bağlantıyı İptal Et",
    "revokeLinkConfirmDescription": "{{fileName}} için genel bağlantı iptal edilsin mi?",
    "badgeSection": "Durum Rozeti",
    "badgeActive": "Aktif",
    "revoked": "İptal Edildi",
    "createModal": {
      "title": "Paylaşım Bağlantısı Oluştur",
      "fileLabel": "Dosya",
      "allowDownload": "İndirmeye izin ver",
      "expirationLabel": "Son kullanma tarihi (isteğe bağlı)",
      "expirationPlaceholder": "Asla",
      "maxAccessCountLabel": "Maksimum erişim sayısı (isteğe bağlı)",
      "maxAccessCountPlaceholder": "Sınırsız",
      "protectWithPassword": "Şifreyle koruyun",
      "passwordLabel": "Şifre",
      "passwordPlaceholder": "Şifreyi girin",
      "passwordRequired": "Koruma etkinleştirildiğinde şifre gereklidir",
      "createLink": "Bağlantı Oluştur"
    },
    "successModal": {
      "title": "Bağlantı oluşturuldu!",
      "message": "Herkese açık bağlantı oluşturuldu.",
      "copyLink": "Bağlantıyı kopyala",
      "warning": "Bu bağlantıya sahip olan herkes dosyaya erişebilir.",
      "expiresAt": "Bitiş Tarihi",
      "remainingAccesses": "Kalan Erişim Hakkı",
      "password": "Şifre"
    },
    "errors": {
      "linkAlreadyExists": "Bu dosya için genel bir bağlantı zaten mevcut. Yeni bir tane oluşturmak için önce onu iptal edin.",
      "linkNotFound": "Bu dosya için etkin bağlantı bulunamadı.",
      "featureDisabled": "Kuruluşunuz için genel bağlantılar devre dışı bırakıldı.",
      "notOwner": "Herkese açık bağlantılar oluşturmak veya iptal etmek için sahibi olmanız gerekir."
    },
    "passwordTitle": "Korumalı içerik",
    "passwordMessage": "Bu dosya bir şifre ile korunmaktadır. Erişmek için şifreyi girin.",
    "passwordRequired": "Şifre gerekli.",
    "errorInvalidPassword": "Girdiğiniz şifre hatalı. Lütfen tekrar deneyin.",
    "passwordSubmit": "Erişim",
    "errorExpiredTitle": "Bağlantının süresi doldu",
    "errorExpiredMessage": "Bu paylaşım bağlantısı artık geçerli değil. Son kullanma tarihi geçti. Yeni bir bağlantı istemek için size bağlantıyı gönderen kişiyle iletişime geçin.",
    "errorMaxAccessTitle": "Erişim sınırına ulaşıldı",
    "errorMaxAccessMessage": "Bu bağlantı izin verilen maksimum erişim sayısına ulaştı. Yeni bir bağlantı istemek için size bağlantıyı gönderen kişiyle iletişime geçin.",
    "errorNotFoundTitle": "Geçersiz bağlantı",
    "errorNotFoundMessage": "Açmaya çalıştığınız bağlantı mevcut değil veya sahibi tarafından iptal edilmiş. Lütfen URL'yi doğru kopyalayıp kopyalamadığınızı kontrol edin.",
    "folderContents": "Klasör içeriği",
    "items": "öğeler",
    "fileSize": "Dosya Boyutu",
    "fileType": "Dosya Türü",
    "sharedAt": "Paylaşıldığı yer",
    "list": {
      "title": "Herkese açık bağlantılarım",
      "description": "Herkese açık paylaşım bağlantılarınızı yönetin. Devre dışı bırakmak için bir bağlantıyı iptal edin.",
      "fileName": "Dosya Adı",
      "type": "Tür",
      "status": "Durum",
      "statusActive": "Aktif",
      "statusExpired": "Günü geçmiş",
      "statusExhausted": "Sınıra ulaşıldı",
      "expiresAt": "Süresi doluyor",
      "accessCount": "Erişimler",
      "hasPassword": "Şifre",
      "empty": "Henüz herkese açık bağlantı yok."
    }
  },
  "common": {
    "buttons": "Butonlar",
    "change": "Değiştir",
    "setting": "Ayar",
    "background": "Arka plan",
    "foreground": "Ön plan",
    "edit": "Düzenle",
    "remove": "Kaldır",
    "settings": "Ayarlar",
    "integrations": "Entegrasyonlar",
    "customizations": "Özelleştirmeler",
    "enable": "Etkinleştir",
    "logout": "Çıkış Yap",
    "features": "Özellikler",
    "day_one": "{{count}} gün",
    "day_other": "{{count}} gün",
    "files": "Dosyalar",
    "received": "Alınan",
    "rename": "Yeniden Adlandır",
    "cancel": "İptal",
    "cancelUpload": "Yüklemeyi İptal Et",
    "canceled": "İptal edildi",
    "close": "Kapat",
    "open": "Aç",
    "createFolder": "Klasör oluştur",
    "openFolder": "Klasörü aç",
    "uploadFolder": "Klasörü yükle",
    "uploadFile": "Dosya yükle",
    "downloadEncrypted": "Şifreli indir",
    "createdBy": "Oluşturan",
    "login": "Giriş Yap",
    "otpCode": "OTP kodu",
    "passkeys": "Geçiş anahtarları",
    "email": "E-posta",
    "username": "Kullanıcı adı",
    "emails": "E-postalar",
    "emailLabel": "E-posta Etiketi",
    "emailPlaceholder": "E-posta Yer Tutucusu",
    "labels": "Etiketler",
    "inputs": "Girişler",
    "loginLabel": "Giriş Etiketi",
    "resendOtpLabel": "OTP Etiketini Yeniden Gönder",
    "otpCodeLabel": "OTP Kod Etiketi",
    "allUsers": "Tüm kullanıcılar",
    "allGroups": "Tüm gruplar",
    "globalSearchPlaceholder": "Dosya ve klasörleri arayın",
    "folderPickerSearchInFolder": "Bu klasörde ara",
    "globalSearchDescription": "Dosya ve klasörleri aramak için yazmaya başlayın",
    "filterExactMatch": "Tam eşleşme (tüm kelime)",
    "filterWholeWord": "Aramayı beğen (joker karakter)",
    "loading": "Yükleniyor...",
    "loadingDescription": "Verileriniz yüklenirken lütfen bekleyin",
    "thinking": "Düşünüyorum...",
    "thinkingDescription": "Yapay zeka isteğinizi işliyor",
    "noResults": "Sonuç bulunamadı",
    "noFilesFound": "Hiçbir dosya bulunamadı",
    "hidden": "Gizli",
    "hide": "Gizle",
    "lock": "Kilitle",
    "file": "Dosya",
    "fileSize": "Dosya boyutu",
    "tags": "Etiketler",
    "tag": "Etiket",
    "title": "Başlık",
    "users": "Kullanıcılar",
    "user": "Kullanıcı",
    "systemUser": "Sistem",
    "groups": "Gruplar",
    "createdAt": "Oluşturulma tarihi",
    "group": "Grup",
    "reviewTeam": "Ekibi İncele",
    "folder": "Klasör ",
    "publicLink": "Genel Bağlantı",
    "publicLinkTitle": "Filegrant Genel Bağlantısı",
    "logs": "Kayıtlar",
    "addUsersOrGroups": "Kullanıcı veya grup ekleyin",
    "addUsers": "Kullanıcı ekle",
    "userTagInputEmptyPlaceholder": "Kullanıcıları veya grupları aramak için yazmaya başlayın",
    "member": "Üye",
    "member_zero": "Üye yok",
    "member_other": "Üyeler",
    "uploaded": "Yüklendi",
    "failed": "Başarısız",
    "retries": "Yeniden denemeler",
    "preparingFilesForUpload": "Dosyalar yüklemeye hazırlanıyor",
    "uploadingFilesCounter": "{{amount}} / {{total}} dosyaları yükleniyor",
    "uploadedFilesCounter": "{{amount}} / {{total}} yüklendi",
    "copyLink": "Bağlantıyı kopyala",
    "unhide": "Göster",
    "licenseLimitation": "Lisans Sınırlaması",
    "deletionDate": "Silinme Tarihi",
    "creationDate": "Oluşturulma tarihi",
    "newUser": "Yeni kullanıcı",
    "newGroup": "Yeni grup",
    "noActionsAvailable": "Hiçbir işlem mevcut değil",
    "author": "Yazar",
    "openProtectedFile": "Korumalı dosyayı aç",
    "showFilesSharedWith": "Şununla paylaşılan dosyaları göster:",
    "showFilesSharedBy": "Tarafından paylaşılan dosyaları göster",
    "upload": "Yükle",
    "youCanRequestANewOtpIn": "Yeni bir OTP talep edebilirsiniz.",
    "otpExpired": "OTP'nin süresi doldu",
    "otpValidFiveMinutesOnce": "Bu kod 5 dakika geçerlidir ve yalnızca bir kez çalışır.",
    "generateNewOtp": "Yeni OTP oluştur",
    "clickHereToGenerateNewOtp": "Yeni bir OTP oluşturmak için burayı tıklayın",
    "preparingFileForDownload": "Dosya indirmeye hazırlanıyor",
    "preparingForDownload": "İndirmeye hazırlanıyor",
    "uploadErrors": "Hataları yükle",
    "uploadErrorsDescription": "Bazı dosyalar yüklenemedi",
    "size": "Boyut",
    "status": "Durum",
    "percentage": "Yüzde",
    "viewer": "Görüntüleyici",
    "editor": "Editör",
    "shareWith": "Şununla paylaş:",
    "retry": "Yeniden dene",
    "regenerate": "Yenile",
    "permissions": "İzinler",
    "expiration": "Son kullanma tarihi",
    "message": "Mesaj",
    "uploadingFiles": "Dosya yükleme",
    "addFiles": "Dosya ekle",
    "addFolders": "Klasör ekle",
    "max": "Maksimum",
    "preview": "Önizleme",
    "write": "Yazma",
    "quickShare": "Hızlı Paylaşım",
    "maxFilesAmountAndSizeEach": "Maksimum {{amount}} dosya, her biri {{size}}MB",
    "startUploadAndShare": "Yüklemeye başlayın ve paylaşın",
    "processing": "İşleniyor",
    "startNewUploadAndShare": "Yeni yüklemeye başlayın ve paylaşın",
    "continue": "Devam Et",
    "goToFileManager": "Dosya Yöneticisine Git",
    "goToQuickShare": "Hızlı Paylaşıma Git",
    "viewAll": "Tümünü gör",
    "emptyUsersList": "Eklediğiniz kullanıcıları burada bulabilirsiniz",
    "emptyGroupsList": "Eklediğiniz grupları burada bulabilirsiniz",
    "confirmationMessage": "Onay mesajı",
    "lastModified": "Son değiştirilme tarihi",
    "opened": "Açıldı",
    "lastAccess": "Son erişim",
    "accessExpiration": "Erişimin sona ermesi",
    "description": "Açıklama",
    "descriptionNotEditable": "Açıklama düzenlenemez",
    "sharedItems": "Paylaşılan öğeler",
    "sharedItemsCount": "{{count}} öğe paylaşıldı",
    "sharedItemsCount_other": "{{count}} öğe paylaşıldı",
    "itemsSharedWith": "<strong>{{resource}}</strong> ile paylaşılan öğeler",
    "manageItems": "Öğeleri yönet",
    "items": "Öğeler",
    "visibleToAdminsOnly": "Yalnızca yöneticiler görebilir",
    "loginAlias": "Giriş takma adı / Çalışan numarası",
    "loginAliasManagedBy": "{{source}} tarafından yönetiliyor",
    "loginAliasManagedWarning": "Bu takma adı düzenlemek dizin otomatik güncellemelerini durdurur.",
    "loginAliasSourceEntraId": "Entra ID",
    "loginAliasSourceActiveDirectory": "Active Directory",
    "employeeId": "Çalışan ID",
    "searchUsersIncludingAlias": "Kullanıcı ara (ad, e-posta veya takma ad)...",
    "pleaseEnterName": "Lütfen bir ad girin",
    "pleaseEnterFirstName": "Lütfen bir ad girin",
    "pleaseEnterLastName": "Lütfen bir soyad girin",
    "pleaseEnterEmail": "Lütfen bir e-posta girin",
    "invalidEmail": "Geçerli bir e-posta adresi değil",
    "nameCannotBeEmail": "Ad bir e-posta olamaz",
    "publicLinkSearchHint": "Arama, tüm sayfalar yüklendikten sonra bu klasörü filtreler",
    "companyTag": "Şirket etiketi",
    "replace": "Değiştir",
    "fileName": "Dosya adı",
    "enterFileName": "Dosya adını girin",
    "new": "Yeni",
    "organize": "Düzenle",
    "downloadFile": "Dosyayı indir",
    "expiry": "Son kullanma tarihi",
    "downloadPdf": "PDF'yi indir",
    "downloadEncryptedFile": "Şifrelenmiş dosyayı indir",
    "save": "Kaydet",
    "createShortcut": "Kısayol oluştur",
    "create": "Oluştur",
    "createShortcutFor": "{{resource}} için kısayol oluştur",
    "selectFolderToCreateFileShortcut": "Dosyanın oluşturulacağı klasör yolunu gösterecek bir konum seçin",
    "editUser": "Kullanıcıyı düzenle",
    "unblockUser": "Kullanıcının engellemesini kaldır",
    "blockUser": "Kullanıcıyı engelle",
    "deleteUser": "Kullanıcıyı sil",
    "excludeFromSso": "SSO'dan hariç tut",
    "includeInSso": "SSO'yu yeniden etkinleştir",
    "confirm": "Onayla",
    "search": "Ara",
    "noUsersFound": "Kullanıcı bulunamadı",
    "noSettingsFound": "Hiçbir ayar bulunamadı",
    "block": "Engelle",
    "unblock": "Engeli Kaldır",
    "role": "Rol",
    "addedOn": "Eklendi",
    "memberOfNGroups": "N° gruplarının üyesi",
    "noExpirationDate": "Son kullanma tarihi yok",
    "groupsMember": "Grup üyesi",
    "onBehalfOf": "Adına",
    "exitFromBehalfOfMode": "Adı modundan çık",
    "expiryDate": "Son kullanma tarihi",
    "select": "Seç",
    "nothingHasBeenSharedYet": "Henüz hiçbir şey paylaşılmadı",
    "manageGroups": "Grupları yönet",
    "noGroupsYet": "Henüz grup yok",
    "addExpirationDate": "Son kullanma tarihi ekle",
    "editExpirationDate": "Son kullanma tarihini düzenle",
    "edited": "Düzenlendi",
    "removed": "Kaldırıldı",
    "removeExpirationDate": "Son kullanma tarihini kaldır",
    "usersWithSharedFiles": "Paylaşılan dosyaları olan kullanıcılar",
    "usersWithoutSharedFiles": "Paylaşılan dosyaları olmayan kullanıcılar",
    "changeRole": "Rolü değiştir",
    "yes": "Evet",
    "no": "HAYIR",
    "selected": "Seçili",
    "editGroup": "Grubu düzenle",
    "viewGroup": "Grubu görüntüle",
    "numberOfMembers": "Üye sayısı",
    "groupMembers": "Grup üyeleri",
    "editGroups": "Grupları düzenle",
    "noUsers": "Kullanıcı yok",
    "deleteGroup": "Grubu sil",
    "documents": "Belgeler",
    "images": "Görseller",
    "audio": "Ses",
    "video": "Video",
    "other": "Diğer",
    "fileExtensionType": {
      "Text": "Metin",
      "SourceCode": "Kaynak Kodu",
      "Markup": "İşaretleme",
      "Data": "Veri",
      "Image": "Resim",
      "Video": "Video",
      "Audio": "Ses",
      "Document": "Belge",
      "Spreadsheet": "E-tablo",
      "Presentation": "Sunum",
      "Archive": "Arşiv",
      "Database": "Veritabanı",
      "Font": "Yazı tipi",
      "System": "Sistem",
      "Executable": "Yürütülebilir",
      "Configuration": "Yapılandırma",
      "Log": "Kayıt",
      "Backup": "Yedekleme",
      "Certificate": "Sertifika",
      "Model3D": "3D Modeli",
      "CAD": "CAD",
      "GIS": "CBS",
      "Scientific": "Bilimsel",
      "EBook": "E-Kitap",
      "Vector": "Vektör",
      "Raw": "İşlenmemiş"
    },
    "fileTypes": "Dosya türleri",
    "download": "İndir",
    "share": "Paylaş",
    "createCopy": "Kopya oluştur",
    "markAsRead": "Okundu olarak işaretle",
    "markAsUnread": "Okunmadı olarak işaretle",
    "move": "Taşı",
    "convertToPdf": "PDF'ye Dönüştür",
    "convert": "Dönüştür",
    "wordDocument": "Word Belgesi",
    "excelDocument": "Excel Belgesi",
    "pptDocument": "PowerPoint Belgesi",
    "hideFromList": "Listeden gizle",
    "showInList": "Listede göster",
    "editAccessAndProtections": "Erişim ve korumaları düzenle",
    "tagColor": "Etiket rengi",
    "tagName": "Etiket adı",
    "addToFavorites": "Favorilere ekle",
    "removeFromFavorites": "Favorilerden kaldır",
    "deletePermanently": "Kalıcı olarak sil",
    "delete": "Sil",
    "selectedItems": "Seçilen öğeler",
    "deselectAll": "Tümünün seçimini kaldır",
    "signOut": "oturumu Kapat",
    "tagTitle": "Etiket Başlığı",
    "noTagsYet": "Henüz etiket yok",
    "untitledDocument": "Başlıksız Belge",
    "copyOf": "Kopyası",
    "restoreFromTrash": "Çöp kutusundan geri yükle",
    "shared": "Paylaşıldı",
    "expiresOn": "{{date}} tarihinde sona eriyor",
    "shareExpiredOn": "Paylaşım {{date}} tarihinde sona erdi",
    "favourite": "Favori",
    "favouriteAddedTo": "favorilere eklendi",
    "favouriteRemovedFrom": "favorilerden kaldırıldı",
    "publicLinkLabel": "Herkese açık bağlantı",
    "classificationInProgress": "Sınıflandırma devam ediyor",
    "forSale": "Satılık",
    "favorites": "Favoriler",
    "recent": "Son",
    "transferOwnership": "Sahipliği aktar",
    "trash": "Çöp kutusu",
    "expirationDate": "Son kullanma tarihi",
    "details": "Detaylar",
    "unlock": "Kilidi aç",
    "activities": "Etkinlikler",
    "copyToClipboard": "Panoya kopyala",
    "fileType": "Dosya türü",
    "noTagsApplied": "Bu dosyaya hiçbir etiket uygulanmadı",
    "notSharedYet": "Henüz paylaşılmadı",
    "manageAccess": "Erişimi yönet",
    "selectItemToViewDetails": "Ayrıntılarını görüntülemek için bir öğe seçin",
    "unlockFolderToViewDetails": "Ayrıntıları görüntülemek için klasörün kilidini açın",
    "unlockFolderToViewSize": "Boyutu görüntülemek için klasörün kilidini açın",
    "folderContent": "Klasör içeriği",
    "calculateFolderSize": "Boyutu hesapla",
    "recalculate": "Yeniden hesapla",
    "recalculateCooldown": "Yeniden hesaplamadan önce biraz bekleyin",
    "subfolders": "Alt klasörler",
    "totalSize": "Toplam boyut",
    "filters": "Filtreler",
    "owner": "Sahibi",
    "linkCopied": "Bağlantı panoya kopyalandı!",
    "account": "Hesap",
    "customization": "Özelleştirme",
    "adminRegisteredUserVisibility": "Yönetici Tarafından Kayıtlı Kullanıcı Görünürlüğü",
    "adminRegisteredUserVisibilityDescription": "Yönetici tarafından kayıtlı kullanıcıları, devre dışı bırakılmadıkça görünür yapın; yalnızca dosya paylaşımı yoluyla görünürlük.",
    "autoFileDeletion": "Otomatik Dosya Silme",
    "autoFileDeletionDescription": "Belirli bir oluşturma tarihi ve saklama süresinden sonra dosyaları otomatik olarak silin.",
    "cannotOpenFileOnBehalf": "Dosyaları vekâleten açamazsınız.",
    "certifiedTimestamping": "Sertifikalı Zaman Damgası",
    "certifiedTimestampingDescription": "Katkıda bulunanların dijital sertifika kullanarak dosyalara sertifikalı tarih uygulamasına izin verin.",
    "compressionCompleted": "Sıkıştırma tamamlandı",
    "compressionFailed": "Sıkıştırma başarısız oldu",
    "compressionOfFilesInProgress": "Dosyaların sıkıştırılması devam ediyor",
    "verifyingFileIntegrity": "Dosya bütünlüğü doğrulanıyor...",
    "fileIntegrityVerified": "Dosya bütünlüğü doğrulandı",
    "downloadCompletedWithExclusions": "İndirme tamamlandı ancak bazı dosyalar hariç tutuldu",
    "moveCompletedWithExclusions": "Taşıma tamamlandı ancak bazı dosyalar taşınamadı",
    "filesExcludedForMove": "Aşağıdaki dosyalar taşınamadı:",
    "excludedFilesTitle": "Hariç tutulan dosyalar",
    "viewExcludedFiles": "Hariç tutulan dosyaları görüntüle",
    "filesExcludedForRestrictions": "Bazı dosyalar kısıtlamalar nedeniyle hariç tutuldu:",
    "contributorStorageLimit": "Katılımcı Depolama Sınırı",
    "contributorStorageLimitDescription": "Katkıda bulunanların yeni dosyalar yüklemesi için depolama alanı sınırlarını ayarlayın.",
    "contents": "İçerik",
    "deviceAccessLimitation": "Cihaz Erişim Sınırlaması",
    "deviceAccessLimitationDescription": "Bir dizi cihaza erişimi sınırlayın ve eski cihazların bağlantısını kesin.",
    "downloadPreparation": "İndirmeye hazırlanıyor",
    "downloadReady": "İndirmeye hazır",
    "editorFileManagement": "Düzenleyici Dosya Yönetimi",
    "editorFileManagementDescription": "Katkıda bulunanların izinlere göre dosyaları silmesine ve yeniden adlandırmasına izin verin.",
    "fileSizeLimit": "Dosya Boyutu Sınırı",
    "fileSizeLimitDescription": "Yüklenebilecek her dosyanın maksimum boyutunu sınırlayın.",
    "folderCreationPermission": "Klasör Oluşturma İzni",
    "folderCreationPermissionDescription": "Katkıda bulunanların yeni klasörler oluşturma iznine sahip olup olmadığını tanımlayın.",
    "groupCreationControl": "Grup Oluşturma Kontrolü",
    "groupCreationControlDescription": "Hangi katkıda bulunanların grup oluşturmasına izin verildiğini kontrol edin.",
    "members": "Üyeler",
    "msOfficeEditing": "Word, Excel, Powerpoint Düzenleme",
    "msOfficeEditingDescription": "Üyelerin belgeleri doğrudan Microsoft Office çevrimiçi düzenleyicisiyle düzenlemesine izin verin.",
    "newButton": "Yeni",
    "security": "Güvenlik",
    "sessionControl": "Oturum Kontrolü",
    "sessionControlDescription": "Otomatik oturum kapatmadan önce üyelerin filegrant.net'te ne kadar süreyle oturum açmış kalacağını ayarlayın.",
    "sessions": "Oturumlar",
    "superAdmins": "Süper Yöneticiler",
    "uploadWithTag": "Etiketle Yükle",
    "uploadWithTagDescription": "Kaynak dosyalarda algılanan etiketi otomatik olarak yakalayın ve ayarlayın.",
    "withExpiration": "Son kullanma tarihi olan",
    "withoutExpiration": "Son kullanma tarihi olmadan",
    "addTag": "Etiket ekle",
    "openFileLocation": "Dosya konumunu aç",
    "loadingTags": "Etiketler yükleniyor...",
    "unlimited": "Sınırsız",
    "dropHereYourFirstFile": "İlk dosyanızı buraya bırakın",
    "noFilesReceived": "Henüz dosya alınmadı",
    "hereYouCanFindFavoritesFiles": "Burada favori dosyalarınızı bulabilirsiniz",
    "noRecentlyOpenedFiles": "Son açılan dosya yok",
    "hereYouCanFindSharedFiles": "Burada paylaşılan dosyaları bulabilirsiniz",
    "hereYouCanFindDeletedFiles": "Silinen dosyaları burada bulabilirsiniz",
    "noFiles": "Dosya yok",
    "loadingFiles": "Dosyalar yükleniyor...",
    "filesFetchFailed": "Dosyalar yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
    "shareDisabledNoRecipients": "Paylaşmak için en az bir kullanıcı veya grup ekleyin",
    "shareDisabledNoChanges": "Kaydedilecek değişiklik yok",
    "editorDisabledByPolicy": "Bu dosyalar için Düzenleyici iznine izin verilmiyor",
    "editorDisabledCannotElevate": "Bu paylaşımı Düzenleyici'ye yükseltemezsiniz",
    "hereYouCanFindHiddenFiles": "Burada gizli dosyaları bulabilirsiniz",
    "noFilesInThisFolder": "Bu klasörde dosya yok",
    "noGroupsFound": "Grup bulunamadı",
    "sell": "Sat",
    "loadingPermissions": "İzinler yükleniyor...",
    "me": "Ben",
    "applyTags": "Etiketleri uygula",
    "emptyTrash": "Çöp kutusunu boşalt",
    "classify": "Yapay Zeka Sınıflandırması",
    "active": "Etkin",
    "activeDescription": "Bu ayarı etkinleştirin veya devre dışı bırakın",
    "add": "Ekle",
    "rule": "Kural",
    "selectTags": "Etiketleri seçin",
    "manageExceptions": "İstisnaları yönet",
    "selectFolders": "Klasörleri seç",
    "selectUsers": "Kullanıcıları seçin",
    "selectGroups": "Grupları seçin",
    "selectDate": "Tarih seçin",
    "none": "Hiçbiri",
    "addRule": "Kural ekle",
    "addConfiguration": "Yapılandırma ekle",
    "aiAgents": "Yapay Zeka Aracıları",
    "daysLeft": "kalan günler",
    "disabled": "Devre Dışı",
    "enabled": "Etkinleştirilmiş",
    "months": "Ay",
    "years": "Yıl",
    "totpStatus": {
      "enabled": "2FA aktif",
      "enabledExempt": "2FA aktif (muaf)",
      "exempt": "2FA'dan muaf",
      "exemptExpires": "{{date}} tarihine kadar muaf"
    },
    "clientId": "Müşteri Kimliği",
    "clientSecret": "Müşteri Sırrı",
    "tenantId": "Organizasyon Kimliği",
    "domains": "Alan Adları",
    "addDomain": "Alan ekle",
    "addItem": "Öğe ekle",
    "artificialIntelligence": "Yapay Zeka",
    "artificialIntelligenceSummary": "Yapay Zeka Özeti",
    "artificialIntelligenceDocumentChat": "Yapay zeka belge sohbeti",
    "generatingSummary": "Özet oluşturuluyor",
    "startNewConversation": "Yeni bir görüşme başlat",
    "groupMembership": "Grup üyeliği",
    "expired": "Süresi doldu",
    "onlyExpired": "Süre sonu",
    "expiredOnly": "Yalnızca süresi dolmuş",
    "expiringWithinDays": "Süresi dolacak",
    "expiringWithinDaysOption": "{{count}} gün",
    "expiringWithinDaysOption_one": "{{count}} gün",
    "sharedBy": "Paylaşan",
    "shareRequests": "Paylaşım talepleri",
    "fileShareRequests": "Dosya paylaşım istekleri",
    "noShareRequests": "Paylaşım isteği yok",
    "activityLog": "Etkinlik günlüğü",
    "targetType": "Hedef türü",
    "operationType": "İşlem türü",
    "fromDate": "Başlangıç tarihi",
    "toDate": "Bitiş tarihi",
    "classificationStatus": "IA Sınıflandırması",
    "invite": "Davet et",
    "send": "Gönder",
    "sendMessage": "Mesaj gönder",
    "target": "Hedef",
    "operation": "İşlem",
    "timestamp": "Zaman bilgisi",
    "export": "Dışa aktar",
    "exportActivityLogsDescription": "Görünür etkinlik günlüklerini CSV dosyasına aktarın",
    "clickForDetailAiClassification": "Yapay zeka sınıflandırmasının detayı için tıklayın",
    "aiClassificationStatus": "AI Sınıflandırma Durumu",
    "noActivityLogsFound": "Etkinlik günlüğü bulunamadı",
    "activityLogQuickFilters": {
      "clearDatesAndOperation": "Tarih ve tür filtrelerini temizle",
      "downloads24h": "Son 24 saatteki dosya indirmeleri",
      "failedLogins7d": "Son 7 gündeki başarısız girişler",
      "last24hAllActivity": "Son 24 saatteki tüm etkinlik",
      "last24hLogins": "Son 24 saatteki girişler",
      "last7DaysAllActivity": "Son 7 gündeki tüm etkinlik",
      "sharing7d": "Son 7 gündeki dosya paylaşımları",
      "title": "Hızlı filtre ön ayarları"
    },
    "waitingForUpload": "Yükleme bekleniyor",
    "waitingForNetwork": "Ağ bekleniyor",
    "uploadsPausedWaitingForNetwork": "Yüklemeler duraklatıldı — ağ bağlantısı bekleniyor",
    "offline": "Çevrimdışı",
    "noPermissions": "Yetki yok",
    "additionalData": "Ek veriler",
    "noActivities": "Etkinlik yok",
    "multipleOwners": "Ortak sahipler",
    "mixed": "Karma",
    "firstName": "Ad",
    "lastName": "Soyad",
    "multipleExpiryDates": "Çoklu son kullanma tarihleri",
    "copied": "Kopyalandı!",
    "copy": "Kopyala",
    "editFile": "Dosyayı düzenle",
    "untitled": "Başlıksız",
    "editModeEnabled": "Düzenleme modu etkinleştirildi",
    "exitEditMode": "Düzenleme modundan çık",
    "editModeDisabled": "Düzenleme modu devre dışı bırakıldı",
    "reload": "Yeniden yükle",
    "forward10Seconds": "10 saniye ileri sar",
    "backward10Seconds": "10 saniye geriye doğru",
    "goToStart": "Başa Git",
    "goToEnd": "Sona git",
    "playbackSpeed": "Oynatma hızı",
    "error": "Hata",
    "shareAgain": "Tekrar paylaş",
    "expiringSoon": "Süresi yakında doluyor",
    "filterByTargetOrOperation": "Hedefe veya işleme göre filtrele",
    "searchByFileName": "Dosya adına göre ara",
    "versions": "Sürümler",
    "version": "Sürüm",
    "restore": "Geri Yükle",
    "showMoreVersions": "Daha fazla sürüm göster",
    "showLessVersions": "Daha az sürüm göster",
    "currentVersion": "Güncel sürüm",
    "bold": "Kalın",
    "italic": "İtalik",
    "link": "Bağlantı",
    "unorderedList": "Sırasız liste",
    "orderedList": "Sıralı liste",
    "header1": "Başlık 1",
    "header2": "Başlık 2",
    "header3": "Başlık 3",
    "paragraph": "Paragraf",
    "secondsAgo": "saniyeler önce",
    "all": "Tümü",
    "dataLossPrevention": "Veri Kaybını Önleme",
    "uploadSuccess": "Yükleme başarılı",
    "uploading": "Yükleniyor",
    "readOnly": "Salt Okunur",
    "aiScrapingProtectionOn": "AI Kazıma Koruması Açık",
    "openFileLocally": "Dosyayı yerel olarak aç",
    "reloadPage": "Sayfayı yeniden yükle",
    "reloadingPageIn": "Sayfa <strong>{{count}}</strong> konumuna yeniden yükleniyor",
    "keepOffline": "Çevrimdışı Tut",
    "openFileOnline": "Dosyayı çevrimiçi aç",
    "saveAndContinue": "Kaydet ve devam et",
    "cancelAndContinue": "İptal et ve devam et",
    "language": "Dil",
    "colorScheme": {
      "title": "Görünüm",
      "light": "Açık",
      "dark": "Koyu",
      "system": "Sistemi izle"
    },
    "accessibility": {
      "title": "Erişilebilirlik",
      "highContrast": "Yüksek kontrast",
      "reduceMotion": "Hareketi azalt",
      "none": "Kapalı",
      "activeCount": "{{count}} açık"
    },
    "impersonateUser": "Kullanıcı Olarak Giriş Yap",
    "protect": "Koru",
    "setPassword": "Şifreyi ayarla",
    "password": "Şifre",
    "stopImpersonation": "Kullanıcı Kimliğine Bürünmeyi Durdur",
    "loggedInAs": "olarak giriş yapıldı",
    "enterReason": "Kimliğe bürünme nedenini girin...",
    "timeRemaining": "Kalan süre",
    "notifications": "Bildirimler",
    "clear": "Temizle",
    "markAllRead": "Tümünü okundu olarak işaretle",
    "clearAll": "Tümünü temizle",
    "noNotifications": "Bildirim yok",
    "batches": "Toplu İşler",
    "noActiveBatches": "Aktif grup yok",
    "refresh": "Yenile",
    "refreshCooldown": "Tekrar yenilemeden önce lütfen {{seconds}}s bekleyin",
    "minutes": "dakika",
    "justNow": "Şu anda",
    "minutesAgo": "{{count}} dakika önce",
    "minutesAgo_other": "{{count}} dakika önce",
    "hoursAgo": "{{count}} saat önce",
    "hoursAgo_other": "{{count}} saat önce",
    "daysAgo": "{{count}} gün önce",
    "daysAgo_other": "{{count}} gün önce",
    "monthsAgo": "{{count}} ay önce",
    "monthsAgo_other": "{{count}} ay önce",
    "yearsAgo": "{{count}} yıl önce",
    "yearsAgo_other": "{{count}} yıl önce",
    "inMinutes": "{{count}} dakika içinde",
    "inMinutes_other": "{{count}} dakika içinde",
    "inHours": "{{count}} saat içinde",
    "inHours_other": "{{count}} saat içinde",
    "inDays": "{{count}} gün içinde",
    "inDays_other": "{{count}} gün içinde",
    "inMonths": "{{count}} ay içinde",
    "inMonths_other": "{{count}} ay içinde",
    "inYears": "{{count}} yıl içinde",
    "inYears_other": "{{count}} yıl içinde",
    "fileNotFound": "Dosya bulunamadı",
    "selectAll": "Tümünü seç",
    "clearSelection": "Seçimi temizle",
    "import": "İçe Aktar",
    "noFilesMatchingFilters": "Filtrelerle eşleşen dosya yok, bazı filtreleri kaldırmayı veya arama kriterlerini değiştirmeyi deneyin",
    "noUsersMatchingFilters": "Filtrelerle eşleşen kullanıcı yok, bazı filtreleri kaldırmayı veya arama kriterlerini değiştirmeyi deneyin",
    "noGroupsMatchingFilters": "Filtrelerle eşleşen grup yok. Filtrelerden bazılarını kaldırmayı veya arama kriterlerini değiştirmeyi deneyin",
    "AIGrant": "Yapay Zekâ Erişimi",
    "emailGrant": "E-posta Erişimi",
    "searchTags": "Etiket Ara",
    "expand": "Genişlet",
    "showMore": "Daha fazla göster",
    "collapse": "Daralt",
    "manageUsersAndGroups": "Kullanıcı ve Grupları Yönet",
    "public": "Genel",
    "private": "Özel",
    "approved": "Onaylandı",
    "rejected": "Reddedildi",
    "pending": "Beklemede",
    "pendingApprovalTooltip": "Onay bekleniyor, istendi {{date}}",
    "approvedByTeamTooltip": "Paylaşım {{date}} ekibi tarafından onaylandı",
    "rejectedByTeamTooltip": "Paylaşım {{date}} ekibi tarafından reddedildi",
    "reject": "Reddet",
    "rejectFileShareRequest": "Dosya paylaşım isteğini reddet",
    "rejectionReason": "Reddetme Sebebi",
    "rejectionReasonPlaceholder": "Reddedilme nedenini girin",
    "moreOwners": "Diğer Sahipler",
    "permissionLevel": "İzin düzeyi",
    "name": "Ad",
    "approve": "Onayla",
    "from": "Kimden",
    "to": "Kime",
    "requester": "Talep eden",
    "shareTo": "Şununla Paylaş",
    "limitation": "Kısıtlama",
    "selectRequestToViewDetails": "Ayrıntıları görüntülemek için bir istek seçin",
    "shareRequestApprovalTitle": "{{fileName}} için paylaşım isteği onayı",
    "noFilesAvailable": "Kullanılabilir dosya yok",
    "accessDenied": "Erişim engellendi",
    "fileShareRequestsList": "Dosya paylaşım istekleri listesi",
    "fileShareRequestsDescription": "Dosya paylaşım isteklerini onaylayın veya reddedin. Ayrıntılarını görüntülemek için sol taraftaki bir isteğe tıklayın.",
    "waiting": "Bekliyor",
    "tagIsUsedForFileVisibility": "Bu etikete sahip dosyalar, Etiketli Dosya Görünürlüğü ayarında ayarlandığı şekilde diğer kullanıcılarla paylaşılır",
    "systemTagLocked": "Sunucu tarafından yönetilen sistem etiketi: kaldırılamaz.",
    "tagRemovalRestricted": "Yöneticiniz bu etiketin dosyalardan kaldırılmasına izin vermiyor.",
    "tagAdditionRestricted": "Yöneticiniz bu etiketin dosyalara eklenmesine izin vermiyor.",
    "completingLogin": "Giriş Tamamlanıyor",
    "redirectingToLogin": "Giriş yapmaya yönlendiriliyorsunuz...",
    "redirecting": "Yönlendiriliyor...",
    "twoFactorAuthentication": "İki Faktörlü Kimlik Doğrulama",
    "debug": "Debug",
    "sessionExpiresIn": "Bu klasör {{time}} konumunda tekrar kilitlenecek",
    "protectedFolder": "Korumalı klasör",
    "sessionsTitle": "{{fileName}} için oturumların kilidini açın",
    "folderSessions": "Klasör Oturumları",
    "publicLinks": "Genel Bağlantılar",
    "revoke": "İptal Et",
    "revokeLink": "Bağlantıyı İptal Et",
    "revokeLinkConfirmDescription": "{{fileName}} için genel bağlantı iptal edilsin mi?",
    "protectedContentTitle": "Korumalı içerik",
    "protectedContentMessage": "Bu içerik bir şifre ile korunmaktadır. Erişmek için şifreyi girin.",
    "accessCodeRequired": "Şifre gerekli.",
    "accessCodeLabel": "Erişim Kodu",
    "accessCodePlaceholder": "Erişim kodunu girin",
    "access": "Erişim",
    "folderContents": "Klasör içeriği",
    "sharedAt": "Paylaşıldığı yer",
    "alerts": {
      "moreCount": "{{count}} daha fazla uyarı",
      "manageTwoFactor": "2FA'yı yönet",
      "dismissMenu": "Ertele veya kapat",
      "snoozePreset": {
        "h24": "1 gün",
        "h72": "3 gün",
        "h168": "1 hafta"
      },
      "snoozeHoursGeneric": "{{count}} saat"
    },
    "usersFetchFailed": "Kullanıcılar yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
    "groupsFetchFailed": "Gruplar yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
    "emailsFetchFailed": "E-postalar yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
    "pleaseSelectRole": "Lütfen bir rol seçin",
    "selectColor": "Renk seçin",
    "color": "Renk",
    "loadingActivities": "Etkinlikler yükleniyor...",
    "quickShareMessagePlaceholder": "Seçili kullanıcılara bir mesaj yazın...",
    "signFile": "Dosyayı imzala"
  },
  "roles": {
    "1000": "Süper Yönetici",
    "1001": "Yönetici",
    "2001": "Katkıda Bulunan",
    "3002": "Okuyucu",
    "4001": "Harici"
  },
  "accessMap": {
    "tagAccessTabLabel": "Erişim ve korumalar",
    "entityAccessTabLabel": "Etiketler ve korumalar",
    "visibility": "Görünürlük",
    "appliedProtections": "Uygulanan korumalar",
    "appliedTo": "Şuna uygulandı",
    "appliedToNobody": "Şu anda hiç kimse bu etiket aracılığıyla bu korumayı almıyor.",
    "configuration": "Yapılandırma",
    "exceptions": "İstisnalar",
    "exceptionsCount": "{{count}} istisna",
    "exceptionsCount_one": "{{count}} istisna",
    "exceptionsCount_other": "{{count}} istisna",
    "hasExceptionsTooltip": "Bazı alıcılar bu korumadan hariç tutulmuştur.",
    "openInSettings": "Ayarlarda aç",
    "noProtectionsForTag": "Bu etikete henüz hiçbir koruma uygulanmadı.",
    "noProtectionsForThisTag": "Bu etiketten miras alınan koruma yok.",
    "configureProtection": "Bir koruma yapılandır",
    "publicTagShort": "Genel",
    "privateTagShort": "Özel",
    "allUsersInCompany": "Şirketteki tüm kullanıcılar",
    "tagNotShared": "Bu etiket henüz hiç kimseyle paylaşılmadı.",
    "protectionsCount": "{{count}} koruma",
    "protectionsCount_one": "{{count}} koruma",
    "protectionsCount_other": "{{count}} koruma",
    "inheritedFromGroups": "Şu gruplar üzerinden görünür: {{groups}}",
    "tagsVisibleToGroup": "Bu gruba görünen etiketler ({{count}})",
    "tagsVisibleToUser": "Bu kullanıcıya görünen etiketler ({{count}})",
    "rulesAppliedToGroup": "Bu gruba uygulanan koruma kuralları ({{count}})",
    "rulesAppliedToUser": "Bu kullanıcıya uygulanan koruma kuralları ({{count}})",
    "userSeesNoTags": "Bu kullanıcı hiçbir etiketi görmüyor.",
    "groupSeesNoTags": "Bu grup hiçbir etiketi görmüyor.",
    "tagNoRulesLead": "Bu etikete sahip dosyalar bu grup için belirli bir kural tetiklemez.",
    "tagRulesLead": "Bu etikete sahip dosyalar şu kuralı etkinleştirir:",
    "tagRulesLead_one": "Bu etikete sahip dosyalar şu kuralı etkinleştirir:",
    "tagRulesLead_other": "Bu etikete sahip dosyalar şu {{count}} kuralı etkinleştirir:",
    "summary": {
      "action": "Eylem",
      "behaviour": "Davranış",
      "readOnlyRoles": "Salt okunur roller",
      "showRecipients": "Asıl alıcıları göster",
      "allowEdit": "Düzenlemeye izin ver",
      "readOnlyMode": "Salt okunur mod",
      "watermarkText": "Filigran metni",
      "placement": "Konum",
      "appliesToExternal": "Harici kullanıcı zorlaması",
      "approvedDomains": "Onaylanan alan adları",
      "maxExpirationDays": "İzin verilen maksimum süre",
      "excludedDomains": "Hariç tutulan alan adları",
      "excludedGroups": "Hariç tutulan gruplar",
      "requireApprovalOnShare": "Genel onay gereksinimi",
      "requireApprovalOnReshare": "Yalnızca yeniden paylaşılan dosyaların onayı",
      "reviewTeamSize": "İnceleme ekibi",
      "hiddenFileTypes": "Paylaşımdan sonra görünmez",
      "allowedApplications": "İzin verilen uygulamalar",
      "rolesAllowed": "Kitle"
    }
  },
  "alerts": {
    "codes": {
      "TOTP_NOT_ENABLED": {
        "message": "İki faktörlü kimlik doğrulama gereklidir. Hesabınızın güvenliğini sağlamak için etkinleştirin."
      },
      "LICENSE_EXPIRING": {
        "message": "Lisansınızın süresi {{expirationDate}} tarihinde doluyor ({{daysRemaining}} gün kaldı)."
      },
      "LOW_BACKUP_CODES": {
        "message": "Birkaç yedek kodunuz kaldı ({{remaining}}). Bunları iki faktörlü ayarlarda yeniden oluşturun."
      },
      "_generic": {
        "message": "Etkin bir bildiriminiz var ({{code}}). Yardıma ihtiyacınız varsa yöneticinizle iletişime geçin."
      }
    }
  },
  "errors": {
    "required": "Bu alan zorunludur",
    "minLength": "En az {{min}} karakter olmalıdır",
    "authenticatorCodeInvalid": "Kimlik doğrulayıcı kodu geçerli değil.",
    "authenticatorNotRemoved": "Kimlik doğrulayıcı kaldırılırken bir hata oluştu.",
    "authenticationUserBlocked": "Kullanıcı engellendi. Lütfen yöneticiyle iletişime geçin.",
    "authenticationUserExpired": "Kullanıcının süresi doldu. Lütfen yöneticiyle iletişime geçin.",
    "codeIncorrect": "Girdiğiniz kod hatalı. Lütfen tekrar deneyin.",
    "genericDeleteError": "{{resource}} silinirken bir hata oluştu. Lütfen tekrar deneyin veya sorun devam ederse destek ekibiyle iletişime geçin.",
    "genericError": "Bir hata oluştu. Lütfen tekrar deneyin veya sorun devam ederse destek ekibiyle iletişime geçin.",
    "genericFetchError": "{{resource}} getirilirken bir hata oluştu. Lütfen tekrar deneyin veya sorun devam ederse destek ekibiyle iletişime geçin.",
    "userProfileUnavailable": "Profiliniz yüklenemedi. Sorun çözülene kadar sınırlı izinlerle oturumunuz açık kalır.",
    "userProfileStale": "Profiliniz yenilenemedi. Son bilinen izinlerinizle oturumunuz açık kalır.",
    "userProfileRetry": "Yeniden dene",
    "alerts": {
      "dismissFailed": "Bu uyarı güncellenemedi. Lütfen tekrar deneyin.",
      "invalidSnooze": "Geçerli bir erteleme süresi seçin.",
      "fetchFailed": "Uyarılar yüklenemedi. Otomatik olarak yeniden deneyecekler."
    },
    "sessionsFetchError": "Oturumlar getirilirken hata oluştu.",
    "sessionsRevokeError": "Oturum iptal edilirken hata oluştu.",
    "sessionsRevokeForbiddenError": "Bu kullanıcının oturumlarını iptal etme izniniz yok.",
    "sessionsRevokeOthersError": "Diğer oturumlar iptal edilirken hata oluştu.",
    "sessionsRevokeAllError": "Tüm oturumlar iptal edilirken hata oluştu.",
    "genericUpdateError": "{{resource}} güncellenirken bir hata oluştu. Lütfen tekrar deneyin veya sorun devam ederse destek ekibiyle iletişime geçin.",
    "genericCreateError": "{{resource}} oluşturulurken bir hata oluştu. Lütfen tekrar deneyin veya sorun devam ederse destek ekibiyle iletişime geçin.",
    "invalidCredentials": "Yanlış e-posta veya şifre. Lütfen kimlik bilgilerinizi doğrulayın ve tekrar deneyin.",
    "invalidUsername": "Girdiğiniz kullanıcı adı geçerli değil.",
    "tokenInvalid": "Geçersiz token.",
    "tokenExpired": "Token süresi doldu",
    "unsavedChangesMessage": "Kaydedilmemiş değişiklikleriniz var. Bu değişikliklerden ayrılıp kaybetmek istediğinizden emin misiniz?",
    "unsavedChangesTitle": "Kaydedilmemiş Değişiklikler Algılandı.",
    "licenseExpired": "Lisansın süresi doldu. Lütfen lisansınızı yenileyin.",
    "licenseMaxUsersReached": "Bu lisans için maksimum kullanıcı sayısına ulaşıldı. Yeni kullanıcılar ekleyemez veya mevcut kullanıcılara harici olmayan roller atayamazsınız.",
    "mandatoryClassificationCannotRemove": "Tüm sınıflandırma etiketleri kaldırılamaz. Kuruluş ayarlarında zorunlu dosya sınıflandırması etkin olduğu için en az bir etiket kalmalıdır.",
    "tagRemovalDenied": "Seçili etiketlerden birini veya birkaçını bu dosyadan kaldırma izniniz yok.",
    "tagAdditionDenied": "Seçili etiketlerden birini veya birkaçını bu dosyaya ekleme izniniz yok.",
    "emailNotFound": "{{email}} e-posta adresi kayıtlı değil. Lütfen e-posta adresinizi doğrulayın ve tekrar deneyin.",
    "invalidEmailOrUsername": "Geçerli bir e-posta veya kullanıcı adı girin",
    "loginAliasNotValid": "Bu giriş takma adı geçerli değil. Yalnızca harf, rakam ve . _ - @ + ' kullanın (en fazla 256 karakter).",
    "loginAliasAlreadyUsed": "Bu giriş takma adı başka bir kullanıcı tarafından kullanılıyor.",
    "loginAliasAlreadyUsedAsEmail": "Bu e-posta başka bir kullanıcının giriş takma adı olarak kullanılıyor.",
    "otpExpired": "OTP'nin süresi doldu. Lütfen yeni bir OTP isteyin.",
    "totpWrong": "Geçersiz 2FA kodu. Lütfen tekrar deneyin.",
    "temporaryTotpExpired": "Geçici TOTP süresi doldu",
    "errorAdminTotpResetNotAllowed": "2FA devre dışı bırakılamıyor: kuruluşunuz yöneticilerin kullanıcı TOTP'sini sıfırlamasına izin vermiyor. Bir süper yönetici, İki Faktörlü Kimlik Doğrulama (TOTP) ayarlarında buna izin verebilir.",
    "transferOwnershipFailed": "Sahiplik devredilemedi. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.",
    "otpRequestLimitExceeded": "OTP isteme sınırını aştınız. Lütfen daha sonra tekrar deneyin.",
    "requestFilePermissions": "İzinlerinizi yenilemek için dosyanın sahibiyle iletişime geçmeyi deneyin",
    "noUploadPermission": "Bu konuma dosya yükleme izniniz yok.",
    "publicLinkClassificationRequired": "Genel bağlantı oluşturulmadan önce dosyanın sınıflandırılması gerekir.",
    "publicLinkPasswordRequired": "Herkese açık bağlantılar için şifre gereklidir.",
    "publicLinkMaxAccessCountRequired": "Maksimum erişim sayısı gerekli.",
    "publicLinkExpirationRequired": "Son kullanma tarihi gereklidir.",
    "publicLinkExpirationExceeded": "Son kullanma tarihi izin verilen maksimum gün sayısını aşıyor.",
    "publicLinkExpirationInPast": "Son kullanma tarihi gelecekteki bir tarih olmalıdır.",
    "publicLinkFolderPasswordProtected": "Parola korumalı klasörler veya bunların içindeki dosyalar için genel bağlantı oluşturulamıyor. Genel bağlantı yoluyla paylaşmak için klasördeki şifre korumasını kaldırın.",
    "publicLinkDownloadRestricted": "Bu dosya veya etiketleri için İndirme Şifreleme Zorlaması etkin olduğundan genel bağlantı oluşturulamıyor. Genel bağlantı yoluyla paylaşmak için İndirme Şifreleme Zorunluluğu ayarındaki kısıtlamayı kaldırın.",
    "publicLinkAnticaptureActive": "Bu dosya veya etiketleri için Yakalama önleme modu etkin olduğundan genel bağlantı oluşturulamıyor. Genel bağlantı yoluyla paylaşmak için dosyadan veya geçerli etiket ayarlarından Yakalama Önleme'yi kaldırın.",
    "publicLinkExternalSharingRestricted": "Bu dosya veya etiketleri için Harici Paylaşım Kısıtlamaları etkin olduğundan genel bağlantı oluşturulamıyor. Genel bağlantı aracılığıyla paylaşmak için Harici Paylaşım Kısıtlamaları ayarında geçerli sınırları kaldırın.",
    "publicLinkResharingDenied": "Bu dosya veya etiketleri için yeniden paylaşıma izin verilmediğinden genel bağlantı oluşturulamıyor. Genel bağlantı yoluyla paylaşmak için Dosya Yeniden Paylaşım İzinleri ayarını gözden geçirin ve güncelleyin.",
    "publicLinkDownloadTagsRestricted": "Bu dosya veya etiketleri için indirme kısıtlamaları etkin olduğundan genel bağlantı oluşturulamıyor. Genel bağlantı yoluyla paylaşmak için İzin Verilen Etiketleri İndir ayarını inceleyin.",
    "publicLinkApprovalRequired": "Bu dosya veya etiketleri için paylaşım onayı gerektiğinden genel bağlantı oluşturulamıyor. Genel bağlantı aracılığıyla paylaşmak için Paylaşım Onayı Gereksinimleri ayarını inceleyin.",
    "publicLinkMandatoryExpiration": "Bu dosya veya etiketleri için zorunlu süre sonu politikası etkin olduğundan genel bağlantı oluşturulamıyor. Genel bağlantı aracılığıyla paylaşmak için son kullanma tarihinin Zorunlu Sona Erme Tarihi Paylaşılan Dosya ayarında tanımlanan sınır dahilinde olduğundan emin olun.",
    "tagsAmountLimitReached": "20'den fazla etiket oluşturamazsınız.",
    "hitASnag": "Bir sorun oluştu",
    "noPermission": "Bu işlemi gerçekleştirme izniniz yok.",
    "errorDownloadFile": "Dosya indirilirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "errorDuplicateFile": "Dosya çoğaltılırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "errorMoveFile": "Dosya taşınırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "denyFileMove": "Bu dosya için taşıma izni yok.",
    "errorDeleteFiles": "Dosyalar silinirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "errorHideFiles": "Dosyalar gizlenirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "errorUploadFile": "Dosya yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "cannotAddArchivedFilesToFavorites": "Arşivlenmiş dosyalar favorilere eklenemez.",
    "cannotDeleteMultiplePasswordProtected": "Birden fazla parola korumalı klasör kilitli olduğundan seçili öğeler silinemiyor. Lütfen her klasörün kilidini ayrı ayrı açın ve tekrar deneyin.",
    "cannotUnlockMultiplePasswordProtected": "Birden fazla parola korumalı klasörün kilidi aynı anda açılamaz. Lütfen her klasörün kilidini ayrı ayrı açın.",
    "groupNameCannotBeEmail": "Grup adı bir e-posta adresi olamaz.",
    "invalidFolder": "Geçersiz klasör",
    "invalidFolderUpload": "Yüklemeye çalıştığınız klasör mevcut değil veya desteklenmiyor.",
    "zeroByteFileNotUploaded": "Sıfır baytlık dosyalar yüklenmez. Lütfen içerikli dosyaları seçin.",
    "loginFailed": "Giriş başarısız",
    "unauthorized": "Kimlik doğrulama başarısız oldu. Lütfen tekrar deneyin.",
    "forbidden": "Erişim engellendi",
    "serverError": "Sunucu hatası. Lütfen daha sonra tekrar deneyin.",
    "tooManyRequests": "Çok fazla istek var. Lütfen daha sonra tekrar deneyin.",
    "oauthAccessDenied": "Erişim kullanıcı tarafından reddedildi",
    "oauthInvalidCallback": "Geçersiz OAuth geri araması",
    "oauthStateMismatch": "Güvenlik doğrulaması başarısız oldu",
    "oauthContextMissing": "OAuth bağlamı eksik",
    "oauthProviderNotEnabled": "OAuth sağlayıcısı etkin değil",
    "oauthNotEnabled": "Bu kiracı için Doğrudan OAuth etkinleştirilmedi",
    "oauthDomainNotAllowed": "E-posta etki alanına izin verilmiyor",
    "oauthEmailMismatch": "Girdiğiniz e-postadan farklı bir hesapla oturum açtınız. Lütfen doğru hesapla oturum açın.",
    "oauthCodeExchangeFailed": "Yetkilendirme kodu değiştirilemedi",
    "oauthTokenValidationFailed": "Jeton doğrulaması başarısız oldu",
    "oauthInvalidTenant": "Geçersiz kiracı",
    "oauthSessionExpired": "Oturumun süresi doldu. Lütfen tekrar deneyin.",
    "sessionExpired": "Oturumunuzun süresi doldu. Devam etmek için lütfen tekrar giriş yapın.",
    "filePasswordLockout": "Bu klasör çok fazla başarısız deneme nedeniyle kilitlendi. {{minutes}} dakika sonra tekrar deneyin.",
    "getViewerData": "Görüntüleyici verileri alınırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "protectedLinkAlreadyUsed": "Bağlantı zaten kullanıldı, yeni bir kod oluşturun",
    "protectedLinkAlreadyUsedOrExpired": "Bağlantı zaten kullanıldı veya süresi doldu, yeni bir kod oluşturun",
    "fileAccessSessionExpired": "Oturum süresi doldu, yeni bir kod oluşturun",
    "protectedFileDownloadOnlyForWindows": "Korumalı dosya indirme yalnızca Windows platformunda mevcuttur.",
    "antiCaptureActivated": "Bu öğe, yakalama önleme ayarlarıyla korunmaktadır.",
    "downloadRestrictionActivated": "Bu öğe indirme kısıtlama ayarlarıyla korunmaktadır.",
    "watermarkProtectionDownloadDenied": "Bu dosya korumalıdır ve indirilemez. Yine de görüntüleyebilirsiniz.",
    "antivirusFileInfected": "Antivirüs tehdit algıladığı için bu dosya açılamaz veya paylaşılamaz.",
    "antivirusFileInfectedNamed": "Antivirüs {{fileName}} içinde {{threatName}} algıladı.",
    "antivirusRescanNotAllowed": "Bu dosya için antivirüs yeniden taraması isteme izniniz yok.",
    "antivirusNotAvailable": "Antivirüs taraması şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.",
    "fileSizeTooBigForDownload": "Dosya, 250 MB sınırını aştığı için şifreli modda indirilemez.",
    "fileNotAvailable": {
      "title": "Dosya artık mevcut değil",
      "description": "Erişmeye çalıştığınız dosya artık mevcut değil. Silinmiş veya taşınmış olabilir."
    },
    "publicLinkNotFoundTitle": "Bu bağlantı kullanılamıyor",
    "publicLinkNotFoundMessage": "Bu bağlantı mevcut değil, kaldırılmış veya artık erişilebilir değil.",
    "publicLinkItemNotAvailable": "Bu öğe kullanılamıyor",
    "publicLinkExpiredTitle": "Bağlantının süresi doldu",
    "publicLinkExpiredMessage": "Bu bağlantının süresi doldu ve artık geçerli değil.",
    "publicLinkMaxAccessTitle": "Erişim sınırına ulaşıldı",
    "publicLinkMaxAccessMessage": "Bu bağlantı için maksimum erişim sayısına ulaşıldı.",
    "invalidAccessCode": "Girdiğiniz şifre hatalı. Lütfen tekrar deneyin.",
    "fileSizeUploadLimit": "Dosya boyutu {{value}} mb olan yükleme sınırını aşıyor",
    "fileSizeExceedsAdminLimit": "Dosya yüklenemiyor: boyut, yönetici tarafından belirlenen maksimum sınırı aşıyor.",
    "fileSizeExceedsLicenseLimit": "Dosya yüklenemiyor: boyut, lisansta belirlenen maksimum sınırı aşıyor.",
    "uploadingFileError": "Dosya yüklenirken bir sorun oluştu.",
    "uploadInterrupted": "Yükleme kullanıcı tarafından iptal edildi.",
    "fileTypeRestrictionError": "Uygulanan ayarlar nedeniyle bu dosya türü yüklenemiyor.",
    "quickShareError": "Dosyalar paylaşılırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "quickShareFilesNotUploaded": "{{ count }} dosyası başarıyla yüklenemedi. Başarıyla yüklenen dosyaları yine de paylaşmak için Devam'ı tıklayın.",
    "quickShareFilesNotUploaded_other": "{{ count }} dosya başarıyla yüklenemedi. Başarıyla yüklenen dosyaları yine de paylaşmak için Devam'ı tıklayın.",
    "enterOnBehalfOfUserFailed": "Kullanıcı adına girilemedi. Lütfen tekrar deneyin.",
    "exitOnBehalfOfUserFailed": "Kullanıcı adına çıkılamadı. Lütfen tekrar deneyin.",
    "reasonRequired": "Lütfen kullanıcı adına giriş yapmak için bir neden girin",
    "reasonMinLength": "Sebep en az 3 karakter olmalıdır",
    "impersonatedUserNotNotified": "Kullanıcı e-posta ile bilgilendirilemedi (hesapta e-posta adresi yok)",
    "quickShareFilesNotShared": "Dosyalar başarıyla paylaşılmadı. Başarıyla yüklenen dosyaları yine de paylaşmak için Devam'ı tıklayın.",
    "filesNotShared": "Dosyalar paylaşılmadı.",
    "fileSizeExceedsLimit": "Dosya boyutu {{value}} sınırını aşıyor.",
    "otpWrong": "OTP kodu yanlış. Lütfen tekrar deneyin.",
    "groupNameAlreadyUsed": "Grup adı zaten kullanılıyor.",
    "updateFileAccessError": "Dosya erişimi güncellenirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "deleteFileAccessError": "Dosya erişimi silinirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "errorCreateFileShortcut": "Dosya kısayolu oluşturulurken bir sorun oluştu. Lütfen tekrar deneyin.",
    "openShortcutFileError": "Hata! Görünüşe göre bağlantılı dosya artık mevcut değil. Kaldırılmış veya erişim iptal edilmiş olabilir.",
    "confirmationMessageMatch": "Onay mesajı eşleşmiyor.",
    "emailExist": "E-posta zaten mevcut.",
    "shareFiles": "Dosyaların paylaşılmasında bir sorun oluştu. Lütfen tekrar deneyin.",
    "genericSellError": "Dosya satılık olarak listelenirken bir hata oluştu.",
    "someItemsCannotBeSelected": "Bazı öğeler seçilemiyor",
    "invalidMicrosoftEntraIdToken": "Microsoft Entra ID jetonu geçerli değil veya süresi dolmuş.",
    "atLeastOneOption": "En az bir seçenek seçmelisiniz",
    "groupNameAlreadyExists": "Grup adı zaten kullanılıyor.",
    "cannotAddSuperAdminToGroup": "Bir gruba Süper Yönetici ekleyemezsiniz.",
    "editSharingDenied": "Zaten paylaşılmış olan dokümanların erişim haklarını düzenleme izniniz yok. Bir kullanıcı listede görünmüyorsa bu onun zaten aktif bir paylaşımı olduğu anlamına gelir.",
    "errorRemoveShareFiles": "Paylaşım dosyaları kaldırılırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "noFileClassificationAvailable": "Şu anda dosya sınıflandırması mevcut değil",
    "errorPermanentlyDeleteFiles": "Dosyalar kalıcı olarak silinirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "aiDocumentChatError": "Dokümanla sohbet edilirken bir hata oluştu. Lütfen tekrar deneyin.",
    "filesAlreadyClassified": "Dosyalar zaten sınıflandırılmış",
    "filesBeingClassified": "Dosyalar şu anda sınıflandırılıyor",
    "filesBeingClassifiedDescription": "Lütfen yeni bir sınıflandırma işlemine başlamadan önce mevcut sınıflandırma işleminin tamamlanmasını bekleyin.",
    "filesTooBig": "Dosyalar sınıflandırma için boyut sınırını aşıyor",
    "filesTooBigDescription": "AI sınıflandırması için izin verilen maksimum dosya boyutu 250 MB'tır. Lütfen daha küçük dosyaları seçin.",
    "tooManyFiles": "Çok fazla dosya seçildi",
    "tooManyFilesDescription": "{{files}} dosya seçildi; üst sınır {{limit}}. Seçimi azaltıp yeniden deneyin.",
    "rejectionReasonRequired": "Reddetme nedeni gerekli",
    "rejectionReasonMinLength": "Reddetme nedeni en az 3 karakter olmalıdır",
    "fileAlreadyInUseError": "Dosya zaten başka bir kullanıcı tarafından kullanılıyor.",
    "contentHashMismatchError": "Yükleme sırasında dosya bozuldu (hash uyuşmuyor)",
    "fileIntegrityCheckFailed": "Dosya bütünlüğü kontrolü başarısız oldu",
    "fileIntegrityCheckFailedDescription": "İndirilen dosya bozulmuş olabilir. Lütfen tekrar indirmeyi deneyin.",
    "fileIntegrityCheckError": "Dosya bütünlüğü kontrol hatası",
    "fileIntegrityCheckErrorDescription": "Dosya bütünlüğü doğrulanamadı ancak indirme işlemi devam edecek.",
    "storageUrlFetchFailed": "Depolama URL'si alınamadı",
    "storageUrlFetchFailedDescription": "Lütfen adresi kontrol edip tekrar deneyin: <strong>{{tenantAddress}}</strong>.",
    "folderPasswordRequired": "Bu klasör şifre doğrulaması gerektiriyor",
    "folderPassword": {
      "passwordRequired": "Şifre gereklidir.",
      "tooShort": "Şifre en az 4 karakter olmalıdır.",
      "ownerOnly": "Bu işlemi yalnızca klasör sahibi yapabilir.",
      "alreadyExists": "Bu klasörde zaten şifre koruması var.",
      "ancestorProtected": "Üst klasör şifre korumalı olduğu için bu işlem yapılamaz.",
      "descendantProtected": "Alt klasör şifre korumalı olduğu için bu işlem yapılamaz.",
      "notSet": "Bu klasör için şifre koruması yapılandırılmamış.",
      "notProtected": "Bu klasör şifre korumalı değil.",
      "currentRequired": "Mevcut şifre gereklidir.",
      "expired": "Klasör şifre korumasının süresi doldu. Lütfen klasör sahibiyle iletişime geçin.",
      "incorrect": "Mevcut klasör şifresi hatalı. Lütfen tekrar deneyin.",
      "sessionNotFound": "Oturum bulunamadı veya zaten iptal edildi.",
      "sessionForbidden": "Bu oturumu yönetme izniniz yok.",
      "otpNotRequested": "OTP istenmedi. Lütfen yeni bir kod isteyin."
    },
    "notAFolder": "Seçilen öğe bir klasör değil",
    "ipRegionBlocked": {
      "message": "Bulunduğunuz konumdan erişim reddedildi.",
      "loginTitle": "Erişim reddedildi",
      "loginMessage": "Bulunduğunuz konumdan erişim reddedildi.",
      "loginGeneric": "Bulunduğunuz konumdan erişim reddedildi.",
      "fileOperationTitle": "İşleme izin verilmiyor",
      "fileOperationMessage": "Bulunduğunuz konumdan erişim reddedildi."
    },
    "ipRegionAdminLockout": {
      "title": "Yönetici IP kısıtlaması etkinleştirilemiyor",
      "message": "Mevcut IP adresiniz izin verilen yönetici IP adresleri arasında yer almalıdır, aksi halde yönetici ayarlarına erişiminizi kaybedersiniz."
    },
    "dateMustBeFuture": "Tarih gelecekte olmalıdır",
    "externalSharingNotAllowed": "Aşağıdaki alıcıların harici paylaşımı alma yetkisi yok: {{recipients}}",
    "sharingNotAllowedMandatoryTag": "Eklerin gönderilmeden önce bir sınıflandırma etiketi olması gerekir",
    "fileSharingDenied": "Bu işlem için dosya paylaşımına izin verilmiyor.",
    "cannotAccessFiles": "İstenilen dosyalardan bir veya daha fazlasına erişemiyorsunuz.",
    "partialSharingDenied": "Bazı dosyalar seçilen alıcılarla paylaşılamaz.",
    "partialSharingDeniedDisabledRecipients": "Seçilen bazı kullanıcıların veya grupların bu dosyalar için zaten paylaşımı var, ancak şu anda devre dışı. Her alıcının yanındaki {{shareAgainLabel}} düğmesiyle yeniden etkinleştirebilirsiniz.",
    "passKeyDataRequired": "Geçiş anahtarı verileri eksik veya geçersiz. Lütfen tekrar deneyin.",
    "passKeyForbidden": "Bu eylemi gerçekleştirme izniniz yok.",
    "passKeyLimitReached": "Maksimum şifre anahtarı sayısına ulaştınız. Başkasını eklemeden önce birini kaldırın.",
    "passKeyLockedOut": "Çok fazla başarısız geçiş anahtarı denemesi. Lütfen daha sonra tekrar deneyin veya başka bir oturum açma yöntemi kullanın.",
    "passKeyNotAllowed": "Bu şifre anahtarı eylemine izin verilmiyor.",
    "passKeyNotEnabled": "Hesabınız veya kuruluşunuz için geçiş anahtarları etkinleştirilmedi.",
    "passKeyNotFound": "Geçiş anahtarı bulunamadı. Kaldırılmış veya artık geçerli değil olabilir.",
    "passKeySessionExpired": "Geçiş anahtarı oturumu sona erdi. Lütfen baştan tekrar deneyin.",
    "passKeyVerificationFailed": "Kimlik bilgisi bulunamadı veya şifresiz oturum açma için etkinleştirilmedi.",
    "batchNotFound": "Toplu iş bulunamadı veya erişiminiz yok.",
    "batchNotCancellable": "Bu toplu iş iptal edilemez (sınıflandırma toplu işi değil).",
    "batchAlreadyFinished": "Bu işlem zaten tamamlandı.",
    "batchRetryNotSupported": "Yeniden deneme yalnızca sınıflandırma toplu işleri için desteklenir.",
    "noFileJobsFound": "Seçilen dosyalardan hiçbiri mevcut durumunda iptal edilemez veya yeniden denenemez.",
    "queueUnavailable": "İşleme kuyruğu geçici olarak kullanılamıyor. Lütfen daha sonra yeniden deneyin.",
    "ldap": {
      "ACTIVE_DIRECTORY_NOT_AVAILABLE": "Active Directory senkronizasyonu bu kurulum veya lisans için kullanılamıyor.",
      "LDAP_NOT_CONFIGURED": "Active Directory henüz yapılandırılmadı. Önce LDAP ayarları sayfasını açın.",
      "LDAP_CONFIGURATION_INVALID": "LDAP yapılandırması geçersiz. Vurgulanan alanları düzeltip tekrar kaydedin.",
      "LDAP_CREDENTIAL_REQUIRED": "Bind parolası gerekli. Servis hesabı parolasını girin.",
      "LDAP_UNREACHABLE": "Etki alanı denetleyicisine ulaşılamıyor — ana bilgisayar, bağlantı noktası ve güvenlik duvarını kontrol edin.",
      "LDAP_TLS_FAILED": "Sertifikaya güvenilmiyor — ayarlarda dahili CA yükleyin veya güvenlik/bağlantı noktası eşleşmesini kontrol edin.",
      "LDAP_BIND_FAILED": "Servis hesabı reddedildi — bind DN ve parolayı kontrol edin.",
      "LDAP_BASE_DN_NOT_FOUND": "Bind başarılı ancak base DN bulunamadı — base DN'yi kontrol edin.",
      "LDAP_SEARCH_FAILED": "Dizin aramayı reddetti — filtreleri kontrol edin.",
      "LDAP_CREDENTIAL_ENCRYPTION_FAILED": "Sunucu hatası, destek ile iletişime geçin.",
      "rateLimited": "Çok fazla istek, bir dakika sonra yeniden deneyin."
    },
    "pdfConversionUnsupportedFormat": "Bu dosya formatı PDF dönüştürme için desteklenmiyor.",
    "pdfConversionFileTooLarge": "Dosya dönüştürme için çok büyük. Maksimum boyut {{maxSizeMb}} MB.",
    "pdfConversionFailed": "PDF dönüştürme başarısız oldu. Lütfen tekrar deneyin.",
    "pdfConversionAntivirusBlocked": "PDF dönüştürme engellendi: dosya bir tehdit içeriyor.",
    "fileNotFound": "Dosya bulunamadı.",
    "outboundEmail": {
      "OUTBOUND_EMAIL_NOT_AVAILABLE": "Özel e-posta alanı bu hesap veya lisans için kullanılamaz.",
      "OUTBOUND_EMAIL_CONFIG_INVALID": "Giden e-posta yapılandırması geçersiz. Vurgulanan alanları düzeltip yeniden kaydedin.",
      "OUTBOUND_EMAIL_NOT_CONFIGURED": "Doğrulamadan önce bir alan adı yapılandırması kaydedin.",
      "OUTBOUND_EMAIL_NOT_READY": "Özel gönderen henüz hazır değil (kapalı, doğrulanmamış veya Mailgun aktif değil).",
      "OUTBOUND_EMAIL_CONCURRENT_CHANGE": "Kontrol sırasında yapılandırma değişti. Durumu yenileyip yeniden deneyin.",
      "OUTBOUND_EMAIL_DNS_LOOKUP_FAILED": "DNS kontrolü kullanılamıyor, daha sonra yeniden deneyin.",
      "OUTBOUND_EMAIL_MAILGUN_FAILED": "Mailgun isteği başarısız. Sahiplik yine de kaydedilmiş olabilir — durumu yenileyin.",
      "OUTBOUND_EMAIL_TEST_FAILED": "Test e-postası gönderilemedi, daha sonra yeniden deneyin.",
      "rateLimited": "Çok fazla istek, kısa süre sonra yeniden deneyin."
    },
    "DIRECTORY_SYNC_ALREADY_RUNNING": "Bu şirket için başka bir dizin senkronizasyonu çalışıyor. Bitince yeniden deneyin."
  },
  "notifications": {
    "genericUpdateSuccess": "{{resource}} başarıyla güncellendi.",
    "genericCreateSuccess": "{{resource}} başarıyla oluşturuldu.",
    "linkCopiedToClipboard": "Bağlantı panoya kopyalandı!",
    "codeCopiedToClipboard": "Kod panoya kopyalandı!",
    "fileProtectedWithAntiCapture": "Bu dosya, yakalama önleme özelliğiyle korunmaktadır Dosya içeriğini görüntülemek için, Filegrant Viewer'da istendiğinde bu kodu girin, işlem tamamdır!",
    "otpCopiedToClipboard": "OTP panoya kopyalandı!",
    "fileProtectedDownloadInProgress": "İndirme işlemi devam ediyor, indirme işleminin sonunda indirilen uygulamayı çalıştırın, dosyayı görüntülemek için yukarıda belirtilenleri girin.",
    "quickShareSuccess": "Dosyalar başarıyla paylaşıldı.",
    "fileLocatedInThisLocation": "Bu dosya zaten bu konumda bulunuyor.",
    "fileAccessRevoked": "Erişim hakları başarıyla iptal edildi.",
    "fileAccessUpdated": "Erişim hakları başarıyla güncellendi.",
    "fileVersionRestored": "Dosya sürümü başarıyla geri yüklendi.",
    "folderCreated": "{{resource}} klasörü başarıyla oluşturuldu.",
    "fileCreated": "{{resource}} dosyası başarıyla oluşturuldu.",
    "fileRenamed": "{{resource}} dosyası başarıyla {{newName}} olarak yeniden adlandırıldı.",
    "fileDuplicated": "{{resource}} dosyası başarıyla kopyalandı.",
    "fileDuplicated_other": "Dosyalar başarıyla kopyalandı.",
    "fileFavouriteChanged": "{{resource}} {{isFavourite}} favorileri başarıyla dosyalayın.",
    "fileFavouriteChanged_other": "{{isFavourite}} favorilere başarıyla eklendi.",
    "fileShortcutCreated": "Dosya {{resource}} kısayolu başarıyla oluşturuldu.",
    "fileMoved": "{{resource}} dosyası başarıyla taşındı.",
    "fileMoved_other": "Dosyalar başarıyla taşındı.",
    "emptyTrash": "Çöp kutusu başarıyla boşaltıldı.",
    "operationMayTakeTime": "Bu işlemin tamamlanması biraz zaman alabilir.",
    "fileRestored": "{{resource}} dosyası başarıyla geri yüklendi.",
    "fileRestored_other": "Dosyalar başarıyla geri yüklendi.",
    "fileHidden": "{{resource}} dosyası başarıyla gizlendi.",
    "fileHidden_other": "Dosyalar başarıyla gizlendi.",
    "fileUnhidden": "{{resource}} dosyası başarıyla gösterildi.",
    "fileUnhidden_other": "Dosyalar başarıyla gösterildi.",
    "filesMarkedAsRead_one": "Okundu olarak işaretlendi.",
    "filesMarkedAsRead_other": "{{count}} dosyalar okundu olarak işaretlendi.",
    "filesMarkedAsUnread_one": "Okunmadı olarak işaretlendi.",
    "filesMarkedAsUnread_other": "{{count}} dosyalar okunmadı olarak işaretlendi.",
    "folderLocked": "{{count}} klasörü kilitlendi.",
    "folderLocked_other": "{{count}} klasör kilitlendi.",
    "fileClassifying": "Dosya sınıflandırılıyor",
    "filesClassifying": "{{count}} dosyası sınıflandırılıyor",
    "filesClassifying_other": "{{count}} dosya sınıflandırılıyor",
    "filesClassifyingBatch": "{{count}} dosyalar toplu olarak sınıflandırılıyor",
    "filesClassifyingBatchWithSkipped": "{{count}} dosya sınıflandırma için sıraya alındı. {{skipped}} atlandı.",
    "folderClassifyingBatch": "Klasör içerikleri toplu olarak sınıflandırılıyor",
    "foldersClassifyingBatch": "{{count}} klasör toplu olarak sınıflandırılıyor",
    "fileTagsUpdated": "Dosya {{resource}} etiketleri başarıyla güncellendi.",
    "fileDeleted": "{{resource}} dosyası başarıyla silindi.",
    "fileDeleted_other": "Dosyalar başarıyla silindi.",
    "checkingFilesExistsCounter": "Dosyalar kontrol ediliyor: {{done}} / {{total}}",
    "checkingFoldersExistsCounter": "Klasörler kontrol ediliyor: {{done}} / {{total}}",
    "checkingFilesInFolderCounter": "{{folder}} · Dosyalar kontrol ediliyor: {{done}} / {{total}}",
    "checkingSubfoldersInFolderCounter": "{{folder}} · Klasörler kontrol ediliyor: {{done}} / {{total}}",
    "tags": {
      "title": "Dosya Etiketlendi",
      "description": "Dosya etiketlendi",
      "error": "AI sınıflandırması başarısız oldu.",
      "batchSuccessTitle": "Sınıflandırma toplu işlemi tamamlandı",
      "batchSuccessDescription": "{{total}} dosyadan {{processed}} sınıflandırıldı.",
      "batchFailedTitle": "Sınıflandırma toplu işlemi başarısız",
      "batchFailedDescription": "Toplu işlem hatalarla bitti ({{processed}}/{{total}})."
    },
    "summary": {
      "title": "Dosya Özeti",
      "description": "{{fileId}} dosyası için özet oluşturuldu",
      "ready": "Dosya özeti hazır.",
      "open": "Özeti aç"
    },
    "fileUnavailable": "Dosya kullanılamıyor",
    "suggestGridMode": {
      "title": "Bu klasörde yalnızca görseller var",
      "description": "Daha iyi önizleme için ızgara görünümüne geçin.",
      "action": "Izgaraya geç"
    },
    "documentClassification": {
      "title": "Belge Gizliliği",
      "description": "{{fileId}} dosyası için belge sınıflandırması tamamlandı"
    },
    "default": {
      "title": "Bildirim",
      "description": "Yeni bildirim alındı"
    },
    "sharing": {
      "title": "Yeni dosya paylaşıldı",
      "sharing_operation_download": "{{actorName}} indirildi {{fileName}}",
      "sharing_operation_open": "{{actorName}} açıldı {{fileName}}",
      "sharing_operation_edit": "{{actorName}} düzenlendi {{fileName}}",
      "sharing_operation_delete": "{{actorName}} silindi {{fileName}}",
      "sharing_operation_rename": "{{actorName}}, {{fileName}} olarak yeniden adlandırıldı",
      "sharing_operation_add": "{{actorName}} eklendi {{fileName}}",
      "sharing_operation_move": "{{actorName}} taşındı {{fileName}}",
      "sharing_operation_copy": "{{actorName}} kopyalandı {{fileName}}",
      "sharing_operation_unknown": "{{actorName}}, {{fileName}} üzerinde bir işlem gerçekleştirdi"
    },
    "folderPasswordSet": "Şifre koruması etkin",
    "folderPasswordUpdated": "Şifre koruması güncellendi",
    "folderPasswordRemoved": "Şifre koruması kaldırıldı",
    "unlockingFolder": "Klasörün kilidi açılıyor…",
    "folderUnlocked": "Klasörün kilidi başarıyla açıldı",
    "pdfConversionStarted": "{{resource}} PDF'ye dönüştürme başlatıldı.",
    "pdfConversionSuccess": "PDF dönüştürme başarıyla tamamlandı.",
    "pdfConversionFailed": "PDF dönüştürme başarısız oldu.",
    "pdfConversionStillRunning": "PDF dönüştürme hâlâ devam ediyor. Tamamlandığında bilgilendirileceksiniz."
  },
  "files": {
    "downloadPreparation": "İndirmeye hazırlanıyor",
    "downloadReady": "İndirmeye hazır",
    "compressionOfFilesInProgress": "Dosyaların sıkıştırılması devam ediyor",
    "compressionCompleted": "Sıkıştırma tamamlandı",
    "compressionFailed": "Sıkıştırma başarısız oldu"
  },
  "fileAccessNotification": {
    "enableActivityNotifications": "Etkinlik bildirimlerini etkinleştir",
    "includeSubfolders": "Alt klasörleri dahil et",
    "notifyOwner": "Sahibine bildir",
    "notifyRecipients": "Alıcılara bildir",
    "whoCanTrigger": "Bildirimleri kim tetikleyebilir?",
    "trigger": {
      "ownerOnly": "Yalnızca sahip",
      "anyone": "Herhangi biri"
    },
    "operation": {
      "download": "İndir",
      "open": "Aç",
      "edit": "Düzenle",
      "delete": "Sil",
      "rename": "Yeniden Adlandır",
      "add": "Ekle",
      "move": "Taşı",
      "copy": "Kopyala"
    },
    "configureNotifications": "Bildirimleri Yapılandır",
    "customizeFor": "Şunun için özelleştir:",
    "discardChangesTitle": "Değişiklikler silinsin mi?",
    "discardChangesDescription": "Kaydedilmemiş değişiklikleriniz var. Bunları atıp kapatmak mı istiyorsunuz?",
    "discardConfirm": "Değişiklikleri Sil",
    "notificationsDisabled": "Bildirimler devre dışı bırakıldı",
    "notificationsEnabled": "Bildirimler etkinleştirildi",
    "modalTitle": "Etkinlik bildirimleri"
  },
  "modal": {
    "saveTagsConfirm": {
      "title": "Etiket değişiklikleri kaydedilsin mi?",
      "description": "Etiketlerde kaydedilmemiş değişiklikleriniz var. Kapatmadan önce kaydet?"
    },
    "userGroupSelectorForm": {
      "title": "Kullanıcı/Grup Seçimi",
      "description": "Kullanıcı veya grup seçin",
      "currentMembers": "Mevcut Üyeler",
      "unsavedReviewTeam": "Kaydedilmemiş İnceleme Ekibi"
    },
    "tagUserGroupMultiSelectForm": {
      "title": "Kullanıcıları ve Grupları Yönetin",
      "description": "Bu etikete erişebilecek kullanıcıları ve grupları seçin",
      "usersAndGroups": "Kullanıcılar ve gruplar",
      "unsavedUsersAndGroups": "Kaydedilmemiş Kullanıcılar ve Gruplar"
    },
    "changeUserRole": {
      "title": "Kullanıcı rolünü değiştir",
      "description": "{{name}} rolünü {{initialRole}} yerine {{newRole}} olarak değiştirmek istediğinizden emin misiniz?"
    },
    "deleteUsersForm": {
      "title": "Kullanıcıyı sil",
      "title_other": "Kullanıcıları sil",
      "roleAdminOrContributor": "Silmek üzere olduğunuz kullanıcı Katkıda Bulunan veya Yöneticidir ve sisteme dosya yüklemiş olabilir. Bu kullanıcının silinmesi, yüklediği tüm dosyaların ve ilişkili tüm paylaşımların da silinmesine neden olacak ve artık platforma erişemeyecektir. Devam etmek istediğinizden emin misiniz? <i>(Onaylamak için \"{{keyword}}\" yazın.)</i>",
      "roleReader": "Silmek üzere olduğunuz kullanıcı bir Reader'dır ve başka kullanıcılar tarafından kendisiyle paylaşılan dosyalara sahip olabilir. Bu kullanıcının silinmesi, sisteme ve kendisiyle paylaşılan dosyalara erişmesini engelleyecektir. Devam etmek istediğinizden emin misiniz? <i>(Onaylamak için \"{{keyword}}\" yazın.)</i>",
      "roleExternal": "Silmek üzere olduğunuz kullanıcıya, platformda kendisiyle doğrudan dosya veya klasör paylaşan diğer kullanıcılar da referans veriyor. Bu kullanıcının kaldırılması, paylaşılan içeriğe erişiminin iptal edilmesine neden olacak ve bu kullanıcıyla paylaşımda bulunan diğer kullanıcılar artık bu kullanıcıyı kendi kullanıcı listelerinde göremeyecektir. Devam etmek istediğinizden emin misiniz? <i>(Onaylamak için \"{{keyword}}\" yazın.)</i>",
      "multiple": "Birden fazla kullanıcıyı silmek üzeresiniz. Bu kullanıcıların bir kısmı sisteme dosya yüklemiş olabilir. Bunları silmek, yükledikleri tüm dosyaların ve ilişkili paylaşımların kaldırılmasına neden olacak ve artık platforma erişemeyecekler. Devam etmek istediğinizden emin misiniz? <i>(Onaylamak için \"{{keyword}}\" yazın.)</i>",
      "transferDestinationLabel": "Kişisel dosyaları başka bir kullanıcıya aktarma (isteğe bağlı)",
      "transferDestinationPlaceholder": "Kullanıcı seçin",
      "transferOptionalHint": "Bir alıcı seçerseniz, sildiğiniz hesaptaki/hesaplardaki kişisel dosyalar, kaldırılmadan önce oraya aktarılacaktır. Yukarıda açıklanan politikaya göre dosyaları kaldırmak için boş bırakın.",
      "userReferencedInSettings": {
        "title": "Kullanıcı silinemiyor",
        "title_other": "Kullanıcılar silinemiyor",
        "description": "Seçilen kullanıcı silinemez. Bu kullanıcıya şu ayarlarda başvurulmaktadır: <settingsList/>. Tekrar denemeden önce bu kullanıcıyı bu ayarlardan kaldırın.",
        "description_other": "Seçilen kullanıcılar silinemez. Bunlara şu ayarlarda başvurulur: <settingsList/>. Tekrar denemeden önce bunları bu ayarlardan kaldırın.",
        "unknownSettings": "Bir veya daha fazla ayar"
      }
    },
    "changeUsersStatus": {
      "title": "Kullanıcı durumunu değiştir",
      "description": "{{status}} <strong>{{resource}}</strong> yapmak istediğinizden emin misiniz?",
      "description_other": "{{status}} <strong>bu kullanıcılara</strong> istediğinizden emin misiniz?"
    },
    "excludeFromSso": {
      "titleExclude": "Kullanıcıyı SSO'dan hariç tut",
      "titleInclude": "Kullanıcı için SSO'yu yeniden etkinleştir",
      "descriptionExclude": "<strong>{{resource}}</strong> kullanıcısını SSO'dan hariç tutmak istediğinizden emin misiniz? Yapılandırılan kimlik sağlayıcısı üzerinden artık giriş yapamayacak ve OTP ile kimlik doğrulamak zorunda kalacak.",
      "descriptionInclude": "<strong>{{resource}}</strong> kullanıcısı için SSO'yu yeniden etkinleştirmek istediğinizden emin misiniz? Yapılandırılan kimlik sağlayıcısı üzerinden tekrar giriş yapabilecek."
    },
    "enterOnBehalfOf": {
      "title": "Vekâleten Moda Gir",
      "description": "<strong>{{resource}}</strong>.<br /><br /> adına verileri göreceğiniz ve işlemler gerçekleştireceğiniz bir oturum başlatıyorsunuz. Onaylıyor musunuz?"
    },
    "impersonateUser": {
      "title": "Kullanıcıyı Taklit Et",
      "description": "{{userName}} olarak giriş yapmak istediğinizden emin misiniz? Bu kullanıcı olarak işlemleri görebilecek ve gerçekleştirebileceksiniz.",
      "emailNotice": "Kullanıcı, bu kimlik taklidi hakkında sizin adınızı, tarih ve saati ve aşağıya girdiğiniz gerekçeyi içeren bir e-posta alacaktır.",
      "reasonLabel": "Gerekçe — bildirim e-postasında kullanıcıya gösterilir",
      "reasonTruncateHint": "500 karakterden uzun gerekçeler e-postada \"…\" ile kısaltılır (tam metin yine de kaydedilir).",
      "reasonEmptyHint": "Boş bırakılırsa e-postada \"Not specified\" görünür."
    },
    "userForm": {
      "editTitle": "Kullanıcıyı düzenle",
      "newTitle": "Yeni kullanıcı",
      "editDescription": "Kullanıcı bilgilerini güncelleyin",
      "newDescription": "Yeni kullanıcı bilgilerini girin"
    },
    "userGroups": {
      "title": "Grup üyeliği",
      "description": "<strong>{{resource}}</strong> kullanıcısının üye olduğu gruplar listesi"
    },
    "userFiles": {
      "title": "Paylaşılan Öğeler",
      "description": "<strong>{{resource}}</strong> ile paylaşılan öğeler"
    },
    "groupFiles": {
      "title": "Paylaşılan Öğeler",
      "description": "<strong>{{resource}}</strong> ile paylaşılan öğeler"
    },
    "fileSizeTooBigForOpen": {
      "title": "Dosya boyutu çok büyük",
      "description": "Dosya boyutu {{value}} sınırını aşıyor. Dosyayı açmak istiyorsanız indirip yerel olarak açabilirsiniz."
    },
    "deleteGroups": {
      "title": "Grubu sil",
      "title_other": "Grupları sil",
      "description": "<strong>{{resource}}</strong> öğesini silmek istediğinizden emin misiniz? Devam etmek istediğinizden emin misiniz? <i>(Onaylamak için \"{{keyword}}\" yazın.)</i>",
      "description_other": "<strong>bu grupları</strong> silmek istediğinizden emin misiniz? Devam etmek istediğinizden emin misiniz? <i>(Onaylamak için \"{{keyword}}\" yazın.)</i>"
    },
    "groupForm": {
      "editTitle": "Grubu düzenle",
      "newTitle": "Yeni grup",
      "viewTitle": "Grubu görüntüle",
      "editDescription": "Grup bilgilerini güncelleyin",
      "viewDescription": "Grup detaylarını görüntüleyin",
      "newDescription": "Yeni grup bilgilerini girin",
      "allUsers": "Tüm kullanıcılar",
      "selectedUsersOrGroups": "Seçilen kullanıcılar veya gruplar"
    },
    "entraIdGroupsImportForm": {
      "importFromEntraId": "Entra ID'den içe aktar",
      "title": "Microsoft Entra ID'den Grupları İçe Aktarma",
      "searchGroups": "Grup Ara",
      "selectNew": "Yalnızca yeniyi seç",
      "existing": "Mevcut",
      "new": "Yeni",
      "importMembers": "Üyeleri İçe Aktar",
      "importSelected": "İçe Aktar ({{count}})",
      "importSuccess": "İçe aktarma tamamlandı: {{created}} oluşturuldu, {{updated}} güncellendi",
      "importError": "İçe aktarma sırasında hata",
      "errorLoadingGroups": "Entra ID'den gruplar yüklenirken hata oluştu",
      "noGroupsFound": "Grup bulunamadı",
      "resultSummary": "Oluşturuldu: {{created}}, Güncellendi: {{updated}}, Atlandı: {{skipped}}, Başarısız: {{failed}}",
      "usersImported": "{{count}} üye de içe aktarıldı",
      "permissionDeniedFallback": "İzin reddedildi",
      "permissionErrorTitle": "Yetersiz Azure AD İzinleri",
      "permissionErrorDescription": "Azure AD uygulamasının Microsoft Graph API'sine erişmek için yeterli izinleri yok.",
      "permissionErrorSteps": "Bu sorunu çözmek için:",
      "permissionErrorStep1": "Azure Portal > Uygulama kayıtları > Uygulamanız'a gidin",
      "permissionErrorStep2": "API izinlerine gidin",
      "permissionErrorStep3": "Gerekli Uygulama izinlerini ekleyin (Yetki Verilmemiş)",
      "permissionErrorStep4": "İzinleri yetkilendirmek için \"Yönetici onayı ver\" seçeneğini tıklayın",
      "requiredPermissions": "Gerekli izinler",
      "defaultRole": "Varsayılan rol",
      "linked": "Bağlı"
    },
    "csvUsersImportForm": {
      "importFromCsv": "Import from CSV",
      "title": "Import users from CSV",
      "description": "Create new users only. Rows whose email already exists are skipped (not treated as failures). Roles: SuperAdmin, Admin, Contributor, Reader (or numeric codes).",
      "browserStayOpenWarning": "Do not close or refresh this browser tab until the import finishes. Progress exists only in this session.",
      "confirmSkipErrors": "{{count}} hatalı öğe var ve bunlar içe aktarılmayacak.",
      "downloadTemplate": "Download CSV template",
      "sendInvites": "Send invitation emails to newly created users",
      "dropzone": "Drop a CSV file here or click to browse",
      "fileSelected": "Selected: {{name}}",
      "invalidFileType": "Please select a .csv file",
      "readError": "Could not read the CSV file",
      "noValidRows": "No valid rows found in this file",
      "colLine": "Line",
      "confirmImport": "Import {{count}} users",
      "emptyFile": "The CSV file is empty",
      "invalidHeader": "Invalid header. Expected: {{expected}}",
      "tooManyColumns": "Too many columns on this row",
      "missingFirstName": "First name is required",
      "missingLastName": "Last name is required",
      "missingEmail": "Email is required",
      "invalidEmail": "Invalid email address",
      "missingRole": "Role is required",
      "invalidRole": "Invalid role: {{value}}",
      "superAdminRoleNotAllowed": "Only a SuperAdmin can assign the SuperAdmin role",
      "invalidExpirationDate": "Invalid expiration date: {{value}}",
      "invalidBoolean": "Invalid boolean for {{field}}: {{value}}",
      "duplicateInFile": "Duplicate email in file (first seen on line {{firstLine}})",
      "genericCreateError": "Could not create user",
      "drawerAria": "User import progress",
      "drawerRunning": "Importing users…",
      "drawerCompleted": "User import complete",
      "drawerCancelled": "User import cancelled",
      "importingUsersCounter": "Importing users {{amount}} of {{total}}",
      "importedUsersCounter": "Imported {{amount}} of {{total}}",
      "waitingForImport": "Waiting",
      "importingRow": "Importing…",
      "alreadyExists": "Already exist",
      "summary": "Created: {{created}} · Already exist: {{skipped}} · Failed: {{failed}}",
      "progressCount": "{{done}} / {{total}}",
      "failedList": "Failed",
      "alreadyExistList": "Already exist ({{count}})",
      "cancelImport": "Cancel import",
      "cancelConfirmTitle": "Cancel import?",
      "cancelConfirmContent": "In-flight creates will finish; remaining rows will not start.",
      "continueImport": "Keep importing",
      "minimizeDrawer": "Minimize",
      "expandDrawer": "Expand",
      "previewHeading": "{{total}} kullanıcı · {{errors}} hata",
      "searchPlaceholder": "Kullanıcı ara…",
      "colStatus": "Durum",
      "filterWithErrors": "Hatalılar",
      "filterValid": "Geçerli",
      "statusError": "Hata",
      "statusOk": "Tamam"
    },
    "entraIdUsersImportForm": {
      "importFromEntraId": "Entra ID'den içe aktar",
      "title": "Kullanıcıları Microsoft Entra ID'den İçe Aktarın",
      "searchUsers": "Kullanıcıları ara...",
      "selectNew": "Yenileri Seç",
      "existing": "Mevcut",
      "new": "Yeni",
      "importSelected": "İçe Aktar ({{count}})",
      "importSuccess": "İçe aktarma tamamlandı: {{created}} oluşturuldu, {{updated}} güncellendi",
      "importError": "İçe aktarma sırasında hata",
      "errorLoadingUsers": "Entra ID'den kullanıcılar yüklenirken hata oluştu",
      "noUsersFound": "Kullanıcı bulunamadı",
      "resultSummary": "Oluşturuldu: {{created}}, Güncellendi: {{updated}}, Atlandı: {{skipped}}, Başarısız: {{failed}}",
      "permissionDeniedFallback": "İzin reddedildi",
      "permissionErrorTitle": "Yetersiz Azure AD İzinleri",
      "permissionErrorDescription": "Azure AD uygulamasının Microsoft Graph API'sine erişmek için yeterli izinleri yok.",
      "permissionErrorSteps": "Bu sorunu çözmek için:",
      "permissionErrorStep1": "Azure Portal > Uygulama kayıtları > Uygulamanız'a gidin",
      "permissionErrorStep2": "API izinlerine gidin",
      "permissionErrorStep3": "Gerekli Uygulama izinlerini ekleyin (Yetki Verilmemiş)",
      "permissionErrorStep4": "İzinleri yetkilendirmek için \"Yönetici onayı ver\" seçeneğini tıklayın",
      "requiredPermissions": "Gerekli izinler",
      "defaultRole": "Varsayılan rol"
    },
    "batchDetailForm": {
      "title": "Toplu iş ayrıntısı",
      "noFailedFiles": "Başarısız dosya yok",
      "noFiles": "Bu durumda dosya yok",
      "fileCancelled": "Bu dosya için iptal istendi.",
      "fileCancelError": "Dosya iptali istenirken hata oluştu.",
      "fileRetried": "Dosya yeniden deneme için kuyruğa alındı",
      "fileRetryError": "Dosya yeniden denenirken hata",
      "truncatedHint": "Başarısız dosya önizlemesi kısaltıldı. Tam liste için Başarısız sekmesini kullanın.",
      "attempt": "Deneme {{count}}",
      "tabs": {
        "pending": "Bekleyen",
        "processing": "İşleniyor",
        "success": "Tamamlanan",
        "failed": "Başarısız",
        "canceled": "İptal edilen"
      },
      "status": {
        "pending": "Bekleyen",
        "processing": "İşleniyor",
        "success": "Tamamlandı",
        "failed": "Başarısız",
        "canceled": "İptal edildi"
      }
    },
    "batchesList": {
      "panelTitle": "Toplu İşlemler",
      "noActiveBatches": "Aktif Toplu İşlem Yok",
      "cancelAllFailed": "Tüm başarısız partileri iptal et (işlenmekte olanlar değil)",
      "cancelAllFailedConfirmTitle": "Tüm başarısız partiler iptal edilsin mi?",
      "cancelAllFailedConfirmContent": "Yalnızca Durumu Başarısız olan partiler temizlenir. İşlenmekte olan veya kuyruktaki partiler çalışmaya devam eder ve etkilenmez. Bu işlem geri alınamaz.",
      "cancelBatch": "Toplu işi iptal et",
      "cancelBatchConfirmTitle": "Bu parti iptal edilsin mi?",
      "cancelBatchConfirmContent": "Bu, isteği iptal eder. İşleme bir sonraki kontrol noktasında durabilir. Bu eylem geri alınamaz.",
      "failedFiles": "{{count}} dosyası başarısız oldu",
      "failedFiles_other": "{{count}} dosya başarısız oldu",
      "progress": "{{processed}} / {{total}}",
      "status": {
        "all": "Tümü",
        "queued": "Sıraya alındı",
        "processing": "İşleniyor",
        "completed": "Tamamlandı",
        "failed": "Başarısız",
        "partiallycompleted": "Kısmen Tamamlandı",
        "cancelled": "İptal edildi"
      },
      "operation": {
        "all": "Tüm Operasyonlar",
        "classification": "Sınıflandırma",
        "folderexpansion": "Klasör Genişletme",
        "delete": "Silme",
        "zip": "ZIP oluşturma başarısız oldu"
      },
      "pendingFiles": "{{count}} bekleyen",
      "pendingFiles_other": "{{count}} bekleyen",
      "processingFiles": "{{count}} işleniyor",
      "processingFiles_other": "{{count}} işleniyor",
      "processedFiles": "{{count}} tamamlanan",
      "processedFiles_other": "{{count}} tamamlanan",
      "canceledFiles": "{{count}} iptal edilen",
      "canceledFiles_other": "{{count}} iptal edilen",
      "viewDetail": "Ayrıntıları gör"
    },
    "tagForm": {
      "editTitle": "Etiketi düzenle",
      "newTitle": "Yeni etiket",
      "editDescription": "Etiket ayrıntılarını düzenle",
      "newDescription": "Yeni bir etiket ekle",
      "visibility": "Görünürlük",
      "selectUserRoles": "Kullanıcı rollerini seçin",
      "visibilityDescription": "Bu etiketi aşağıdaki rollere görünür yapın ve etiketin herkese mi yoksa yalnızca belirli gruplara veya kullanıcılara mı görüneceğini belirtin.",
      "usedInSettings": "Kullanıldığı yerler:",
      "usedInSettingsNone": "Hiçbir Ayarda Kullanılmıyor"
    },
    "deleteTag": {
      "title": "Etiketi sil",
      "description": "<strong>{{resource}}</strong> öğesini silmek istediğinizden emin misiniz? Devam etmek istediğinizden emin misiniz?",
      "descriptionWithPublicTag": "<strong>{{resource}}</strong> öğesini silmek istediğinizden emin misiniz? Bu etiketin silinmesi, Etiketli Dosya Görünürlüğü ayarında onunla ilişkili tüm paylaşımların kaldırılmasına neden olacaktır.",
      "errorInUse": "Etiket silinemiyor",
      "errorInUseDescription": "Bu etiket şu anda aşağıdaki alanlarda kullanılmaktadır:",
      "errorInUseAction": "Etiketi silmeden önce bu konumlardan kaldırın.",
      "usedInSettings": "Ayarlar",
      "usedInClassificationAgent": "Sınıflandırma Aracısı"
    },
    "fileTitleForm": {
      "newFolderTitle": "Yeni Klasör Adı",
      "editFolderTitle": "Klasör Adını Düzenle",
      "editFileTitle": "Dosya Adını Düzenle"
    },
    "fileFromTemplateForm": {
      "newWordDocumentTitle": "Yeni Word Belgesi",
      "newExcelDocumentTitle": "Yeni Excel Belgesi",
      "newPowerpointDocumentTitle": "Yeni PowerPoint Belgesi",
      "newGenericDocumentTitle": "Yeni Belge"
    },
    "enterFolderPasswordForm": {
      "passwordPlaceholder": "Şifre",
      "required": "Şifre gerekli",
      "cancel": "İptal",
      "confirm": "Onayla",
      "error": "Yanlış şifre",
      "lockout": "Çok fazla başarısız deneme. {{minutes}} dakika sonra tekrar deneyin.",
      "genericError": "Bir hata oluştu",
      "resetPassword": "Şifreyi sıfırla",
      "forgotPassword": "Parolanızı mı unuttunuz?",
      "title": "Korumalı Klasör",
      "description": "\"{{folderName}}\" klasörü şifre gerektiriyor."
    },
    "filePasswordForm": {
      "title": "Klasör Şifre Koruması",
      "createTitle": "Parola Korumasını Ayarla",
      "editTitle": "Şifre Korumasını Düzenle",
      "password": "Şifre",
      "currentPassword": "Mevcut Şifre",
      "newPassword": "Yeni Şifre",
      "newPasswordHelp": "Mevcut şifreyi korumak için boş bırakın",
      "ownerBypass": "Sahip Yetkisini Atlama",
      "ownerBypassDescription": "Sahibi klasöre şifre olmadan erişebilir",
      "adminBypass": "Yönetici Atlama",
      "adminBypassDescription": "Yönetici klasöre şifre olmadan erişebilir",
      "maxFailedAttempts": "Maksimum Başarısız Deneme Sayısı",
      "lockoutDuration": "Kilitlenme Süresi (dakika)",
      "sessionDuration": "Oturum Süresi (dakika)",
      "expirationDate": "Son kullanma tarihi",
      "expirationDatePlaceholder": "Tarih seçin (isteğe bağlı)",
      "remove": "Şifreyi Kaldır",
      "removeConfirm": "Şifreyi kaldırmak istediğinizden emin misiniz?",
      "validation": {
        "required": "Bu alan zorunludur",
        "minLength": "En az {{min}} karakter olmalıdır",
        "expirationDateExpired": "Son kullanma tarihi geçmişte olamaz"
      }
    },
    "fileSessionsForm": {
      "title": "Klasör Oturumları",
      "revokeAllSessionsDescription": "\"{{fileName}}\" için tüm kilit açma oturumları iptal edilecek. Kullanıcıların bu klasöre erişebilmeleri için şifreyi tekrar girmeleri gerekecektir.",
      "revokeAllFolderSessionsDescription": "Tüm klasör kilit açma oturumları iptal edilecek. Kullanıcıların herhangi bir korumalı klasöre erişmek için şifreyi tekrar girmeleri gerekecektir.",
      "noSessions": "Aktif oturum yok",
      "unknownDevice": "Bilinmeyen cihaz",
      "createdAt": "Oluşturuldu",
      "expiresAt": "Bitiş Tarihi",
      "revokeSession": "Oturumu Sonlandır",
      "sessionRevoked": "Oturum başarıyla iptal edildi",
      "sessionRevoked_other": "{{count}} oturum başarıyla iptal edildi",
      "allSessionsRevoked": "Tüm Oturumlar Sonlandırıldı",
      "fetchError": "Oturumlar getirilirken hata oluştu",
      "revokeError": "Oturum iptal edilirken hata oluştu",
      "revokeAllError": "Tüm oturumlar iptal edilirken hata oluştu",
      "revokeSessionConfirmTitle": "Bu oturum iptal edilsin mi?",
      "revokeSessionConfirmDescription": "Bu klasör kilit açma oturumu derhal iptal edilecek. Kullanıcının bu klasöre erişebilmesi için şifreyi tekrar girmesi gerekecektir.",
      "revokeAllConfirmTitle": "Tüm klasör oturumları iptal edilsin mi?",
      "revokeAllConfirmDescription": "Tüm klasör kilit açma oturumları iptal edilecek. Kullanıcıların korumalı klasörlere erişmek için şifreyi tekrar girmeleri gerekecektir.",
      "logoutAll": "Tümünü iptal et"
    },
    "userSessionsForm": {
      "activeSessions": "Aktif Oturumlar",
      "manageSessions": "Oturumları yönet",
      "manageUserSessions": "{{userName}} oturumları",
      "noSessions": "Aktif oturum yok",
      "unknownBrowser": "Bilinmeyen tarayıcı",
      "unknownDevice": "Bilinmeyen cihaz",
      "lastActivity": "Son aktivite",
      "expiresAt": "Bitiş Tarihi",
      "currentSession": "Geçerli oturum",
      "revokeSession": "Geri çekmek",
      "sessionRevoked": "Oturum başarıyla iptal edildi",
      "sessionRevoked_other": "{{count}} oturum başarıyla iptal edildi",
      "otherSessionsRevoked": "{{count}} oturum başarıyla iptal edildi",
      "otherSessionsRevoked_other": "{{count}} oturum başarıyla iptal edildi",
      "allSessionsRevoked": "Tüm oturumlar iptal edildi",
      "revokeSessionConfirmTitle": "Bu oturum iptal edilsin mi?",
      "revokeSessionConfirmDescription": "Cihazdaki oturum hemen kapatılacaktır.",
      "revokeGroupedSessionConfirmDescription": "Bu işlem, bu cihazdaki {{count}} oturumu iptal edecek.",
      "revokeOthersConfirmTitle": "Diğer tüm cihazlardan çıkış yapılsın mı?",
      "revokeOthersConfirmDescription": "Mevcut olan dışındaki tüm cihazlardan çıkış yapılacaktır.",
      "revokeAllConfirmTitle": "Tüm cihazlardan çıkış yapılsın mı?",
      "revokeAllConfirmDescription": "Mevcut cihaz da dahil olmak üzere tüm cihazlardan çıkış yapılacaktır. Tekrar giriş yapmanız gerekecek.",
      "adminRevokeAllConfirmTitle": "Tüm kullanıcı oturumlarından çıkış yapılsın mı?",
      "adminRevokeAllConfirmDescription": "{{userName}} tarihinin tüm oturumları iptal edilecek. Kullanıcının tekrar oturum açması gerekecektir.",
      "logoutOthers": "Diğer cihazlardan çıkış yapın",
      "logoutAll": "Tüm oturumları kapat",
      "revokeAllUserSessions": "Tümünü iptal et"
    },
    "resetFilePasswordForm": {
      "forgotPassword": "Parolanızı mı unuttunuz?",
      "otpSentToEmail": "OTP e-posta adresinize gönderildi.",
      "resetPassword": "Şifreyi sıfırla",
      "otpCodeLabel": "OTP kodu",
      "newPasswordLabel": "Yeni Şifre",
      "wrongOtpCode": "Yanlış OTP kodu.",
      "tooManyAttemptsRequestNewOtp": "Çok fazla deneme. Yeni bir OTP isteyin.",
      "codeExpiredRequestNewOtp": "Kodun süresi doldu. Yeni bir OTP isteyin.",
      "otpRequired": "OTP gerekli",
      "otpMustBe6": "OTP 6 haneli olmalıdır",
      "newPasswordRequired": "Yeni şifre gerekli",
      "newPasswordMin": "Şifre en az 4 karakter olmalıdır",
      "passwordResetSuccess": "Şifre başarıyla sıfırlandı.",
      "tooManyOtpRequests": "Çok fazla OTP isteği var. Lütfen daha sonra tekrar deneyin."
    },
    "fileMoveForm": {
      "title": "{{resource}} dosyayı taşı",
      "title_other": "{{count}} dosyayı taşı",
      "currentPosition": "Mevcut konum",
      "folderIsEmpty": "Klasör boş",
      "selectFolderToMoveInto": "Dosyayı taşımak istediğiniz klasör yolunu gösterecek bir konum seçin"
    },
    "fileShortcutForm": {
      "title": "{{resource}} için bir kısayol oluşturun",
      "currentPosition": "Mevcut konum",
      "folderIsEmpty": "Klasör boş",
      "selectFolderToCreateShortcutInto": "Kısayolu oluşturmak istediğiniz klasör yolunu gösterecek bir konum seçin",
      "goBack": "Geri gitmek"
    },
    "fileChooseDestinationForm": {
      "currentPosition": "Mevcut konum",
      "folderIsEmpty": "Klasör boş",
      "selectFolderHint": "Dosyayı kaydetmek istediğiniz klasörü seçin",
      "goBack": "Geri gitmek"
    },
    "fileShareForm": {
      "title": "{{resource}} paylaş",
      "title_other": "{{count}} dosya paylaş",
      "message": "Bu dosyayı bir veya daha fazla kullanıcı veya grupla paylaşın.",
      "message_other": "{{count}} dosyasını bir veya daha fazla kullanıcı veya grupla paylaşın.",
      "currentPosition": "Mevcut konum",
      "folderIsEmpty": "Klasör boş",
      "selectFolderToShareInto": "Dosyayı paylaşmak istediğiniz klasör yolunu gösterecek bir konum seçin",
      "peopleWithAccess": "Erişimi olan kişiler",
      "sendMessage": "Mesaj gönder",
      "sendMessagePlaceholder": "Özel bir mesaj ekleyin (isteğe bağlı)",
      "existingAccessesChanged": "Mevcut erişimler değiştirildi",
      "existingAccessesChangedDescription": "Kaydet mevcut erişimlerdeki düzenlemeleri uygular, ardından yeni kullanıcı veya grupları ekler. İptal formu olduğu gibi bırakır ve eklemez.",
      "existingAccessesExpirationRequired": "Bu mevcut erişimleri güncellemek için şirket politikalarının izin verdiği bir son kullanma tarihi ayarlamanız gerekir.",
      "applyAllExpirationDates": "Tümüne uygula"
    },
    "filePublicLinkForm": {
      "title": "Genel Bağlantı",
      "createTitle": "Genel Bağlantı Oluştur",
      "expirationLabel": "Son kullanma tarihi (isteğe bağlı)",
      "expirationLabelRequired": "Son kullanma tarihi",
      "expirationPlaceholder": "Son kullanma tarihi seçin",
      "maxAccessCountLabel": "Maksimum erişim sayısı (isteğe bağlı)",
      "maxAccessCountLabelRequired": "Maksimum erişim sayısı",
      "maxAccessCountPlaceholder": "Maksimum erişim sayısını girin",
      "allowDownload": "İndirmeye izin ver",
      "protectWithPassword": "Şifreyle koruyun",
      "passwordLabel": "Şifre",
      "passwordPlaceholder": "Şifreyi girin",
      "passwordRequired": "Koruma etkinleştirildiğinde şifre gereklidir",
      "createLink": "Bağlantı Oluştur",
      "linkCreatedTitle": "Bağlantı oluşturuldu!",
      "linkCreatedMessage": "Herkese açık bağlantı oluşturuldu.",
      "copyLink": "Bağlantıyı kopyala",
      "warning": "Genel bağlantı oluşturmak, bu dosyadaki standart korumaları atlar. Bağlantıya sahip olan herkes belge içeriğine erişebilir; dikkatli kullanın.",
      "expiresAt": "Bitiş Tarihi",
      "remainingAccesses": "Kalan erişimler",
      "password": "Şifre",
      "revoke": "Bağlantıyı iptal et",
      "revoked": "Genel bağlantı başarıyla iptal edildi.",
      "publicUrl": "Genel URL",
      "status": "Durum",
      "statusActive": "Aktif",
      "statusExpired": "Süresi Doldu",
      "statusExhausted": "Sınıra ulaşıldı",
      "accessCount": "Erişim Sayısı",
      "hasPassword": "Şifre korumalı",
      "createdAt": "Oluşturuldu",
      "errors": {
        "linkAlreadyExists": "Bu dosya için genel bir bağlantı zaten mevcut. Yeni bir tane oluşturmak için önce onu iptal edin.",
        "linkNotFound": "Bu dosya için etkin bağlantı bulunamadı.",
        "featureDisabled": "Kuruluşunuz için genel bağlantılar devre dışı bırakıldı.",
        "notOwner": "Herkese açık bağlantılar oluşturmak veya iptal etmek için sahibi olmanız gerekir."
      }
    },
    "filePublicLinksForm": {
      "statusExpired": "Süresi Doldu",
      "statusExhausted": "Sınıra ulaşıldı",
      "statusActive": "Aktif",
      "expiresAt": "Bitiş Tarihi",
      "accessCount": "Erişim Sayısı",
      "hasPassword": "Şifre",
      "empty": "Henüz herkese açık bağlantı yok."
    },
    "userTransferOwnershipForm": {
      "title": "Sahipliği aktar – {{sourceName}}",
      "destinationLabel": "Hedef kullanıcı",
      "destinationPlaceholder": "Bir kullanıcı arayın ve seçin",
      "destinationRequired": "Bir hedef kullanıcı seçin.",
      "infoMessage": "Dosyalar, alıcının kökündeki \"{{email}} kaynağından aktarıldı\" klasörüne taşınacaktır. Pazaryerinde satışa sunulan dosyalar aktarılmayacaktır.",
      "submit": "Aktar",
      "cancel": "İptal",
      "close": "Kapat",
      "successTitle": "Aktarım tamamlandı",
      "resultFilesTransferred": "Aktarılan dosyalar",
      "resultFoldersTransferred": "Aktarılan klasörler",
      "resultSharesUpdated": "Paylaşımlar güncellendi",
      "resultSelfSharesRemoved": "Kişisel paylaşımlar kaldırıldı",
      "resultTagAssignmentsRemoved": "Etiket atamaları kaldırıldı",
      "resultTagAssignmentsTransferred": "Etiket atamaları aktarıldı",
      "resultFilesForSaleExcluded": "Satıştaki dosyalar hariç tutuldu",
      "resultWrapperFolderName": "Sarmalayıcı klasör adı"
    },
    "userTotpForm": {
      "title": "2FA – {{userName}}",
      "statusTitle": "2FA durumu",
      "totpEnabled": "TOTP etkin",
      "enabledAt": "Etkinleştirildi",
      "backupCodesRemaining": "Kalan yedek kodlar",
      "requiredByPolicy": "Politika gereği zorunlu",
      "lockoutStatus": "Kilitlenme durumu",
      "failedAttempts": "Başarısız denemeler",
      "exemptionTitle": "TOTP muafiyeti",
      "grantExemption": "Hibe muafiyeti",
      "revokeExemption": "Muafiyeti iptal et",
      "revoke": "Kaldır",
      "exemptionTypeTemporary": "Geçici",
      "exemptionTypePermanent": "Kalıcı",
      "exemptionTypeLabel": "Tip",
      "exemptionExpires": "Muafiyet bitişi",
      "exemptionReason": "Muafiyet nedeni",
      "grantedBy": "Muafiyeti veren",
      "grantedAt": "Muafiyet tarihi",
      "grantDialogTitle": "Hibe muafiyeti",
      "grantDialogTemporary": "Geçici",
      "grantDialogPermanent": "Kalıcı",
      "grantDialogDays": "Gün sayısı",
      "grantDialogReason": "Sebep (en az 5 karakter)",
      "grantSubmit": "Muafiyet ver",
      "revokeConfirmTitle": "Muafiyeti iptal et",
      "revokeConfirmDescription": "Kullanıcının tekrar 2FA politikasına uyması gerekecektir.",
      "disableConfirmTitle": "Bu kullanıcı için 2FA devre dışı bırakılsın mı?",
      "disableConfirmDescription": "Bu, kullanıcı için iki faktörlü kimlik doğrulamayı kaldıracaktır. Politika gerektirdiği takdirde bunu yeniden ayarlamaları gerekecektir.",
      "statusLoading": "Yükleniyor…",
      "statusError": "2FA durumu yüklenemedi.",
      "grantSuccess": "Muafiyet tanındı.",
      "revokeSuccess": "Muafiyet iptal edildi.",
      "disableSuccess": "2FA devre dışı.",
      "cancel": "İptal etmek",
      "disableTotp": "2FA'yı devre dışı bırak",
      "retry": "Yeniden dene",
      "errorGeneric": "Bir şeyler ters gitti. Lütfen tekrar deneyin."
    },
    "userPasskeyForm": {
      "cancel": "İptal etmek",
      "retry": "Yeniden dene",
      "errorGeneric": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
      "passkeyRemove": "Kaldırmak",
      "passkeyRemoveAll": "Tüm şifre anahtarlarını kaldır",
      "passkeyRemoveAllConfirm": "Bu, bu kullanıcı için tüm {{count}} şifre anahtarlarını kaldıracaktır. Yenilerini kaydetmeleri gerekecek.",
      "passkeyRemoveAllSuccess": "Tüm şifre anahtarları kaldırıldı.",
      "passkeyRemoveAllTitle": "Tüm şifre anahtarları kaldırılsın mı?",
      "passkeyRemoveConfirm": "\"{{name}}\" şifresi kaldırılsın mı? Kullanıcı artık bunu oturum açmak için kullanamayacak.",
      "passkeyRemoveSuccess": "Geçiş anahtarı kaldırıldı.",
      "passkeyRemoveTitle": "Şifre anahtarı kaldırılsın mı?",
      "passkeysBlocked": "Geçiş anahtarı kilitleme",
      "passkeysCount": "Parolalar kaydedildi",
      "passkeysEnabled": "Şifre anahtarları etkinleştirildi",
      "passkeysFailedAttempts": "Geçiş anahtarı başarısız denemeleri",
      "passkeysLoadError": "Şifre anahtarı yönetici durumu yüklenemedi.",
      "passkeysTitle": "Geçiş anahtarları"
    },
    "loginTokensForm": {
      "title": "Erişim Jetonları – {{userName}}",
      "manageTokens": "Erişim belirteçlerini yönetin",
      "noTokens": "Bu kullanıcı için yapılandırılmış erişim belirteci yok.",
      "createToken": "Yeni jeton oluştur",
      "label": "Etiket",
      "labelRequired": "Etiket gerekli",
      "labelPlaceholder": "örneğin CRM Entegrasyonu, CI/CD Boru Hattı",
      "expirationDays": "Son kullanma tarihi (gün)",
      "create": "Yaratmak",
      "cancel": "İptal etmek",
      "close": "Kapalı",
      "delete": "Silmek",
      "retry": "Yeniden dene",
      "enabled": "Etkinleştirilmiş",
      "disabled": "Engelli",
      "expired": "Günü geçmiş",
      "enable": "Olanak vermek",
      "disable": "Devre dışı bırakmak",
      "createdAt": "Oluşturuldu",
      "expiresAt": "Süresi doluyor",
      "lastUsed": "Son kullanılan",
      "lastUsedIp": "Son IP",
      "neverUsed": "Hiç kullanılmadı",
      "maxTokensReached": "Maksimum jeton sayısına ulaşıldı (2). Yeni bir jeton oluşturmak için mevcut bir jetonu silin.",
      "tokenCreatedTitle": "Jeton başarıyla oluşturuldu",
      "tokenCreatedWarning": "Bu jetonu şimdi kopyalayın. Bir daha gösterilmeyecek.",
      "copyToken": "Jetonu kopyala",
      "copied": "Kopyalandı!",
      "deleteConfirmTitle": "Erişim jetonu silinsin mi?",
      "deleteConfirmDescription": "\"{{label}}\" jetonu kalıcı olarak silinecek ve artık kimlik doğrulama için kullanılamayacak.",
      "deleteSuccess": "Jeton başarıyla silindi.",
      "errorCannotCreateTokenForSuperAdmin": "Süper yöneticiler için erişim belirteçleri oluşturulamaz.",
      "errorGeneric": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
      "errorLoad": "Erişim jetonları yüklenemedi.",
      "errorMaxReached": "Bu kullanıcı zaten maksimum sayıda jetona sahip.",
      "errorTokenAlreadyUsed": "Bu jeton zaten kullanılmış ve yeniden etkinleştirilemez."
    },
    "alertDismiss": {
      "title": "Uyarıyı reddet veya ertele",
      "chooseAction": "Nasıl devam etmek istiyorsunuz?",
      "permanent": "Bir daha gösterme",
      "snooze": "Daha sonra hatırlat",
      "snoozeDuration": "Sonra hatırlat",
      "confirm": "Uygula",
      "success": "Tercih kaydedildi."
    },
    "alertsList": {
      "title": "Tüm etkin uyarılar",
      "dismiss": "Ertele veya kapat"
    },
    "totpForm": {
      "title": "İki Faktörlü Kimlik Doğrulama",
      "statusActive": "Etkin",
      "statusInactive": "Etkin değil",
      "activatedOn": "{{date}} tarihinde etkinleştirildi",
      "backupCodesRemaining": "{{count}} / {{total}} yedek kod kaldı",
      "requiredByPolicy": "Kuruluşunuz iki faktörlü kimlik doğrulamayı gerektiriyor.",
      "gracePeriodEnds": "Etkinleştirmek için {{date}} tarihine kadar süreniz var.",
      "activate": "2FA'yı etkinleştir",
      "setupTitle": "İki Faktörlü Kimlik Doğrulamayı Ayarlayın",
      "scanQR": "Bu QR kodunu kimlik doğrulayıcı uygulamanızla (Google Authenticator, Microsoft Authenticator, Authy vb.) tarayın.",
      "manualEntry": "Tarayamıyor musunuz? Manuel olarak girin",
      "hideManual": "Manuel girişi gizle",
      "enterSecretManually": "Bu kodu uygulamanıza manuel olarak girin:",
      "copySecret": "Kopyala",
      "copied": "Panoya kopyalandı",
      "verifyCodeLabel": "Uygulamanızdan 6 haneli kodu girin",
      "verifyAndActivate": "Doğrulayın ve etkinleştirin",
      "backupCodesTitle": "İki Faktörlü Kimlik Doğrulama etkinleştirildi!",
      "regenerateSuccess": "Yedek kodlar yeniden oluşturuldu",
      "backupCodesWarning": "Bu yedek kodları güvenli bir yere kaydedin. Kimlik doğrulayıcı uygulamanıza erişiminizi kaybederseniz hesabınıza erişmek için kullanılabilirler. Her kod yalnızca bir kez kullanılabilir.",
      "copyAll": "Tümünü kopyala",
      "download": "İndir",
      "print": "Yazdır",
      "savedConfirm": "Bu kodları güvenli bir yere kaydettim",
      "continue": "Devam et",
      "regenerateBackupCodes": "Yedek kodları yeniden oluştur",
      "disableTotp": "2FA'yı devre dışı bırak",
      "disableConfirm": "İki Faktörlü Kimlik Doğrulama devre dışı bırakılsın mı?",
      "disableConfirmDescription": "2FA'yı kaldırmak hesabınızı daha az güvenli hale getirecektir. 2FA'yı tekrar etkinleştirmek istiyorsanız kimlik doğrulama uygulamanızı yeniden yapılandırmanız gerekecektir.",
      "enterCodeToConfirm": "Onaylamak için TOTP kodunu girin",
      "cancel": "İptal",
      "disable": "Devre dışı bırak",
      "disabledSuccess": "İki Faktörlü Kimlik Doğrulama devre dışı bırakıldı.",
      "invalidCode": "Geçersiz kod. Lütfen tekrar deneyin.",
      "errorGeneric": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
      "retry": "Yeniden dene"
    },
    "passkeyCreateForm": {
      "addDescription": "Devam ettiğinizde tarayıcınız sizden Touch ID, Face ID, Windows Hello veya güvenlik anahtarınızla doğrulama yapmanızı isteyecektir.",
      "continueAuthenticator": "Devam etmek",
      "deviceNameInvalid": "1 ila 100 karakter arasında bir cihaz adı girin.",
      "deviceNameLabel": "Cihaz adı",
      "deviceNamePlaceholder": "örneğin MacBook Dokunmatik Kimliği",
      "passkeyCancelled": "Geçiş anahtarıyla oturum açma iptal edildi.",
      "registerErrorDeviceAlreadyRegistered": "Bu cihaz için bir şifre zaten kayıtlı. Başka bir kimlik doğrulayıcı kullanın veya önce mevcut şifreyi kaldırın.",
      "registerErrorGeneric": "Geçiş anahtarı kaydı tamamlanamadı. Lütfen tekrar deneyin.",
      "registerErrorNotSupported": "Tarayıcınız veya cihazınız bu tür şifre anahtarı kaydını desteklemiyor.",
      "registerSuccess": "Şifre kaydedildi.",
      "title": "Bir şifre anahtarı ekleyin"
    },
    "passkeyEditForm": {
      "deviceNameInvalid": "1 ila 100 karakter arasında bir cihaz adı girin.",
      "deviceNameLabel": "Cihaz adı",
      "renameError": "Şifre yeniden adlandırılamadı.",
      "renameSuccess": "Geçiş anahtarı yeniden adlandırıldı.",
      "saveLabel": "Kaydetmek",
      "title": "Şifreyi yeniden adlandır"
    },
    "passkeysForm": {
      "addPasskey": "Şifre anahtarı ekle",
      "browserUnsupported": "Tarayıcınız şifre anahtarlarını desteklemiyor. Chrome, Safari, Edge veya Firefox'un güncel bir sürümünü kullanın.",
      "empty": "Henüz şifre anahtarı yok. Daha hızlı oturum açmak için bir tane ekleyin ve bunu ikinci bir faktör olarak kullanın.",
      "lastUsed": "Son kullanılan",
      "loadError": "Şifre durumu yüklenemedi.",
      "maxReached": "En fazla {{max}} şifre anahtarını kaydedebilirsiniz.",
      "never": "Asla",
      "passwordless": "Şifresiz",
      "passwordlessDisabled": "Şifresiz devre dışı bırakıldı.",
      "passwordlessEnabled": "Şifresiz etkin.",
      "passwordlessUnavailable": "Bu cihazda mevcut değil",
      "policyDisabled": "Geçiş anahtarları kuruluşunuz tarafından devre dışı bırakıldı.",
      "registered": "Kayıtlı",
      "remove": "Kaldırmak",
      "removeConfirm": "\"{{name}}\" şifresi kaldırılsın mı? Artık oturum açmak için kullanamayacaksınız.",
      "removeError": "Şifre anahtarı kaldırılamadı.",
      "removeLastWarning": "Bu senin tek geçiş anahtarın. Bunu kaldırmak, yeni bir şifre ekleyene kadar şifreyle oturum açmayı devre dışı bırakacaktır.",
      "removeSuccess": "Geçiş anahtarı kaldırıldı.",
      "removeTitle": "Şifre anahtarı kaldırılsın mı?",
      "rename": "Yeniden isimlendirmek",
      "title": "Geçiş anahtarları",
      "toggleError": "Şifresiz ayar güncellenemedi.",
      "transport": "Cihaz türü",
      "transportBle": "Bluetooth güvenlik anahtarı",
      "transportHybrid": "Telefon",
      "transportHybridInternal": "Senkronize geçiş anahtarı (telefon)",
      "transportInternal": "Bu cihaz (Touch ID, Face ID, Windows Hello)",
      "transportNfc": "Güvenlik anahtarı (NFC)",
      "transportUsb": "Güvenlik anahtarı (USB)",
      "transportUsbNfc": "Güvenlik anahtarı (USB + NFC)",
      "transportUnknown": "Bildirilmedi"
    },
    "filesSelectForm": {
      "confirmDeselectParent": "Ana klasörün seçimi kaldırılsın mı?",
      "confirmDeselectParentDescription": "Bu klasörün seçilmesi ana klasörün ve aynı düzeydeki tüm klasörlerin seçimini kaldıracaktır. Devam etmek istiyor musun?",
      "ariaLabel": "Dosya paylaşım formu",
      "selectUsersOrGroups": "Kullanıcıları veya grupları seçin",
      "userMultiSelectAria": "Kullanıcı ve grup seçimi",
      "actions": "İşlemler"
    },
    "fileTagsForm": {
      "title": "Etiketleri Düzenle - {{resource}}",
      "availableTags": "Kullanılabilir etiketler",
      "assignedTags": "Atanmış etiketler",
      "searchAvailableTags": "Kullanılabilir etiketleri ara",
      "searchAssignedTags": "Atanmış etiketleri ara",
      "noAssignedTags": "Atanmış etiket yok",
      "clickHintAdd": "Eklemek için bir etikete tıklayın.",
      "clickHintRemove": "Kaldırmak için bir etikete tıklayın. Yeniden sıralamak için tutamacı sürükleyin.",
      "clickToAdd": "{{title}} etiketini ekle",
      "clickToRemove": "{{title}} etiketini kaldır",
      "dragToReorder": "{{title}} etiketini sürükleyerek sırala",
      "aiScrapingOnlyPdfOffice": "AI Scraping yalnızca PDF ve Office dosyalarında etkindir.",
      "watermarkOnlyPdfOffice": "Filigran koruması yalnızca PDF ve Office dosyalarında etkindir."
    },
    "openFileFromTrash": {
      "title": "Bu dosya çöp kutunuzda",
      "description": "<strong>{{resource}}</strong> öğesini görüntülemek için onu çöp kutusundan geri yüklemeniz gerekir."
    },
    "fileUploadOptionsForm": {
      "title": "Yükleme seçenekleri",
      "description": "<strong>{{resource}}</strong> bu konumda zaten mevcut. Mevcut dosyayı yeni bir sürümle değiştirmek mi yoksa her iki dosyayı da saklamak mı istiyorsunuz? Dosyaları değiştirmek paylaşım seçeneklerini değiştirmez",
      "description_other": "Bu konumda bir veya daha fazla öğe zaten mevcut. Mevcut dosyaları yeni bir sürümle değiştirmek mi yoksa her iki dosyayı da saklamak mı istiyorsunuz? Dosyaları değiştirmek paylaşım seçeneklerini değiştirmez",
      "replaceExistingFile": "Mevcut dosyayı değiştir",
      "replaceExistingFile_other": "Mevcut dosyaları değiştir",
      "keepBothFiles": "Her iki dosyayı da sakla",
      "keepBothFiles_other": "Her iki dosyayı da sakla",
      "newOnly": "Yalnızca yeni dosyaları yükle"
    },
    "filePermanentlyDeleteForm": {
      "title": "{{resource}} kalıcı olarak silin",
      "title_other": "{{count}} dosyayı kalıcı olarak sil",
      "description": "<strong>{{resource}}</strong> öğesini kalıcı olarak silmek istediğinizden emin misiniz? Bu eylem geri alınamaz.",
      "description_other": "<strong>Bu dosyaları</strong> kalıcı olarak silmek istediğinizden emin misiniz? Bu eylem geri alınamaz."
    },
    "fileSellForm": {
      "title": "Dosyayı sat",
      "message": "Dosyayı FileGrant ile sat",
      "uploadPreview": "Önizleme yüklemek için tıklayın veya sürükleyin",
      "uploadPreviewHint": "Kare görsel - En fazla 5MB",
      "removeImage": "Görseli kaldır",
      "pleaseEnterPrice": "Lütfen bir fiyat girin",
      "invalidNumber": "Geçersiz sayı",
      "priceMin": "Fiyat en az €{{amount}} olmalı",
      "allowDownload": "Dosya indirmeye izin ver",
      "removeFromStore": "Mağazadan kaldır",
      "listedSuccess": "Dosya başarıyla satışa çıkarıldı!",
      "purchaseLink": "Satın alma bağlantısı",
      "previewUploadError": "Önizleme yüklenirken hata",
      "imageTooLarge": "Görsel 5MB’den küçük olmalı",
      "unableToReadImage": "Görsel okunamıyor",
      "previewAlt": "Önizleme",
      "mustBeImage": "Dosya bir görsel olmalı",
      "previewImage": "Önizleme görseli"
    },
    "emptyFilesTrash": {
      "title": "Çöp kutusunu boşalt",
      "description": "Çöp kutusunu boşaltmak istediğinizden emin misiniz? Onaylamak için <strong>{{keyword}}</strong> yazın, bu işlem geri alınamaz."
    },
    "settingExceptionsForm": {
      "title": "İstisnaları yönet",
      "description": "Ayarın istisnalarını düzenleyin.",
      "unsavedExceptions": "Kaydedilmemiş istisnalar",
      "currentExceptions": "Mevcut istisnalar"
    },
    "aiSummary": {
      "title": "Yapay Zeka Özeti"
    },
    "aiDocumentChat": {
      "title": "Yapay zekâ doküman sohbeti"
    },
    "sendInvitationToGroupUsers": {
      "title": "Davetiye gönder",
      "description": "Grubun yeni kullanıcılarına özel bir mesaj gönderebilir veya başka bir işlem yapmadan bu iletişim kutusunu kapatabilirsiniz.",
      "success": "Davetiye başarıyla gönderildi",
      "error": "Davetiye gönderilirken hata oluştu",
      "customMessagePlaceholder": "İsteğe bağlı: özel mesaj"
    },
    "sendInvitationToUsers": {
      "title": "Davetiye gönder",
      "description": "{{resource}} adresine özel bir mesaj gönderebilir veya başka bir işlem yapmadan bu iletişim kutusunu kapatabilirsiniz.",
      "description_other": "{{count}} kullanıcıya özel bir mesaj gönderebilir veya başka bir işlem yapmadan bu iletişim kutusunu kapatabilirsiniz.",
      "success": "Davetiye başarıyla gönderildi",
      "error": "Davetiye gönderilirken hata oluştu",
      "customMessagePlaceholder": "İsteğe bağlı: özel mesaj"
    },
    "restoreFileVersion": {
      "title": "Dosya sürümünü geri yükle",
      "description": "<strong>{{resource}}</strong> ürününü <strong>{{version}}</strong> sürümüne geri yüklemek istediğinizden emin misiniz?"
    },
    "fileShareFormUnauthorizedUsers": {
      "title": "Yetkisiz kullanıcılar",
      "descriptionForAllUsers": "Mevcut ayarlar nedeniyle bu kullanıcılarla dosya paylaşamazsınız",
      "descriptionForSomeUsers": "Şu kullanıcılarla dosya paylaşamazsınız: <strong> {{users}} </strong> mevcut ayarlar nedeniyle, ayar tarafından engellenmeyen diğer kullanıcılarla paylaşmak istiyor musunuz?"
    },
    "sessionExpired": {
      "title": "Oturumun süresi doldu",
      "description": "Oturumunuzun süresi doldu. Devam etmek için lütfen tekrar giriş yapın.",
      "redirectMessage": "<strong>{{seconds}}</strong> saniye içinde giriş bilgilerine yönlendirileceksiniz…",
      "goToLoginNow": "Şimdi giriş yap"
    },
    "appUpdated": {
      "title": "Yeni sürüm mevcut",
      "description": "Uygulamanın yeni bir sürümü mevcut. Devam etmek için lütfen sayfayı yeniden yükleyin.",
      "reloadButton": "Yeniden yükle"
    },
    "tooManyRequestsOverlay": {
      "title": "Çok fazla istek",
      "description": "Kısa sürede çok fazla istekte bulundunuz. Tekrar denemeden önce lütfen biraz bekleyin.",
      "redirectMessage": "<strong>{{seconds}}</strong> saniye içinde yeniden deneyebileceksiniz…"
    },
    "activateTotpOverlay": {
      "badge": "Hesap koruması",
      "title": "Dosyalarınız ekstra bir savunma katmanını hak ediyor",
      "description1": "CyberGrant olarak gizli verilerin paha biçilmez olduğunu, daha doğrusu bir bedeli olduğunu ve bu verileri sizden almak isteyenler için çok yüksek olduğunu biliyoruz.",
      "description2": "İki faktörlü kimlik doğrulama (2FA), kimlik bilgileri tehlikeye girse bile yetkisiz erişimi engelleyen ikinci bir doğrulama katmanı ekler.",
      "stat1Value": "%99,9",
      "stat1Label": "2FA ile engellenen otomatik saldırıların oranı",
      "stat2Value": "< 30s",
      "stat2Label": "İlk kurulumu tamamlamak için",
      "featuresTitle": "2FA etkinken",
      "feature1": "Telefonunuz olmadan erişim yok",
      "feature2": "Her şüpheli girişimde anında bildirim",
      "feature3": "NIS2 ve GDPR ile daha güçlü uyum",
      "actionActivate": "2FA'yı şimdi etkinleştirin",
      "actionRemind": "{{count}} gün sonra hatırlat",
      "actionRemind_other": "{{count}} gün sonra hatırlat",
      "actionSkipForever": "Riski kabul ediyorum ve 2FA'yı etkinleştirmek istemiyorum",
      "skipForever": "Sonsuza kadar atla",
      "skipForeverConfirmTitle": "Seçiminizi onaylayın",
      "skipForeverConfirmBody1": "İki faktörlü kimlik doğrulamayı (2FA) etkinleştirmemeyi seçiyorsunuz. 2FA, benimseyebileceğiniz en basit ve en etkili güvenlik önlemidir. Bunu etkinleştirmemek gereksiz ve kolayca önlenebilir bir risktir.",
      "skipForeverConfirmBody2": "İki faktörlü kimlik doğrulamayı (2FA) etkinleştirmeden devam etmek istediğinizden emin misiniz?",
      "skipForeverConfirmEnableNow": "Şimdi etkinleştirin",
      "skipForeverConfirmDecline": "Bunu etkinleştirmek istemiyorum",
      "footer": "2FA'yı istediğiniz zaman hesabınızdaki Güvenlik ayarlarından yönetebilirsiniz.",
      "badgeMandatory": "Eylem gerekli",
      "titleMandatory": "İki faktörlü kimlik doğrulama artık zorunlu",
      "description1Mandatory": "Kuruluşunuz hesabınız için iki faktörlü kimlik doğrulama (2FA) gerektiriyor ve bunu kurmak için tanınan süre doldu. Filegrant'ı kullanmaya devam etmek için şimdi etkinleştirmelisiniz.",
      "footerMandatory": "Bu adım kuruluşunuzun güvenlik politikası tarafından gereklidir ve ertelenemez."
    },
    "openFileLocallyError": {
      "title": "Müşteri bulunamadı",
      "description": "Belgeleri yerel olarak açmak için Remotegrant'ın kurulu olması gerekir. Yüklemek için yöneticiyle iletişime geçin."
    },
    "offline": {
      "title": "Çevrimdışı",
      "description": "Çevrimdışısınız. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.",
      "message": "İnternet bağlantısı bekleniyor..."
    },
    "webAppUpdateAvailable": {
      "title": "Web uygulaması güncellemesi mevcut",
      "description": "Web uygulamasının yeni bir sürümü mevcut. Güncellemek için lütfen sayfayı yenileyin.",
      "okText": "Güncelleme",
      "cancelText": "Daha sonra"
    },
    "keepFilesOfflineError": {
      "title": "Müşteri bulunamadı",
      "description": "Dosyaları bilgisayarınızda tutmak için RemoteGrant aracısının yüklü olması gerekir. Yüklemek için yöneticinizle iletişime geçin."
    },
    "sharingApprovalRequirementReviewTeamForm": {
      "title": "İnceleme Ekibini Yönet",
      "description": "Paylaşım onayı gereksinimi için inceleme ekibini yönetin."
    },
    "tagsRequiredForShare": {
      "title": "Paylaşım için gerekli etiketler",
      "description": "<strong>{{resource}}</strong> dosyası etiketlerin paylaşılmasını gerektiriyor. Lütfen dosyaya etiket ekleyin ve tekrar deneyin.",
      "description_other": "Bu dosyalardan bazıları etiketlerin paylaşılmasını gerektirir. Lütfen dosyalara etiket ekleyin ve tekrar deneyin."
    },
    "tagsRequiredForDownload": {
      "title": "İndirme için gerekli etiketler",
      "description": "<strong>{{resource}}</strong> dosyası, etiketlerin indirilmesini gerektiriyor. Lütfen dosyaya etiket ekleyin ve tekrar deneyin.",
      "description_other": "Bu dosyalardan bazılarının indirilmesi için etiketler gerekir. Lütfen dosyalara etiket ekleyin ve tekrar deneyin."
    },
    "filesWithShortcutsDeleteConfirmation": {
      "title": "Dosyalar Silinsin mi?",
      "description": "<strong>{{resource}}</strong> öğesini silmek istediğinizden emin misiniz? Seçilen dosyaların kısayolları bulundu. Bu dosyayı silerseniz bu kısayollar artık çalışmaz <br /><br />Devam etmek istiyor musunuz?",
      "description_other": "<strong>bu dosyaları</strong> silmek istediğinizden emin misiniz? Seçilen dosyaların kısayolları bulundu. Bu dosyaları silerseniz bu kısayollar artık çalışmayacaktır <br /><br />Devam etmek istiyor musunuz?"
    },
    "officeTokenExpired": {
      "title": "Oturumun süresi doldu",
      "description": "Devam etmek için sayfayı yenileyin"
    },
    "officeEditorBeta": {
      "title": "Yeni FileGrant Office'i denemek ister misiniz?",
      "description": "FileGrant Office beta olarak sunuluyor. Klasik editörü kullanmaya devam edebilir veya bu oturum için yeni deneyimi deneyebilirsiniz.",
      "tryNew": "Yeniyi dene",
      "useClassic": "Klasik kullan"
    },
    "officeEditorDelete": {
      "title": "Çöp kutusuna taşıyıp editörü kapatılsın mı?",
      "description": "Dosya çöp kutusuna taşınacak ve editör kapanacak. Kaydedilmemiş değişiklikler otomatik kaydetme ile yönetilir."
    },
    "applyIsUsedForFileVisibilityTags": {
      "title": "Dosyalara etiket uygulama",
      "description": "Seçilen etiketlerin uygulanması, Etiketli Dosya Görünürlüğü ayarlarına göre bu dosyaları diğer kullanıcılarla otomatik olarak paylaşacaktır.<br /><br />Etkilenen etiketler:<br /><strong>{{resource}}</strong><br /><br />Devam etmek istiyor musunuz?",
      "description_other": "Seçilen etiketlerden bazılarının uygulanması, Etiketli Dosya Görünürlüğü ayarlarına göre bu dosyaları otomatik olarak diğer kullanıcılarla paylaşacaktır.<br /><br />Etkilenen etiketler:<br /><strong>{{resource}}</strong><br /><br />Devam etmek istiyor musunuz?"
    },
    "activeDirectoryUsersImportForm": {
      "importFromActiveDirectory": "Active Directory'den içe aktar",
      "title": "Active Directory'den kullanıcı içe aktar",
      "searchUsers": "Kullanıcı ara...",
      "selectNew": "Yalnızca yenileri seç",
      "existing": "Mevcut",
      "new": "Yeni",
      "importSelected": "İçe aktar ({{count}})",
      "importSuccess": "İçe aktarma tamamlandı: {{created}} oluşturuldu, {{updated}} güncellendi",
      "importError": "İçe aktarma hatası",
      "errorLoadingUsers": "Active Directory kullanıcıları yüklenirken hata",
      "noUsersFound": "Kullanıcı bulunamadı",
      "resultSummary": "Oluşturulan: {{created}}, Güncellenen: {{updated}}, Atlanan: {{skipped}}, Başarısız: {{failed}}",
      "defaultRole": "Varsayılan rol",
      "openSettings": "LDAP ayarlarını aç"
    },
    "activeDirectoryGroupsImportForm": {
      "importFromActiveDirectory": "Active Directory'den içe aktar",
      "title": "Active Directory'den grup içe aktar",
      "searchGroups": "Grup ara...",
      "selectNew": "Yalnızca yenileri seç",
      "existing": "Mevcut",
      "new": "Yeni",
      "importSelected": "İçe aktar ({{count}})",
      "importSuccess": "İçe aktarma tamamlandı: {{created}} oluşturuldu, {{updated}} güncellendi",
      "importError": "İçe aktarma hatası",
      "errorLoadingGroups": "Active Directory grupları yüklenirken hata",
      "noGroupsFound": "Grup bulunamadı",
      "resultSummary": "Oluşturulan: {{created}}, Güncellenen: {{updated}}, Atlanan: {{skipped}}, Başarısız: {{failed}}",
      "defaultRole": "Varsayılan rol",
      "openSettings": "LDAP ayarlarını aç",
      "importMembers": "Üyeleri içe aktar",
      "usersImported": "{{count}} üye de içe aktarıldı",
      "linked": "Bağlı"
    },
    "entraIdFullSync": {
      "menuLabel": "Tam senkronizasyon (Entra ID)",
      "title": "Tam Entra ID senkronizasyonu",
      "syncUsers": "Kullanıcıları senkronize et",
      "syncGroups": "Grupları senkronize et",
      "createMissingUsers": "Eksik kullanıcıları oluştur",
      "createMissingGroups": "Eksik grupları oluştur",
      "updateExisting": "Mevcut olanları güncelle",
      "disableMissingUsers": "Dizinde artık olmayan kullanıcıları devre dışı bırak",
      "disableMissingUsersTitle": "Eksik kullanıcılar devre dışı bırakılsın mı?",
      "disableMissingUsersConfirm": "Bu dizinden içe aktarılan ve artık mevcut olmayan kullanıcılar Filegrant’ta devre dışı bırakılır. Bir yönetici tarafından devre dışı bırakılan kullanıcılar senkronizasyonla yeniden etkinleştirilmez. Devam edilsin mi?",
      "confirmSync": "Senkronize et ve devre dışı bırak",
      "groupFilter": "Grup adı filtresi (isteğe bağlı)",
      "defaultRole": "Yeni kullanıcılar için varsayılan rol",
      "runSync": "Tam senkronizasyonu çalıştır",
      "syncSuccess": "Tam senkronizasyon tamamlandı",
      "syncError": "Tam senkronizasyon başarısız",
      "resultSummary": "Oluşturulan: {{created}}, Güncellenen: {{updated}}, Atlanan: {{skipped}}, Başarısız: {{failed}}"
    },
    "activeDirectoryFullSync": {
      "menuLabel": "Tam senkronizasyon (Active Directory)",
      "title": "Tam Active Directory senkronizasyonu",
      "syncUsers": "Kullanıcıları senkronize et",
      "syncGroups": "Grupları senkronize et",
      "createMissingUsers": "Eksik kullanıcıları oluştur",
      "createMissingGroups": "Eksik grupları oluştur",
      "updateExisting": "Mevcut olanları güncelle",
      "disableMissingUsers": "Dizinde artık olmayan kullanıcıları devre dışı bırak",
      "disableMissingUsersTitle": "Eksik kullanıcılar devre dışı bırakılsın mı?",
      "disableMissingUsersConfirm": "Bu dizinden içe aktarılan ve artık mevcut olmayan kullanıcılar Filegrant’ta devre dışı bırakılır. Bir yönetici tarafından devre dışı bırakılan kullanıcılar senkronizasyonla yeniden etkinleştirilmez. Devam edilsin mi?",
      "confirmSync": "Senkronize et ve devre dışı bırak",
      "groupFilter": "Grup adı filtresi (isteğe bağlı)",
      "defaultRole": "Yeni kullanıcılar için varsayılan rol",
      "runSync": "Tam senkronizasyonu çalıştır",
      "syncSuccess": "Tam senkronizasyon tamamlandı",
      "syncError": "Tam senkronizasyon başarısız",
      "resultSummary": "Oluşturulan: {{created}}, Güncellenen: {{updated}}, Atlanan: {{skipped}}, Başarısız: {{failed}}"
    },
    "directorySync": {
      "usersDisabled": "{{count}} kullanıcı devre dışı bırakıldı",
      "disableThemAnyway": "Yine de devre dışı bırak",
      "suggestFullSync": "İpucu: tam senkronizasyon dizinde yeniden oluşturulan bir grubu yeniden bağlayabilir.",
      "massDisableConfirmTitle": "Toplu devre dışı bırakma onaylansın mı?",
      "massDisableConfirmFallback": "Kullanıcıların büyük bir kısmı devre dışı bırakılacak. Devam etmek için onaylayın."
    },
    "convertToPdf": {
      "title": "PDF'ye Dönüştür",
      "selectDestination": "Hedef klasörü seçin"
    }
  },
  "specialFolders": {
    "FTA27E720F2F2BD4718893095FE4354A4F6": "Hızlı Paylaşım"
  },
  "viewer": {
    "eml": {
      "attachments": "Ekler",
      "cc": "Cc",
      "date": "Tarih",
      "downloadAttachment": "{{name}} dosyasını indir",
      "emptyBody": "Bu iletinin gövde içeriği yok.",
      "from": "Kimden",
      "parseError": "Bu e-posta dosyası ayrıştırılamadı.",
      "showRawSource": "Ham kaynağı göster",
      "subject": "Konu",
      "to": "Kime"
    },
    "ics": {
      "description": "Açıklama",
      "empty": "Bu dosyada takvim etkinliği bulunamadı.",
      "end": "Bitiş",
      "location": "Konum",
      "organizer": "Düzenleyen",
      "parseError": "Bu takvim dosyası ayrıştırılamadı.",
      "showRaw": "Ham kaynağı göster",
      "start": "Başlangıç",
      "untitled": "Başlıksız etkinlik"
    },
    "msg": {
      "attachments": "Ekler",
      "cc": "Cc",
      "date": "Tarih",
      "downloadAttachment": "{{name}} dosyasını indir",
      "emptyBody": "Bu iletinin gövde içeriği yok.",
      "from": "Kimden",
      "parseError": "Bu Outlook iletisi ayrıştırılamadı.",
      "showRawSource": "Ham kaynağı göster",
      "subject": "Konu",
      "to": "Kime"
    },
    "vcf": {
      "email": "E-posta",
      "empty": "Bu dosyada kişi bulunamadı.",
      "note": "Not",
      "organization": "Kuruluş",
      "parseError": "Bu kişi dosyası ayrıştırılamadı.",
      "phone": "Telefon",
      "showRaw": "Ham kaynağı göster",
      "title": "Ünvan",
      "unnamed": "Adsız kişi"
    },
    "htmlPreview": {
      "title": "HTML Önizlemesini Aç",
      "description": "Bu HTML dosyası, potansiyel olarak tehlikeli olabilecek JavaScript kodu içerebilir. Önizleme, güvenlik amacıyla korumalı bir ortamda görüntülenecektir. Devam etmek istiyor musunuz?",
      "button": "HTML'yi önizle",
      "hideButton": "Önizlemeyi Gizle"
    },
    "error": {
      "decryptFailed": {
        "title": "Şifre çözme başarısız oldu",
        "description": "Dosyanın şifresi çözülemiyor. Lütfen tekrar deneyin."
      },
      "officeNoPreview": {
        "title": "Önizleme mevcut değil",
        "description": "Dikkat: Bu orijinal dosyayı indirmeden önce kaynağın güvenilirliğini bir kez daha kontrol edin."
      },
      "blobFetchFailed": {
        "title": "Dosya bulunamadı",
        "description": "Dosya bulunamadı. Lütfen tekrar deneyin."
      },
      "videoPlayback": {
        "title": "Video oynatma hatası",
        "description": "Video oynatılamadı. Sayfayı yeniden yüklemeyi deneyin."
      },
      "videoUnsupported": {
        "title": "Video biçimi desteklenmiyor",
        "description": "Tarayıcınız bu videonun kodunu çözemiyor (örneğin HEVC/H.265 veya 10 bit video). Burada oynatmak için H.264 (MP4) ile kodlanmış bir sürümünü isteyin."
      },
      "fetchFilePermissionsFailed": {
        "title": "Dosya izinleri getirilemedi",
        "description": "Dosya izinleri getirilemedi. Lütfen tekrar deneyin."
      },
      "isFolder": {
        "title": "Dosya bir klasördür",
        "description": "Dosya bir klasördür. Görüntüleyicide açılamaz."
      },
      "fetchFileFailed": {
        "title": "Dosya getirilemedi",
        "description": "Dosya getirilemedi. Lütfen tekrar deneyin."
      },
      "noPreviewAvailable": {
        "title": "Önizleme mevcut değil",
        "description": "Dikkat: Bu orijinal dosyayı indirmeden önce kaynağın güvenilirliğini bir kez daha kontrol edin."
      },
      "noPermissions": {
        "title": "Yetkiniz yok",
        "description": "Bu dosyayı açma izniniz yok."
      }
    },
    "sign": {
      "title": "İmza ekle",
      "add": "İmza ekle",
      "delete": "İmzayı kaldır",
      "pickFolder": "Hedef klasörü seç",
      "saveSignature": "Bu imzayı Dosyalar’a da kaydet",
      "selectFolderHint": "İmzayı kaydetmek istediğiniz klasör yolunu göstermek için bir konum seçin",
      "unavailable": "PDF imzalama mevcut görüntüleyici lisansı ile kullanılamıyor.",
      "success": "İmzalı PDF kaydedildi",
      "error": "İmzalı PDF kaydedilemedi",
      "flattenWarning": "İmza kaydedildikten sonra kaldırılamaz. Kaydetmeden önce emin olun.",
      "modeEnabled": "İmza modu açık",
      "modeDisabled": "İmza modu kapalı",
      "tab": {
        "draw": "Çiz",
        "upload": "Yükle",
        "drive": "Dosyalar’dan"
      },
      "draw": {
        "hint": "İmzanızı kutuya çizin",
        "clear": "Temizle"
      },
      "upload": {
        "dropHint": "Bir görseli buraya bırakın veya gözatmak için tıklayın"
      },
      "replaceOrCopy": {
        "title": "İmzalı PDF’i kaydet",
        "replace": "Orijinali değiştir",
        "replaceHint": "Mevcut PDF’i imzalı sürümle üzerine yaz",
        "copy": "Kopya olarak kaydet",
        "copyHint": "Orijinali koru ve imzalı PDF’i seçtiğin bir klasöre kaydet"
      }
    }
  },
  "store": {
    "fileSalesOverview": "Dosya Satışına Genel Bakış",
    "totalSales": "Satılan Birimler",
    "fileRevenue": "Dosya Geliri",
    "unitRevenue": "Birim Fiyatı",
    "stock": "Stok",
    "openStoreLink": "Mağaza bağlantısını aç",
    "salesDashboard": "Satış kontrol paneli",
    "confirmEmail": "E-postayı onayla",
    "confirmEmailPlaceholder": "E-postanızı onaylayın",
    "emailPlaceholder": "siz@ornek.com",
    "pleaseEnterEmail": "Lütfen e-postanızı girin",
    "pleaseConfirmEmail": "Lütfen e-postanızı onaylayın",
    "emailsDoNotMatch": "İki e-posta eşleşmiyor!",
    "invalidEmail": "E-posta geçerli değil!",
    "payNow": "Şimdi öde",
    "paymentSuccessful": "Ödeme başarılı!",
    "fileAlreadySold": "Dosya bu e-postaya zaten satılmış",
    "emailsMismatch": "E-posta ve onay eşleşmiyor.",
    "invalidEmailFormat": "Geçersiz e-posta biçimi",
    "fileNotFound": "Dosya bulunamadı",
    "filePreview": "Dosya önizlemesi",
    "filePreviewAlt": "Dosya önizlemesi",
    "fileFullPreviewAlt": "Tam dosya önizlemesi",
    "byOwner": "{{name}} tarafından",
    "purchase": "Satın al"
  },
  "dashboard": {
    "title": "Yönetici raporu",
    "tabs": {
      "overview": "Genel bakış"
    },
    "riskIndicators": {
      "title": "Risk Göstergeleri",
      "untaggedFiles": {
        "label": "Etiketsiz Dosyalar",
        "description": "Etiketlerle sınıflandırılmayan dosyaların yüzdesi. Yüksek bir değer, veri sınıflandırma politikalarına uyumsuzluk riskini gösterir."
      },
      "sharingWithoutExpiration": {
        "label": "Süre Sonu Olmadan Paylaşma",
        "description": "Son kullanma tarihi olmayan hisselerin yüzdesi. Kalıcı paylaşımlar zamanla yetkisiz erişim riskini artırır."
      },
      "editorSharing": {
        "label": "Editör İzin Paylaşımı",
        "description": "Düzenleme izinlerine sahip paylaşımların yüzdesi. Yüksek değerler yetkisiz veri değişikliği riskini artırır."
      },
      "externalSharing": {
        "label": "Harici Paylaşım",
        "description": "Harici alan adlarına yapılan paylaşımların yüzdesi. Yüksek değerler hassas veri sızıntısı riskini gösterebilir."
      },
      "excessiveExpiration": {
        "label": "Aşırı Sona Erme",
        "description": "Geçerlilik süresi 90 günü aşan aktif hisselerin yüzdesi. Uzun süreli erişim, uzlaşma riskini artırır."
      },
      "userConcentration": {
        "label": "Kullanıcı Yoğunlaşması",
        "description": "Tek bir kullanıcı tarafından yapılan maksimum paylaşım yüzdesi. Yüksek konsantrasyon, içeriden tehdit veya hesabın ele geçirilmesi riskini gösterir."
      },
      "thresholds": "Eşikler"
    },
    "ssoCoverage": {
      "label": "SSO'suz dahili kullanıcılar",
      "asOfNow": "Şu an itibarıyla",
      "excluded": "SSO'dan hariç tutulanlar",
      "outsideDomains": "SSO kapsamındaki e-posta alanı dışında",
      "description": "SSO yerine e-posta OTP ile giriş yapan etkin dahili kullanıcıların (External hariç tüm roller, süresi dolmamış) güncel anlık görüntüsü. SSO'dan hariç tutma, kapsanmayan alan adına göre önceliklidir. Rapor tarih aralığını takip etmez."
    },
    "riskDetail": {
      "viewDetails": "Detaylar",
      "user": "Kullanıcı",
      "domain": "İhtisas",
      "domains": "Alanlar",
      "shares": "Paylaşımlar",
      "noData": "Bu gösterge için veri mevcut değil",
      "totalUsers": "{{count}} kullanıcıları etkilendi",
      "countLabel": {
        "editorSharing": "Editör Paylaşımları",
        "untaggedFiles": "Etiketsiz Dosyalar",
        "sharingWithoutExpiration": "Son kullanma tarihi olmadan",
        "externalSharing": "Harici Paylaşımlar",
        "excessiveExpiration": "Aşırı Paylaşımlar",
        "userConcentration": "Toplam Paylar"
      }
    },
    "volumeData": {
      "volume": "Hacim",
      "files": "Dosyalar",
      "folders": "Klasörler",
      "total": "Toplam Öğeler"
    },
    "classification": {
      "title": "ETİKET Sınıflandırması",
      "withTag": "ETİKETLİ",
      "withoutTag": "ETİKETSİZ"
    },
    "sharing": {
      "internal": "İç paylaşım",
      "external": "Dış paylaşım",
      "readOnly": "Yalnızca okuma",
      "editor": "Düzenleyici"
    },
    "expiration": {
      "title": "Paylaşımın Sona Ermesi",
      "withExpiration": "son kullanma tarihi olan",
      "withoutExpiration": "süresi dolmadan"
    },
    "expirationAnalysis": {
      "title": "Detaylı Son Kullanma Analizi",
      "count": "Sayı",
      "average": "Ortalama",
      "active": "Etkin",
      "expired": "Süresi dolmuş",
      "min": "Minimum Süre",
      "max": "Maksimum Süre",
      "days": "günler",
      "distribution": {
        "expired": "Süresi dolmuş",
        "expiringSoon": "0-7 gün",
        "shortTerm": "7-30 gün",
        "mediumTerm": "30-90 gün",
        "longTerm": "90-365 gün",
        "excessive": ">365 gün"
      }
    },
    "domains": {
      "title": "Etki alanları",
      "domain": "Etki alanı",
      "type": "Türü",
      "count": "Sayı",
      "distribution": "Dağılım",
      "internal": "İç",
      "external": "Dış",
      "openRecipients": "{{domain}} için paylaşım alıcılarını aç"
    },
    "users": {
      "title": "Kullanıcı İstatistikleri",
      "user": "Kullanıcı",
      "files": "Dosyalar",
      "folders": "Klasörler",
      "total": "Toplam",
      "sharing": "Paylaşım",
      "withSharing": "Paylaşım yapan",
      "withoutSharing": "Paylaşım yapmayan"
    },
    "refresh": "Raporu Yenile",
    "retry": "Yeniden dene",
    "period": "Dönem",
    "apply": "Uygula",
    "lastMonth": "Geçen ay",
    "last3Months": "Son 3 Ay",
    "year": "Yıl",
    "all": "Tüm",
    "cachedData": "Verilerin güncellenme tarihi: {{date}}",
    "internalDomains": "Dahili Etki Alanları",
    "critical": "kritik",
    "warnings": "uyarılar",
    "criticalAlert": "Kritik risk göstergeleri tespit edildi. Acil eylem gerekli.",
    "warningAlert": "Uyarı risk göstergeleri tespit edildi. İnceleme önerilir.",
    "securityIncidents": {
      "title": "Güvenlik olayları ve uyarıları",
      "noData": "Bu dönemde güvenlik olayı veya uyarısı yok",
      "dateTime": "Tarih ve saat",
      "severityColumn": "Önem",
      "category": "Tür",
      "description": "Açıklama",
      "user": "Kullanıcı",
      "ipAddress": "IP adresi",
      "country": "Ülke",
      "viewInActivityLog": "Activity Log'da görüntüle",
      "severityLevels": {
        "critical": "Kritik",
        "error": "Hata",
        "warning": "Uyarı",
        "info": "Bilgi"
      },
      "categories": {
        "loginFailed": "Başarısız giriş",
        "suspiciousAccess": "Şüpheli erişim",
        "policyViolation": "Politika ihlali",
        "permissionDenied": "İzin reddedildi",
        "rateLimitExceeded": "İstek limiti aşıldı",
        "configurationAlert": "Yapılandırma değişikliği",
        "sharingViolation": "Paylaşım ihlali",
        "dataExportAlert": "Veri dışa aktarma"
      }
    },
    "securityAnomalies": {
      "title": "Güvenlik Anomalileri",
      "noData": "Bu dönemde açık güvenlik anomalisi yok",
      "criticalAlert": "{{count}} kritik güvenlik anomalisi dikkat gerektiriyor",
      "criticalAlert_other": "{{count}} kritik güvenlik anomalisi dikkat gerektiriyor",
      "byDetectorTitle": "Türe göre anomaliler",
      "summary": {
        "totalOpen": "Açık anomaliler",
        "critical": "Kritik",
        "warning": "Uyarı",
        "info": "Bilgi"
      },
      "severityColumn": "Önem",
      "type": "Tür",
      "anomaly": "Anomali",
      "events": "Olaylar",
      "lastSeen": "Son görülme",
      "actionsColumn": "İşlemler",
      "handledAt": "İşlenme tarihi",
      "tabs": {
        "open": "Açık",
        "managed": "Yönetilen"
      },
      "actions": {
        "hide": "İşlendi olarak işaretle",
        "restore": "Geri yükle"
      },
      "hideConfirmTitle": "Bu anomali işlendi olarak işaretlensin mi?",
      "hideNotePlaceholder": "İsteğe bağlı not (neden)…",
      "restoreConfirmTitle": "Bu anomali geri yüklensin mi?",
      "hideSuccess": "Anomali işlendi olarak işaretlendi",
      "hideError": "Anomali işlendi olarak işaretlenemedi",
      "restoreSuccess": "Anomali geri yüklendi",
      "restoreError": "Anomali geri yüklenemedi",
      "managedLoadError": "Yönetilen anomaliler yüklenemedi",
      "managedNoData": "Yönetilen anomali yok",
      "severityLevels": {
        "critical": "Kritik",
        "warning": "Uyarı",
        "info": "Bilgi"
      },
      "detectors": {
        "admin_ip_blocked": "Engellenen IP'den admin erişimi",
        "unauthorized_country": "Yetkisiz ülkeden erişim",
        "brute_force_login": "Oturum açma kaba kuvvet saldırısı",
        "password_spray": "Parola püskürtme",
        "folder_password_brute_force": "Klasör parolası kaba kuvvet saldırısı",
        "public_link_brute_force": "Genel bağlantı kaba kuvvet saldırısı",
        "security_signal": "Güvenlik sinyali"
      }
    },
    "activityMap": {
      "title": "Ülkeye göre etkinlik",
      "noData": "Bu dönemde etkinlik konum verisi yok",
      "activities": "{{count}} etkinlik",
      "failedLogins": "{{count}} başarısız giriş",
      "legendLow": "Düşük",
      "legendHigh": "Yüksek",
      "selectedCountry": "{{country}}",
      "hint": "Ayrıntılar için haritada bir ülkeye tıklayın.",
      "viewDetails": "Erişim ayrıntılarını gör",
      "periodNote": "Harita verileri son 90 günü kapsar.",
      "periodRange": "Harita verileri {{from}} - {{to}} arasını kapsar."
    },
    "geoDetail": {
      "title": "Erişim ayrıntıları — {{country}}",
      "totalUsers": "{{count}} kullanıcı",
      "user": "Kullanıcı",
      "activities": "Etkinlikler",
      "failedLogins": "Başarısız girişler",
      "distinctIps": "IP'ler",
      "lastAccess": "Son erişim",
      "anonymous": "Anonim",
      "noData": "Seçili dönemde bu ülke için erişim verisi yok",
      "geoUnavailable": "Coğrafi konum kullanılamıyor"
    },
    "recipients": {
      "title": "Paylaşım alıcıları",
      "domainSubtitle": "Alan adı: {{domain}}",
      "refreshHint": "Verileri yeniden hesapla (en fazla 30 saniyede bir)",
      "topTitle": "Paylaşılan öğelere göre ilk 10 alıcı",
      "noData": "Seçilen dönemde alıcı yok",
      "countingRulesTitle": "Alıcılar nasıl sayılır",
      "countingRules": {
        "active": "Yalnızca etkin paylaşımlar sayılır: süresi dolmuş, beklemede, reddedilmiş, iptal edilmiş veya tükenmiş paylaşımlar ile geri dönüşüm kutusundaki dosyalar hariç tutulur.",
        "direct": "Yalnızca doğrudan paylaşımlar sayılır: paylaşılan bir klasör tek öğedir, içeriği genişletilmez.",
        "group": "Bir grup tek alıcıdır (üyeler bilgi amaçlı gösterilir); tüm genel bağlantılar tek satırdır.",
        "domainCount": "Bu toplamlar, dönemin tüm paylaşımlarını içeren Alıcı Alan Adları sayılarından düşük olabilir."
      },
      "summary": {
        "internalUsers": "İç kullanıcılar",
        "externalUsers": "Dış kullanıcılar",
        "groups": "Gruplar",
        "publicLinks": "Genel bağlantılar",
        "totalShares": "Toplam paylaşım"
      },
      "types": {
        "all": "Tüm türler",
        "internal": "İç",
        "external": "Dış",
        "group": "Grup",
        "public": "Genel"
      },
      "type": "Tür",
      "domain": "Alan adı",
      "domainPlaceholder": "Alan adına göre filtrele",
      "searchPlaceholder": "Ad veya e-posta ara",
      "editorOnly": "Yalnızca düzenleyici paylaşımları",
      "withoutExpirationOnly": "Yalnızca süresiz olanlar",
      "sortBy": "Sırala",
      "sortByValue": "Sırala: {{field}}",
      "sort": {
        "items": "Öğeler",
        "editor": "Düzenleyici paylaşımları",
        "withoutExpiration": "Süresiz",
        "lastShared": "Son paylaşım",
        "owners": "Sahipler",
        "name": "Ad"
      },
      "totalRecipients": "{{count}} alıcı",
      "name": "Ad",
      "email": "E-posta",
      "members": "Üyeler",
      "items": "Öğeler",
      "filesFolders": "{{files}} dosya / {{folders}} klasör",
      "editorShares": "Düzenleyici",
      "withoutExpiration": "Süresiz",
      "withoutPassword": "Parolasız",
      "owners": "Sahipler",
      "lastShared": "Son paylaşım",
      "highestRisk": "En yüksek risk",
      "publicLinks": "Genel bağlantılar",
      "unknown": "Bilinmiyor",
      "itemsTitle": "{{name}} ile paylaşılanlar",
      "totalItems": "{{count}} paylaşılan öğe",
      "noItems": "Seçilen dönemde etkin paylaşım yok",
      "itemName": "Ad",
      "file": "Dosya",
      "folder": "Klasör",
      "size": "Boyut",
      "owner": "Sahip",
      "permission": "İzin",
      "editor": "Düzenleyici",
      "viewer": "Görüntüleyici",
      "expiration": "Son kullanma",
      "never": "Asla",
      "createdAt": "Paylaşım tarihi",
      "canDownload": "İndirme",
      "passwordProtected": "Parola",
      "accesses": "Erişimler",
      "accessCountValue": "{{count}} / {{max}}",
      "unlimited": "Sınırsız",
      "yes": "Evet",
      "no": "Hayır"
    },
    "errors": {
      "accessDenied": "Erişim engellendi",
      "accessDeniedDescription": "Yönetici Raporunu görüntüleme izniniz yok. Bu bölüme yalnızca Yöneticiler erişebilir.",
      "serverError": "Sistem Hatası",
      "serverErrorDescription": "Rapor oluşturulamıyor. Lütfen daha sonra tekrar deneyin.",
      "noData": "Mevcut Veri Yok",
      "pdfExportFailed": "Kontrol paneli PDF olarak dışa aktarılamadı. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.",
      "folderPasswordForm": {
        "title": "Klasör Şifre Koruması"
      },
      "invalidFilter": "Geçersiz filtre: sıfırlandı.",
      "recipientNotFound": "Alıcı bulunamadı. Liste yenilendi."
    }
  },
  "aiClassificationStatus": {
    "none": "Hiçbiri",
    "queued": "Sırada...",
    "classifying": "Sınıflandırılıyor...",
    "done": "Tamamlanmış",
    "error": "Hata",
    "unknown": "Bilinmiyor"
  },
  "webSocketStatus": {
    "idle": "Boşta",
    "connecting": "Bağlanıyor",
    "open": "Açık",
    "closing": "Kapanış",
    "closed": "Kapalı",
    "error": "Hata"
  },
  "fileOfflineStatus": {
    "Pending": "Cihaz senkronizasyonu için sıraya alındı",
    "Downloading": "Cihaza indiriliyor",
    "Downloaded": "Cihazda Senkronize Edildi"
  },
  "file": {
    "antivirus": {
      "pending": "Antivirüs taraması devam ediyor",
      "rescanPending": "Yeniden tarama kuyrukta — dosya engelli kalıyor ({{threatName}})",
      "infected": "Tehdit algılandı: {{threatName}}",
      "error": "Antivirüs bu dosyayı doğrulayamadı",
      "errors": {
        "STREAM_TOO_LARGE": "Antivirüs doğrulamadı — dosya taranamayacak kadar büyük",
        "ENGINE_UNREACHABLE": "Antivirüs motoruna ulaşılamıyor",
        "SCAN_TIMEOUT": "Antivirüs taraması zaman aşımına uğradı",
        "MAX_RETRIES": "Antivirüs taraması birden fazla denemeden sonra başarısız"
      },
      "rescanFailed": "Yeniden tarama başarısız — dosya engelli kalıyor ({{threatName}})",
      "retry": "Taramayı tekrarla",
      "contactAdmin": "Yanlış alarm olduğunu düşünüyorsanız yöneticinize başvurun.",
      "stickyNote": "Yeniden yükleme, sürüm geri yükleme veya Office'te düzenleme bu tehdidi kaldırmaz.",
      "tooLarge": "Antivirüs doğrulamadı — dosya taranamayacak kadar büyük"
    }
  },
  "batch": {
    "status": {
      "all": "Tüm",
      "queued": "Sıraya alındı",
      "processing": "İşleme",
      "completed": "Tamamlanmış",
      "failed": "Arızalı",
      "partiallycompleted": "Kısmen Tamamlandı",
      "cancelled": "İptal edildi"
    },
    "operation": {
      "all": "Tüm Operasyonlar",
      "classification": "Yapay Zeka Sınıflandırması",
      "folderexpansion": "Klasör Genişletme",
      "delete": "Silmek"
    },
    "failedFiles": "{{count}} dosyası başarısız oldu",
    "failedFiles_other": "{{count}} dosya başarısız oldu",
    "eta": "ETA",
    "failedFilesDetail": "Başarısız Dosyalar Ayrıntısı",
    "noFailedFiles": "Başarısız dosya yok",
    "fileCancelled": "Bu dosya için iptal istendi.",
    "fileCancelError": "Dosya iptali istenirken hata oluştu.",
    "fileRetried": "Dosya yeniden denenmek üzere sıraya alındı",
    "fileRetryError": "Dosya yeniden denenirken hata oluştu",
    "cancelAllFailed": "Tüm başarısız partileri iptal et (işlenmekte olanlar değil)",
    "cancelAllFailedConfirmTitle": "Tüm başarısız partiler iptal edilsin mi?",
    "cancelAllFailedConfirmContent": "Yalnızca Durumu Başarısız olan partiler temizlenir. İşlenmekte olan veya kuyruktaki partiler çalışmaya devam eder ve etkilenmez. Bu işlem geri alınamaz."
  },
  "entraId": {
    "importFromEntraId": "Entra ID'den içe aktar",
    "importGroupsTitle": "Microsoft Entra ID'den Grupları İçe Aktarma",
    "importUsersTitle": "Kullanıcıları Microsoft Entra ID'den İçe Aktarın",
    "searchGroups": "Grupları ara...",
    "selectNew": "Yalnızca yeniyi seç",
    "existing": "Mevcut",
    "new": "Yeni",
    "importMembers": "Grup üyelerini de içe aktar",
    "importSelected": "İçe Aktar ({{count}})",
    "importSuccess": "İçe aktarma tamamlandı: {{created}} oluşturuldu, {{updated}} güncellendi",
    "importError": "İçe aktarma sırasında hata",
    "errorLoadingGroups": "Entra ID'den gruplar yüklenirken hata oluştu",
    "errorLoadingUsers": "Entra ID'den kullanıcılar yüklenirken hata oluştu",
    "noGroupsFound": "Grup bulunamadı",
    "noUsersFound": "Kullanıcı bulunamadı",
    "resultSummary": "Oluşturuldu: {{created}}, Güncellendi: {{updated}}, Atlandı: {{skipped}}, Başarısız: {{failed}}",
    "usersImported": "{{count}} üye de içe aktarıldı",
    "permissionErrorTitle": "Yetersiz Azure AD İzinleri",
    "permissionErrorDescription": "Azure AD uygulamasının Microsoft Graph API'sine erişmek için yeterli izinleri yok.",
    "permissionErrorSteps": "Bu sorunu çözmek için:",
    "permissionErrorStep1": "Azure Portal > Uygulama kayıtları > Uygulamanız'a gidin",
    "permissionErrorStep2": "API izinlerine gidin",
    "permissionErrorStep3": "Gerekli Uygulama izinlerini ekleyin (Yetki Verilmemiş)",
    "permissionErrorStep4": "İzinleri yetkilendirmek için \"Yönetici onayı ver\" seçeneğini tıklayın",
    "requiredPermissions": "Gerekli izinler",
    "filterBySync": "Senkronizasyona göre filtrele",
    "syncedWithEntraId": "Entra ID ile senkronize edildi",
    "syncedTooltip": "Microsoft Entra ID ile senkronize edildi",
    "searchUsers": "Kullanıcıları ara...",
    "importUsersSuccess": "İçe aktarma tamamlandı: {{created}} oluşturuldu, {{updated}} güncellendi",
    "usersResultSummary": "Oluşturuldu: {{created}}, Güncellendi: {{updated}}, Atlandı: {{skipped}}, Başarısız: {{failed}}",
    "defaultRole": "Varsayılan rol"
  },
  "continents": {
    "europe": "Avrupa",
    "asia": "Asya",
    "africa": "Afrika",
    "northAmerica": "Kuzey Amerika",
    "southAmerica": "Güney Amerika",
    "oceania": "Okyanusya",
    "antarctica": "Antarktika"
  },
  "components": {
    "countrySelect": {
      "placeholder": "Ülkeleri seçin...",
      "euOption": "Avrupa Birliği (27 ülkenin tamamı)",
      "searchPlaceholder": "Ülkeleri ara..."
    },
    "regionSelect": {
      "placeholder": "Bölgeleri seçin veya ISO kodlarını girin...",
      "euOption": "Avrupa Birliği",
      "searchPlaceholder": "Bölge ara"
    },
    "ipCidrInput": {
      "placeholder": "IP adreslerini veya CIDR aralıklarını virgülle ayırarak girin",
      "helperText": "Örnekler: 192.168.1.100, 10.0.0.0/8, 2001:db8::/32",
      "invalidEntry": "Geçerli bir IP adresi veya CIDR aralığı girin",
      "invalidEntries": "Geçersiz girişler: {{entries}}"
    },
    "ipRegionExceptionForm": {
      "title": "IP/Bölge İstisnalarını Yönet",
      "description": "Belirli kullanıcılara veya gruplara ek erişim kriterleri verin",
      "typeLabel": "İstisna Türü",
      "additionalIpsTitle": "İzin Verilen Ek IP'ler",
      "additionalCountriesTitle": "İzin Verilen Ek Ülkeler",
      "additionalRegionsTitle": "İzin Verilen Ek Bölgeler",
      "expirationTitle": "Son kullanma tarihi",
      "expirationNone": "Sona Erme Tarihi Yok",
      "expirationCustom": "Geçerlilik tarihi:",
      "reasonTitle": "Sebep (denetim için)",
      "reasonPlaceholder": "ör. Londra'ya iş gezisi - Şubat 2026",
      "addException": "İstisna ekle",
      "existingExceptions": "Mevcut istisnalar",
      "fetchError": "İstisnalar alınırken bir hata oluştu. Lütfen tekrar deneyin.",
      "selectAtLeastOne": "En az bir kullanıcı veya grup seçin",
      "atLeastOneCriterion": "En az bir IP adresi, ülke veya bölge ekleyin: kriteri olmayan bir istisna hiçbir şey sağlamaz",
      "alreadyPresent": "Seçilen kullanıcılar veya gruplar bu kısıtlamada zaten bir istisnaya sahip",
      "addAllowedIp": "IP veya CIDR ekle"
    }
  },
  "email": {
    "inbox": "Gelen kutusu",
    "sent": "Gönderilen",
    "favorites": "Favoriler",
    "trash": "Çöp kutusu",
    "drafts": "Taslaklar",
    "noEmails": "Bu klasörde e-posta yok",
    "noEmailsFound": "E-posta bulunamadı",
    "noSubject": "(Konu yok)",
    "searchPlaceholder": "E-postaları arayın",
    "newMessage": "Yeni Mesaj",
    "newEmail": "E-posta",
    "folders": "Klasörler",
    "to": "Kime",
    "from": "Kimden",
    "cc": "Bilgi",
    "bcc": "Gizli",
    "subject": "Konu",
    "date": "Tarih",
    "body": "İçerik",
    "send": "Gönder",
    "sending": "Gönderiliyor...",
    "cancel": "İptal",
    "draftIdle": "Taslak kaydedildi",
    "draftSaveError": "Taslak kaydedilemedi",
    "draftSaved": "Taslak kaydedildi",
    "draftSaving": "Kaydediliyor...",
    "editDraft": "Taslağı düzenle",
    "saveDraft": "Taslağı kaydet",
    "sendError": "E-posta gönderilemedi",
    "errorExternalSharingNotAllowed": "Aşağıdaki alıcılar yetkili değil",
    "errorSharingDenied": "Bu dosyaları paylaşma izniniz yok",
    "errorPartialSharingDenied": "Bazı ekler seçilen alıcılarla paylaşılamaz",
    "errorCannotAccessFiles": "Ekteki dosyalara erişiminiz yok",
    "attachmentReadOnly": "Yalnızca görüntüle",
    "attachmentEditor": "Düzenleyebilir",
    "attachmentExpirationWarning": "Paylaşımın süresi {{days}} gün içinde dolacak",
    "attachmentPermission": "İzin",
    "writeMessage": "Mesajınızı yazın...",
    "attachFiles": "Dosya ekle",
    "attachments": "Ekler",
    "hasAttachments": "Ek içeriyor",
    "addFavorite": "Favorilere ekle",
    "removeFavorite": "Favorilerden kaldır",
    "moveToTrash": "Çöp kutusuna taşı",
    "archive": "Arşiv",
    "archiveAction": "Arşivle",
    "unarchiveAction": "Arşivden çıkar",
    "restore": "Geri yükle",
    "deleteDraft": "Taslağı sil",
    "deleteDraftConfirm": "Bu taslak çöp kutusuna taşınsın mı? Daha sonra Çöp Kutusu'ndan geri yükleyebilirsiniz.",
    "deletePermanently": "Kalıcı olarak sil",
    "bold": "Kalın",
    "italic": "İtalik",
    "underline": "Altı çizili",
    "bulletList": "Madde işareti listesi",
    "fontSmall": "Küçük",
    "fontNormal": "Normal",
    "fontLarge": "Büyük",
    "fontHuge": "Büyük",
    "sendingInProgress": "Gönderim Devam Ediyor",
    "stepPreparing": "İleti teslim için hazırlanıyor",
    "stepValidating": "Alıcılar doğrulanıyor",
    "stepArchiving": "Güvenli depolama için arşivleme",
    "stepDelivering": "Alıcılara teslim ediliyor...",
    "secureDelivery": "Güvenli Teslimat - Kurumsal Korumalı",
    "protect": "Şifreyle koruyun",
    "protectionTitle": "Şifre Koruması",
    "protectionPassword": "Şifre",
    "protectionConfirm": "Şifreyi onayla",
    "protectionHint": "İpucu (isteğe bağlı)",
    "protectionMismatch": "Şifreler eşleşmiyor",
    "protectionWarning": "E-posta içeriği yerel olarak şifrelenecektir. Bu şifreyi kaybederseniz mesaj kurtarılamaz.",
    "protectedMessage": "Bu mesaj bir şifre ile korunmaktadır.",
    "protectedSnippet": "Korumalı mesaj",
    "protectedHintLabel": "İpucu",
    "enterPassword": "Mesajı okumak için şifreyi girin",
    "unlock": "Kilidi aç",
    "wrongPassword": "Yanlış şifre. Lütfen tekrar deneyin.",
    "reply": "Yanıtla",
    "forward": "İlet",
    "forwardedMessage": "İletilen mesaj",
    "forwardExpired": "Orijinal mesajın süresi doldu, yönlendirme iptal edildi.",
    "forwardAttachmentsTitle": "Ekleri ilet",
    "forwardAttachmentsMessage": "Bu mesaj eklentiler içermektedir. İletilen mesaja bunları dahil etmek istiyor musunuz?",
    "forwardWithAttachments": "Ekleri ile",
    "forwardWithoutAttachments": "Ekler olmadan",
    "selectFromFileGrant": "FileGrant'tan seçin",
    "uploadFromDevice": "Cihazdan yükle",
    "selectFiles": "Dosyaları seçin",
    "selectFolderForUpload": "Yükleme klasörünü seçin",
    "filesSelected": "{{count}} dosya seçildi",
    "confirm": "Onayla",
    "expiration": "Son kullanma tarihi",
    "expirationTitle": "Son kullanma tarihi",
    "expirationDescription": "Seçilen tarihten sonra e-postaya artık erişilemeyecek.",
    "expirationPlaceholder": "Son kullanma tarihini ve saatini seçin",
    "expiresOn": "{{date}} tarihinde sona eriyor",
    "expired": "{{date}} tarihinde süresi doldu",
    "selected": "{{count}} seçildi",
    "markAsRead": "Okundu olarak işaretle",
    "markAsUnread": "Okunmadı olarak işaretle",
    "deletePermanentlyConfirm": "{{count}} e-postalarını kalıcı olarak silmek istediğinizden emin misiniz? Bu eylem geri alınamaz.",
    "selectAll": "Tümünü seç",
    "deselectAll": "Tümünün seçimini kaldır",
    "removeAttachment": "Eki kaldır",
    "removeAttachmentConfirm": "Bu eklentiyi kaldırmak istiyor musunuz? Tüm alıcıların erişimi iptal edilecek.",
    "attachmentNotFound": "Ek bulunamadı",
    "featureNotAvailable": "Özellik mevcut değil",
    "removeRecipient": "Alıcıyı kaldır",
    "removeRecipientsConfirm": "{{count}} alıcıyı/alıcıları kaldırmak istiyor musunuz? Artık bu e-postayı göremeyecekler ve eklere erişim iptal edilecek.",
    "emailNotFound": "E-posta bulunamadı",
    "recipientNotFound": "Alıcı bulunamadı",
    "mustKeepOneRecipient": "En az bir alıcı kalmalıdır",
    "replyAll": "Tümünü Yanıtla",
    "activity": "Etkinlik",
    "cannotCreateEmail": "Yeni e-posta oluşturma izniniz yok",
    "blockForward": "İleriyi engelle",
    "blockForwardDescription": "Alıcılar bu e-postayı iletemeyecek",
    "advancedProtection": "Gelişmiş koruma",
    "protectDescription": "Alıcıların bu e-postayı okuyabilmeleri için şifreye ihtiyaçları olacak"
  },
  "aiSummary": {
    "generationInProgress": "Özetin oluşturulması biraz zaman alabilir: bu pencereyi kapatabilirsiniz, hazır olduğunda sizi bilgilendireceğiz.",
    "closeAndNotify": "Kapat, sizi bilgilendireceğiz"
  },
  "imagePreview": {
    "loadFullQuality": "Tam kaliteyi yükle",
    "loadFullQualityTooltip": "Orijinal tam çözünürlüklü görüntüyü yükle (büyük dosya)",
    "loadingFullQuality": "Tam kalite yükleniyor…",
    "openInViewer": "Görüntüleyicide aç"
  },
  "shortcuts": {
    "title": "Klavye kısayolları",
    "then": "sonra",
    "searchLabel": "Klavye kısayollarında ara",
    "searchPlaceholder": "Kısayol ara…",
    "listLabel": "Klavye kısayolları listesi",
    "noResults": "Aramanızla eşleşen kısayol yok.",
    "categories": {
      "app": "Uygulama",
      "create": "Oluştur",
      "file": "Dosyalar",
      "navigation": "Gezinme",
      "selection": "Seçim",
      "view": "Görünüm"
    },
    "app": {
      "focusSearch": "Aramaya odaklan",
      "openShortcutsHelp": "Klavye kısayollarını aç"
    },
    "create": {
      "openMenu": "Oluştur menüsünü aç",
      "folder": "Yeni klasör",
      "uploadFile": "Dosya yükle",
      "uploadFolder": "Klasör yükle",
      "word": "Yeni Word belgesi",
      "excel": "Yeni Excel çalışma sayfası",
      "powerpoint": "Yeni PowerPoint sunumu",
      "note": "Yeni not",
      "secret": "Yeni giriş bilgileri",
      "secretCard": "Yeni ödeme kartı",
      "secretIdentity": "Yeni kimlik",
      "secretSshKey": "Yeni SSH anahtarı",
      "secretCustom": "Yeni özel gizli"
    },
    "file": {
      "open": "Aç",
      "openNewTab": "Yeni sekmede aç",
      "rename": "Yeniden adlandır",
      "share": "Paylaş",
      "move": "Taşı",
      "favorite": "Favorilere ekle",
      "delete": "Kaldır",
      "copyLink": "Bağlantıyı kopyala",
      "createShortcut": "Kısayol oluştur",
      "details": "Ayrıntılar",
      "download": "İndir",
      "publicLink": "Genel bağlantı",
      "setPassword": "Parola ayarla",
      "aiSummary": "YZ özeti",
      "tags": "Etiketleri düzenle"
    },
    "view": {
      "toggleGridList": "Izgara veya liste görünümünü değiştir"
    },
    "nav": {
      "focusSidebar": "Gezinmeye odaklan",
      "focusMain": "Dosya listesine odaklan",
      "focusDetails": "Ayrıntı paneline odaklan",
      "focusUploadDrawer": "Yükleme ilerlemesine odaklan"
    },
    "selection": {
      "selectAll": "Tümünü seç",
      "clear": "Seçimi temizle",
      "toggle": "Seçimi değiştir",
      "moveFocusUp": "Odağı yukarı taşı",
      "moveFocusDown": "Odağı aşağı taşı",
      "moveFocusLeft": "Odağı sola taşı",
      "moveFocusRight": "Odağı sağa taşı",
      "extendUp": "Seçimi yukarı genişlet",
      "extendDown": "Seçimi aşağı genişlet",
      "extendLeft": "Seçimi sola genişlet",
      "extendRight": "Seçimi sağa genişlet"
    }
  },
  "chat": {
    "thinking": {
      "working": "İsteğiniz işleniyor. Birkaç saniye sürebilir."
    },
    "stream": {
      "tools": {
        "routing": "İstek sınıflandırılıyor",
        "rag_search": "Belgelerde aranıyor",
        "filename_search": "Dosya adına göre aranıyor",
        "metadata_search": "Metaveri aranıyor",
        "open_file": "Dosya açılıyor",
        "relevance_assessment": "Alaka değerlendiriliyor",
        "search_refinement": "Arama daraltılıyor",
        "activity_log_search": "Etkinlik günlüğü aranıyor",
        "calculator": "Hesaplanıyor",
        "chart_generation": "Grafik oluşturuluyor",
        "aggregation": "Sonuçlar toplanıyor",
        "answer_generation": "Yanıt yazılıyor",
        "paused": "Kuyrukta bekleniyor",
        "unknown": "Çalışılıyor"
      },
      "descriptions": {
        "routing": {
          "start": "Ne istediğiniz anlaşılıyor…",
          "done": "İstek sınıflandırıldı{{intentDetail}}."
        },
        "rag_search": {
          "start": "Belgelerinizde aranıyor{{queryDetail}}…",
          "done": "Kitaplığınızda eşleşen bölümler bulundu{{countDetail}}."
        },
        "filename_search": {
          "start": "Dosyalar ada göre taranıyor{{patternDetail}}…",
          "done": "Ada göre eşleşen dosyalar bulundu{{countDetail}}."
        },
        "metadata_search": {
          "start": "Etiketler, tarihler ve diğer özellikler inceleniyor…",
          "done": "Belge özellikleri kontrol edildi{{countDetail}}."
        },
        "open_file": {
          "start": "Seçilen belge okunuyor{{filenameDetail}}…",
          "done": "Belge içeriği kullanıma hazır{{filenameDetail}}."
        },
        "relevance_assessment": {
          "start": "Hangi sonuçların soruya daha iyi uyduğu tartılıyor{{candidateCountDetail}}…",
          "done": "En güçlü eşleşmeler tutuldu{{countDetail}}."
        },
        "search_refinement": {
          "start": "Daha iyi sonuçlar için sorgu daraltılıyor{{queryDetail}}…",
          "done": "Arama ölçütleri güncellendi."
        },
        "activity_log_search": {
          "start": "Kim ne yaptı, ne zaman kontrol ediliyor{{queryDetail}}…",
          "done": "Eşleşen etkinlik kayıtları alındı{{countDetail}}."
        },
        "calculator": {
          "start": "Sayılar hesaplanıyor{{expressionDetail}}…",
          "done": "Sayılar hazır{{expressionDetail}}."
        },
        "chart_generation": {
          "start": "Veriler görsele dönüştürülüyor…",
          "done": "Grafik gösterime hazır."
        },
        "aggregation": {
          "start": "Eşleşmeler tek kümede birleştiriliyor…",
          "done": "Birleşik sonuçlar hazır{{countDetail}}."
        },
        "answer_generation": {
          "start": "Yanıtınız hazırlanıyor…",
          "done": "Yanıt hazır."
        },
        "paused": {
          "start": "GPU meşgul — sıranız kuyrukta{{reasonDetail}}…",
          "done": "Devam — isteğiniz sürdürülüyor."
        },
        "unknown": {
          "start": "Bu adım üzerinde çalışılıyor…",
          "done": "Bu adım tamamlandı."
        }
      },
      "param": {
        "query": ": «{{query}}»",
        "pattern": ": «{{pattern}}»",
        "filename": " «{{filename}}»",
        "expression": " ({{expression}})",
        "count": " ({{count}})",
        "candidateCount": " ({{count}} aday)",
        "reason": " — {{reason}}",
        "intent": ": «{{intent}}»"
      },
      "reasons": {
        "gpu_overload": "GPU aşırı yükü"
      },
      "toolsUsed": "Kullanılan araçlar ({{count}})"
    },
    "disclaimer": "AIGrant hata yapabilir. Önemli bilgileri kontrol edin.",
    "offlineHint": "Gerçek zamanlı bağlantı yok. Sohbetlere bakabilirsiniz; çevrimiçi olunca gönderin.",
    "offlineDisclaimer": "Çevrimdışı: bağlantı yeniden kurulduğunda mesaj gönderebilirsiniz.",
    "connectingHint": "Gerçek zamanlı bağlantı kuruluyor. Hazır olunca gönderebilirsiniz.",
    "connectingDisclaimer": "Bağlanıyor: bağlantı hazır olduğunda mesaj gönderebilirsiniz.",
    "placeholder": "Mesajınızı yazın... (Göndermek için Enter, yeni satır için Shift+Enter)",
    "dictate": "Dikte et",
    "stopDictation": "Dikteyi durdur",
    "speechUnsupported": "Bu tarayıcıda konuşma tanıma desteklenmiyor",
    "dictationFailed": "Dikte başlatılamadı",
    "regenerate": "Yeniden oluştur",
    "readAloud": "Sesli oku",
    "stopReading": "Okumayı durdur",
    "speechUnavailable": "Konuşma sentezi kullanılamıyor",
    "requestCancelled": "İstek iptal edildi",
    "genericError": "İsteğiniz işlenirken bir hata oluştu.",
    "gpuBusyBody": "Sistem geçici olarak aşırı yüklü. Lütfen biraz sonra tekrar deneyin.",
    "gpuBusyRetrying": "Sistem meşgul — bir kez yeniden deneniyor…",
    "responseTimeout": "İstek azami süre (10 dakika) içinde tamamlanamadı. Lütfen daha sonra tekrar deneyin veya sorun devam ederse destek ile iletişime geçin.",
    "jumpToLatest": "En sona git"
  },
  "sharePointStatus": {
    "menuLabel": "SharePoint",
    "title": "SharePoint durumu",
    "openConfiguration": "Yapılandır",
    "refreshHint": "Durumu kiracınızdan canlı olarak okur. Az kullanın.",
    "never": "Hiç",
    "notAvailableTitle": "Lisansınıza dahil değil",
    "notAvailable": "SharePoint entegrasyonu lisansınıza dahil değildir. Etkinleştirmek için destek ekibine başvurun.",
    "loadFailedTitle": "Durum yüklenemedi",
    "loadFailed": "Entegrasyonun durumu okunurken bir hata oluştu.",
    "verdict": {
      "encrypting": "Kapsamdaki dosyalar şifreleniyor",
      "notEncrypting": "Hiçbir şey şifrelenmiyor"
    },
    "unmatched": {
      "title": "Kapsamdaki bazı siteler kiracınızda bulunmuyor",
      "body": "Eşleştirme birebirdir, bu nedenle adı değiştirilmiş veya silinmiş bir site artık eşleşmez. Bu sitelerin dosyaları incelenmiyor ve şifrelenmiyor:",
      "allMissingTitle": "Kapsamdaki hiçbir site kiracınızda bulunmuyor",
      "allMissingBody": "Hiçbir şey izlenmiyor. Bu sitelerin hiçbiri bulunamadı:",
      "repickAction": "Bu siteleri yeniden seç"
    },
    "blocking": {
      "notConfiguredTitle": "Entegrasyon yapılandırılmadı",
      "notConfigured": "Kayıtlı kimlik bilgisi yok, bu nedenle hiçbir şey olmuyor.",
      "configInvalid": "Kaydedilmiş yapılandırma, taramanın çalıştırdığı aynı doğrulama tarafından reddedildi, bu nedenle hiçbir şey olmuyor.",
      "workerDisabledTitle": "Tarama bu kurulumda etkin değil",
      "workerDisabled": "Tarama hizmeti bu dağıtımda kayıtlı değil, bu nedenle hiçbir şey incelenmeyecek. Bunu siz değiştiremezsiniz: destek ekibine başvurun.",
      "noCertificateTitle": "Hiçbir şifreleme sertifikası seçilmedi",
      "noCertificate": "Hiçbir RemoteGrant sertifikası seçilmedi, bu nedenle anahtar yok ve hiçbir şey şifrelenmeyecek.",
      "certificateUnusableTitle": "Şifreleme sertifikası artık kullanılamıyor",
      "certificateUnusable": "Şifrelemeyi sürdürmek için sertifikayı yeniden seçip kaydedin. RemoteGrant’ta silinmiş, anahtarı değiştirilmiş veya RemoteGrant erişilemez durumda olabilir.",
      "noKeyWhileArmed": "Discovery modu kapalı, bu nedenle yapılandırma etkin görünürken hiçbir şey şifrelenmiyor.",
      "emptyPerimeterTitle": "Kapsam boş",
      "emptyPerimeter": "Kapsamdaki hiçbir site kiracınızda çözümlenmiyor, bu nedenle hiçbir şey izlenmiyor."
    },
    "certificate": {
      "label": "Şifreleme sertifikası",
      "none": "Seçili değil",
      "unnamed": "{{id}} numaralı sertifika",
      "repickAction": "Sertifikayı yeniden seç"
    },
    "perimeterUnresolvedTitle": "Kapsam kiracınıza karşı denetlenemedi",
    "perimeterUnresolvedBody": "Aşağıdaki sayaçlar hâlâ geçerli, ancak izlenen siteler ve klasörler şu anda okunamadı. Bu, kapsamın boş olduğu anlamına gelmez.",
    "perimeterError": {
      "unauthorized": "Microsoft Graph kimlik bilgilerini reddetti: istemci parolasının süresi dolmuş olabilir veya uygulama izinlerinde yönetici onayı eksik olabilir.",
      "unavailable": "Microsoft Graph geçici olarak erişilemiyor.",
      "siteNotFound": "Kapsamdaki bir site artık bu kimlik bilgileriyle görünmüyor.",
      "generic": "Kiracıya ulaşılamadı."
    },
    "countersTitle": "Tarama etkinliği",
    "pendingInQueue": "İşlenmeyi bekleyen dosyalar",
    "totalFilesEncrypted": "Şu ana kadar şifrelenen dosyalar",
    "scanInterval": "Kapsam denetimi",
    "everyNMinutes": "Her {{minutes}} dakikada",
    "lastEncryptedAt": "Son şifrelenen dosya",
    "lastDeltaAdvancedAt": "Son tarama döngüsü",
    "lastVerifiedAt": "Kimlik bilgilerinin son doğrulaması",
    "verifyOk": "Başarılı",
    "verifyKo": "Reddedildi",
    "perimeterTitle": "İzlenen kapsam",
    "perimeterUnknown": "Kapsam şu anda kiracınızdan okunamadı.",
    "perimeterEmpty": "Hiçbir site izlenmiyor.",
    "crossLibraryCaveat": "Aşağıdaki her klasör, yalnızca seçildiği kitaplığın değil, sitesindeki tüm belge kitaplıklarının köküyle eşleştirilir.",
    "wholeSiteTag": "Tüm site",
    "wholeSiteBody": "Klasör filtresi yok: bu sitedeki tüm dosyalar kapsamdadır.",
    "allFileTypes": "Tüm dosya türleri",
    "filteredFileTypes": "Yalnızca: {{extensions}}",
    "notAllowedTitle": "Bu sayfayı görme izniniz yok",
    "notAllowed": "SharePoint entegrasyonunu yönetme izniniz yok. Bu ayara erişim için bir SuperAdmin'e başvurun.",
    "box": {
      "active": "Etkin",
      "dryRunDiscovery": "Discovery",
      "dryRunEncryption": "Şifreleme",
      "dryRunLabel": "Mod",
      "dryRunOffCaption": "Eşleşen dosyalar yerinde şifrelenir, geri dönüşü yoktur.",
      "dryRunOnCaption": "Kapsam yalnızca incelenir: hiçbir şey geri yazılmaz.",
      "inactive": "Etkin değil",
      "off": "Kapalı",
      "on": "Açık",
      "scanLabel": "Tarama"
    },
    "issuesTitle": "Dikkatinizi gerektiren koşullar"
  },
  "sharePoint": {
    "editor": {
      "error": {
        "disabled": {
          "description": "SharePoint entegrasyonu bu kurulumda etkin değil.",
          "title": "Entegrasyon kullanılamıyor"
        },
        "forbidden": {
          "description": "Bu dosyayı SharePoint üzerinde açma izniniz yok.",
          "title": "Erişim reddedildi"
        },
        "generic": {
          "description": "Dosya düzenleyicide açılamadı. Yeniden deneyin veya görüntüleyicide açın.",
          "title": "Düzenleyici açılamıyor"
        },
        "notProtected": {
          "description": "Bu dosya FileGrant tarafından şifrelenmemiş; doğrudan SharePoint üzerinde Office ile açılır.",
          "title": "Burada açılacak bir şey yok"
        },
        "tooLarge": {
          "description": "Dosya, düzenleme boyut sınırını aşıyor. Yine de görüntüleyicide açabilirsiniz.",
          "title": "Dosya düzenlemek için çok büyük"
        },
        "unsupported": {
          "description": "Bu biçim çevrimiçi düzenlenemez. Yine de görüntüleyicide açabilirsiniz.",
          "title": "Biçim düzenlenebilir değil"
        }
      },
      "loading": "Dosya düzenleyicide açılıyor…",
      "readOnly": {
        "description": "SharePoint bu dosyayı değiştirme izni vermedi veya kaydı şifrelemek için kullanılabilir bir sertifika yok. Dosyayı okuyabilirsiniz, ancak kaydedemezsiniz.",
        "title": "Salt okunur belge"
      },
      "signIn": {
        "button": "Dosyayı düzenlemek için oturum açın",
        "description": "Bu dosyayı düzenlemek için Microsoft hesabınızla oturum açın. Düzenleme, SharePoint üzerindeki dosyaları değiştirme izni gerektirir; bunu bir yöneticinin onaylaması gerekebilir.",
        "failed": "Oturum açma tamamlanmadı. Tarayıcının açılır pencereleri engellemediğinden emin olun ve yeniden deneyin.",
        "title": "Oturum açma gerekli"
      }
    },
    "signIn": {
      "failed": {
        "description": "Microsoft oturum açma yapılandırması yüklenemedi. Sayfayı yenileyin veya birkaç dakika sonra yeniden deneyin.",
        "title": "Oturum açma kullanılamıyor"
      },
      "loading": "Microsoft oturum açma hazırlanıyor…",
      "notConfigured": {
        "description": "Dosya açılamıyor: bir yönetici, tarayıcının oturum açtığı Microsoft uygulama kaydını yapılandırmadı. SharePoint tümleştirme ayarını tamamlamasını isteyin.",
        "title": "Oturum açma yapılandırılmadı"
      }
    },
    "viewer": {
      "edit": "Düzenle",
      "error": {
        "authFailed": {
          "description": "SharePoint dosyalarınızı okuma izni alınamadı. Yeniden oturum açın veya bir yöneticiden FileGrant erişimini onaylamasını isteyin.",
          "title": "Oturum açmanız gerekiyor"
        },
        "disabled": {
          "description": "SharePoint tümleştirmesi bu kurulumda etkin değil.",
          "title": "Tümleştirme kullanılamıyor"
        },
        "forbidden": {
          "description": "Bu dosyayı SharePoint'te açma izniniz yok.",
          "title": "Erişim reddedildi"
        },
        "generic": {
          "description": "Dosya SharePoint'ten açılamadı. Tekrar deneyin.",
          "title": "Dosya açılamıyor"
        },
        "invalidLink": {
          "description": "Bu SharePoint bağlantısı geçerli değil. Dosyayı SharePoint'ten yeniden açın.",
          "title": "Geçersiz bağlantı"
        },
        "notFound": {
          "description": "Dosya bulunamadı: taşınmış veya silinmiş olabilir.",
          "title": "Dosya bulunamadı"
        },
        "reopen": {
          "description": "Bu dosyayı açma izni sona erdi veya dosya bu arada değişti. Dosyayı SharePoint'ten yeniden açın.",
          "title": "Dosyayı yeniden açın"
        },
        "tooLarge": {
          "description": "Bu dosya SharePoint görüntüleyicisinin boyut sınırını aşıyor.",
          "title": "Dosya çok büyük"
        }
      },
      "loading": "Dosya SharePoint'ten okunuyor…",
      "signIn": {
        "button": "Dosyayı açmak için oturum açın",
        "description": "Bu dosyayı açmak için Microsoft hesabınızla oturum açın. Yalnızca okuma izniniz varsa şifresi çözülür.",
        "failed": "Oturum açma tamamlanmadı. Tarayıcının açılır pencereleri engellemediğini doğrulayın ve yeniden deneyin.",
        "title": "Oturum açma gerekli"
      },
      "source": "SharePoint'ten"
    }
  },
  "activeDirectory": {
    "syncedWithActiveDirectory": "Active Directory ile senkronize"
  }
}
